/* eslint-disable */
/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

'use strict';
(function () {
    var $global, $module;
    if (
        ((Error.stackTraceLimit = 1 / 0),
        'undefined' != typeof window
            ? ($global = window)
            : 'undefined' != typeof self
              ? ($global = self)
              : 'undefined' != typeof global
                ? (($global = global).require = require)
                : ($global = this),
        void 0 === $global || void 0 === $global.Array)
    )
        throw new Error('no global object found');
    'undefined' != typeof module && ($module = module);
    var $throwRuntimeError,
        $packages = {},
        $idCounter = 0,
        $keys = function (e) {
            return e ? Object.keys(e) : [];
        },
        $flushConsole = function () {},
        $throwNilPointerError = function () {
            $throwRuntimeError('invalid memory address or nil pointer dereference');
        },
        $call = function (e, n, r) {
            return e.apply(n, r);
        },
        $makeFunc = function (e) {
            return function () {
                return $externalize(
                    e(
                        this,
                        new ($sliceType($jsObjectPtr))(
                            $global.Array.prototype.slice.call(arguments, [])
                        )
                    ),
                    $emptyInterface
                );
            };
        },
        $unused = function (e) {},
        $mapArray = function (e, n) {
            for (var r = new e.constructor(e.length), t = 0; t < e.length; t++)
                r[t] = n(e[t]);
            return r;
        },
        $methodVal = function (e, n) {
            var r = e.$methodVals || {};
            e.$methodVals = r;
            var t = r[n];
            if (void 0 !== t) return t;
            var i = e[n];
            return (
                (t = function () {
                    $stackDepthOffset--;
                    try {
                        return i.apply(e, arguments);
                    } finally {
                        $stackDepthOffset++;
                    }
                }),
                (r[n] = t),
                t
            );
        },
        $methodExpr = function (e, n) {
            var r = e.prototype[n];
            return (
                void 0 === r.$expr &&
                    (r.$expr = function () {
                        $stackDepthOffset--;
                        try {
                            return (
                                e.wrapped && (arguments[0] = new e(arguments[0])),
                                Function.call.apply(r, arguments)
                            );
                        } finally {
                            $stackDepthOffset++;
                        }
                    }),
                r.$expr
            );
        },
        $ifaceMethodExprs = {},
        $ifaceMethodExpr = function (e) {
            var n = $ifaceMethodExprs['$' + e];
            return (
                void 0 === n &&
                    (n = $ifaceMethodExprs['$' + e] =
                        function () {
                            $stackDepthOffset--;
                            try {
                                return Function.call.apply(arguments[0][e], arguments);
                            } finally {
                                $stackDepthOffset++;
                            }
                        }),
                n
            );
        },
        $subslice = function (e, n, r, t) {
            void 0 === r && (r = e.$length),
                void 0 === t && (t = e.$capacity),
                (n < 0 || r < n || t < r || r > e.$capacity || t > e.$capacity) &&
                    $throwRuntimeError('slice bounds out of range');
            var i = new e.constructor(e.$array);
            return (
                (i.$offset = e.$offset + n), (i.$length = r - n), (i.$capacity = t - n), i
            );
        },
        $substring = function (e, n, r) {
            return (
                (n < 0 || r < n || r > e.length) &&
                    $throwRuntimeError('slice bounds out of range'),
                e.substring(n, r)
            );
        },
        $sliceToArray = function (e) {
            return e.$array.constructor !== Array
                ? e.$array.subarray(e.$offset, e.$offset + e.$length)
                : e.$array.slice(e.$offset, e.$offset + e.$length);
        },
        $decodeRune = function (e, n) {
            var r = e.charCodeAt(n);
            if (r < 128) return [r, 1];
            if (r != r || r < 192) return [65533, 1];
            var t = e.charCodeAt(n + 1);
            if (t != t || t < 128 || 192 <= t) return [65533, 1];
            if (r < 224)
                return (a = ((31 & r) << 6) | (63 & t)) <= 127 ? [65533, 1] : [a, 2];
            var i = e.charCodeAt(n + 2);
            if (i != i || i < 128 || 192 <= i) return [65533, 1];
            if (r < 240)
                return (a = ((15 & r) << 12) | ((63 & t) << 6) | (63 & i)) <= 2047
                    ? [65533, 1]
                    : 55296 <= a && a <= 57343
                      ? [65533, 1]
                      : [a, 3];
            var a,
                o = e.charCodeAt(n + 3);
            return o != o || o < 128 || 192 <= o
                ? [65533, 1]
                : r < 248
                  ? (a =
                        ((7 & r) << 18) |
                        ((63 & t) << 12) |
                        ((63 & i) << 6) |
                        (63 & o)) <= 65535 || 1114111 < a
                      ? [65533, 1]
                      : [a, 4]
                  : [65533, 1];
        },
        $encodeRune = function (e) {
            return (
                (e < 0 || e > 1114111 || (55296 <= e && e <= 57343)) && (e = 65533),
                e <= 127
                    ? String.fromCharCode(e)
                    : e <= 2047
                      ? String.fromCharCode(192 | (e >> 6), 128 | (63 & e))
                      : e <= 65535
                        ? String.fromCharCode(
                              224 | (e >> 12),
                              128 | ((e >> 6) & 63),
                              128 | (63 & e)
                          )
                        : String.fromCharCode(
                              240 | (e >> 18),
                              128 | ((e >> 12) & 63),
                              128 | ((e >> 6) & 63),
                              128 | (63 & e)
                          )
            );
        },
        $stringToBytes = function (e) {
            for (var n = new Uint8Array(e.length), r = 0; r < e.length; r++)
                n[r] = e.charCodeAt(r);
            return n;
        },
        $bytesToString = function (e) {
            if (0 === e.$length) return '';
            for (var n = '', r = 0; r < e.$length; r += 1e4)
                n += String.fromCharCode.apply(
                    void 0,
                    e.$array.subarray(
                        e.$offset + r,
                        e.$offset + Math.min(e.$length, r + 1e4)
                    )
                );
            return n;
        },
        $stringToRunes = function (e) {
            for (
                var n, r = new Int32Array(e.length), t = 0, i = 0;
                i < e.length;
                i += n[1], t++
            )
                (n = $decodeRune(e, i)), (r[t] = n[0]);
            return r.subarray(0, t);
        },
        $runesToString = function (e) {
            if (0 === e.$length) return '';
            for (var n = '', r = 0; r < e.$length; r++)
                n += $encodeRune(e.$array[e.$offset + r]);
            return n;
        },
        $copyString = function (e, n) {
            for (var r = Math.min(n.length, e.$length), t = 0; t < r; t++)
                e.$array[e.$offset + t] = n.charCodeAt(t);
            return r;
        },
        $copySlice = function (e, n) {
            var r = Math.min(n.$length, e.$length);
            return (
                $copyArray(
                    e.$array,
                    n.$array,
                    e.$offset,
                    n.$offset,
                    r,
                    e.constructor.elem
                ),
                r
            );
        },
        $copyArray = function (e, n, r, t, i, a) {
            if (0 !== i && (e !== n || r !== t))
                if (n.subarray) e.set(n.subarray(t, t + i), r);
                else {
                    switch (a.kind) {
                        case $kindArray:
                        case $kindStruct:
                            if (e === n && r > t) {
                                for (var o = i - 1; o >= 0; o--)
                                    a.copy(e[r + o], n[t + o]);
                                return;
                            }
                            for (o = 0; o < i; o++) a.copy(e[r + o], n[t + o]);
                            return;
                    }
                    if (e === n && r > t)
                        for (o = i - 1; o >= 0; o--) e[r + o] = n[t + o];
                    else for (o = 0; o < i; o++) e[r + o] = n[t + o];
                }
        },
        $clone = function (e, n) {
            var r = n.zero();
            return n.copy(r, e), r;
        },
        $pointerOfStructConversion = function (e, n) {
            void 0 === e.$proxies &&
                ((e.$proxies = {}), (e.$proxies[e.constructor.string] = e));
            var r = e.$proxies[n.string];
            if (void 0 === r) {
                for (var t = {}, i = 0; i < n.elem.fields.length; i++)
                    !(function (n) {
                        t[n] = {
                            get: function () {
                                return e[n];
                            },
                            set: function (r) {
                                e[n] = r;
                            },
                        };
                    })(n.elem.fields[i].prop);
                ((r = Object.create(n.prototype, t)).$val = r),
                    (e.$proxies[n.string] = r),
                    (r.$proxies = e.$proxies);
            }
            return r;
        },
        $append = function (e) {
            return $internalAppend(e, arguments, 1, arguments.length - 1);
        },
        $appendSlice = function (e, n) {
            if (n.constructor === String) {
                var r = $stringToBytes(n);
                return $internalAppend(e, r, 0, r.length);
            }
            return $internalAppend(e, n.$array, n.$offset, n.$length);
        },
        $internalAppend = function (e, n, r, t) {
            if (0 === t) return e;
            var i = e.$array,
                a = e.$offset,
                o = e.$length + t,
                $ = e.$capacity;
            if (o > $)
                if (
                    ((a = 0),
                    ($ = Math.max(
                        o,
                        e.$capacity < 1024
                            ? 2 * e.$capacity
                            : Math.floor((5 * e.$capacity) / 4)
                    )),
                    e.$array.constructor === Array)
                ) {
                    (i = e.$array.slice(e.$offset, e.$offset + e.$length)).length = $;
                    for (var c = e.constructor.elem.zero, u = e.$length; u < $; u++)
                        i[u] = c();
                } else
                    (i = new e.$array.constructor($)).set(
                        e.$array.subarray(e.$offset, e.$offset + e.$length)
                    );
            $copyArray(i, n, a + e.$length, r, t, e.constructor.elem);
            var l = new e.constructor(i);
            return (l.$offset = a), (l.$length = o), (l.$capacity = $), l;
        },
        $equal = function (e, n, r) {
            if (r === $jsObjectPtr) return e === n;
            switch (r.kind) {
                case $kindComplex64:
                case $kindComplex128:
                    return e.$real === n.$real && e.$imag === n.$imag;
                case $kindInt64:
                case $kindUint64:
                    return e.$high === n.$high && e.$low === n.$low;
                case $kindArray:
                    if (e.length !== n.length) return !1;
                    for (var t = 0; t < e.length; t++)
                        if (!$equal(e[t], n[t], r.elem)) return !1;
                    return !0;
                case $kindStruct:
                    for (t = 0; t < r.fields.length; t++) {
                        var i = r.fields[t];
                        if (!$equal(e[i.prop], n[i.prop], i.typ)) return !1;
                    }
                    return !0;
                case $kindInterface:
                    return $interfaceIsEqual(e, n);
                default:
                    return e === n;
            }
        },
        $interfaceIsEqual = function (e, n) {
            return e === $ifaceNil || n === $ifaceNil
                ? e === n
                : e.constructor === n.constructor &&
                      (e.constructor === $jsObjectPtr
                          ? e.object === n.object
                          : (e.constructor.comparable ||
                                $throwRuntimeError(
                                    'comparing uncomparable type ' + e.constructor.string
                                ),
                            $equal(e.$val, n.$val, e.constructor)));
        },
        $min = Math.min,
        $mod = function (e, n) {
            return e % n;
        },
        $parseInt = parseInt,
        $parseFloat = function (e) {
            return void 0 !== e && null !== e && e.constructor === Number
                ? e
                : parseFloat(e);
        },
        $froundBuf = new Float32Array(1),
        $fround =
            Math.fround ||
            function (e) {
                return ($froundBuf[0] = e), $froundBuf[0];
            },
        $imul =
            Math.imul ||
            function (e, n) {
                var r = 65535 & e,
                    t = 65535 & n;
                return (
                    (r * t +
                        (((((e >>> 16) & 65535) * t + r * ((n >>> 16) & 65535)) << 16) >>>
                            0)) >>
                    0
                );
            },
        $floatKey = function (e) {
            return e != e ? 'NaN$' + ++$idCounter : String(e);
        },
        $flatten64 = function (e) {
            return 4294967296 * e.$high + e.$low;
        },
        $shiftLeft64 = function (e, n) {
            return 0 === n
                ? e
                : n < 32
                  ? new e.constructor(
                        (e.$high << n) | (e.$low >>> (32 - n)),
                        (e.$low << n) >>> 0
                    )
                  : n < 64
                    ? new e.constructor(e.$low << (n - 32), 0)
                    : new e.constructor(0, 0);
        },
        $shiftRightInt64 = function (e, n) {
            return 0 === n
                ? e
                : n < 32
                  ? new e.constructor(
                        e.$high >> n,
                        ((e.$low >>> n) | (e.$high << (32 - n))) >>> 0
                    )
                  : n < 64
                    ? new e.constructor(e.$high >> 31, (e.$high >> (n - 32)) >>> 0)
                    : e.$high < 0
                      ? new e.constructor(-1, 4294967295)
                      : new e.constructor(0, 0);
        },
        $shiftRightUint64 = function (e, n) {
            return 0 === n
                ? e
                : n < 32
                  ? new e.constructor(
                        e.$high >>> n,
                        ((e.$low >>> n) | (e.$high << (32 - n))) >>> 0
                    )
                  : n < 64
                    ? new e.constructor(0, e.$high >>> (n - 32))
                    : new e.constructor(0, 0);
        },
        $mul64 = function (e, n) {
            var r = 0,
                t = 0;
            0 != (1 & n.$low) && ((r = e.$high), (t = e.$low));
            for (var i = 1; i < 32; i++)
                0 != (n.$low & (1 << i)) &&
                    ((r += (e.$high << i) | (e.$low >>> (32 - i))),
                    (t += (e.$low << i) >>> 0));
            for (i = 0; i < 32; i++) 0 != (n.$high & (1 << i)) && (r += e.$low << i);
            return new e.constructor(r, t);
        },
        $div64 = function (e, n, r) {
            0 === n.$high && 0 === n.$low && $throwRuntimeError('integer divide by zero');
            var t = 1,
                i = 1,
                a = e.$high,
                o = e.$low;
            a < 0 &&
                ((t = -1), (i = -1), (a = -a), 0 !== o && (a--, (o = 4294967296 - o)));
            var $ = n.$high,
                c = n.$low;
            n.$high < 0 && ((t *= -1), ($ = -$), 0 !== c && ($--, (c = 4294967296 - c)));
            for (
                var u = 0, l = 0, s = 0;
                $ < 2147483648 && (a > $ || (a === $ && o > c));

            )
                ($ = (($ << 1) | (c >>> 31)) >>> 0), (c = (c << 1) >>> 0), s++;
            for (var f = 0; f <= s; f++)
                (u = (u << 1) | (l >>> 31)),
                    (l = (l << 1) >>> 0),
                    (a > $ || (a === $ && o >= c)) &&
                        ((a -= $),
                        (o -= c) < 0 && (a--, (o += 4294967296)),
                        4294967296 === ++l && (u++, (l = 0))),
                    (c = ((c >>> 1) | ($ << 31)) >>> 0),
                    ($ >>>= 1);
            return r ? new e.constructor(a * i, o * i) : new e.constructor(u * t, l * t);
        },
        $divComplex = function (e, n) {
            var r =
                    e.$real === 1 / 0 ||
                    e.$real === -1 / 0 ||
                    e.$imag === 1 / 0 ||
                    e.$imag === -1 / 0,
                t =
                    n.$real === 1 / 0 ||
                    n.$real === -1 / 0 ||
                    n.$imag === 1 / 0 ||
                    n.$imag === -1 / 0,
                i = !r && (e.$real != e.$real || e.$imag != e.$imag),
                a = !t && (n.$real != n.$real || n.$imag != n.$imag);
            if (i || a) return new e.constructor(NaN, NaN);
            if (r && !t) return new e.constructor(1 / 0, 1 / 0);
            if (!r && t) return new e.constructor(0, 0);
            if (0 === n.$real && 0 === n.$imag)
                return 0 === e.$real && 0 === e.$imag
                    ? new e.constructor(NaN, NaN)
                    : new e.constructor(1 / 0, 1 / 0);
            if (Math.abs(n.$real) <= Math.abs(n.$imag)) {
                var o = n.$real / n.$imag,
                    $ = n.$real * o + n.$imag;
                return new e.constructor(
                    (e.$real * o + e.$imag) / $,
                    (e.$imag * o - e.$real) / $
                );
            }
            (o = n.$imag / n.$real), ($ = n.$imag * o + n.$real);
            return new e.constructor(
                (e.$imag * o + e.$real) / $,
                (e.$imag - e.$real * o) / $
            );
        },
        $kindBool = 1,
        $kindInt = 2,
        $kindInt8 = 3,
        $kindInt16 = 4,
        $kindInt32 = 5,
        $kindInt64 = 6,
        $kindUint = 7,
        $kindUint8 = 8,
        $kindUint16 = 9,
        $kindUint32 = 10,
        $kindUint64 = 11,
        $kindUintptr = 12,
        $kindFloat32 = 13,
        $kindFloat64 = 14,
        $kindComplex64 = 15,
        $kindComplex128 = 16,
        $kindArray = 17,
        $kindChan = 18,
        $kindFunc = 19,
        $kindInterface = 20,
        $kindMap = 21,
        $kindPtr = 22,
        $kindSlice = 23,
        $kindString = 24,
        $kindStruct = 25,
        $kindUnsafePointer = 26,
        $methodSynthesizers = [],
        $addMethodSynthesizer = function (e) {
            null !== $methodSynthesizers ? $methodSynthesizers.push(e) : e();
        },
        $synthesizeMethods = function () {
            $methodSynthesizers.forEach(function (e) {
                e();
            }),
                ($methodSynthesizers = null);
        },
        $ifaceKeyFor = function (e) {
            if (e === $ifaceNil) return 'nil';
            var n = e.constructor;
            return n.string + '$' + n.keyFor(e.$val);
        },
        $identity = function (e) {
            return e;
        },
        $typeIDCounter = 0,
        $idKey = function (e) {
            return (
                void 0 === e.$id && ($idCounter++, (e.$id = $idCounter)), String(e.$id)
            );
        },
        $newType = function (e, n, r, t, i, a, o) {
            var $;
            switch (n) {
                case $kindBool:
                case $kindInt:
                case $kindInt8:
                case $kindInt16:
                case $kindInt32:
                case $kindUint:
                case $kindUint8:
                case $kindUint16:
                case $kindUint32:
                case $kindUintptr:
                case $kindUnsafePointer:
                    (($ = function (e) {
                        this.$val = e;
                    }).wrapped = !0),
                        ($.keyFor = $identity);
                    break;
                case $kindString:
                    (($ = function (e) {
                        this.$val = e;
                    }).wrapped = !0),
                        ($.keyFor = function (e) {
                            return '$' + e;
                        });
                    break;
                case $kindFloat32:
                case $kindFloat64:
                    (($ = function (e) {
                        this.$val = e;
                    }).wrapped = !0),
                        ($.keyFor = function (e) {
                            return $floatKey(e);
                        });
                    break;
                case $kindInt64:
                    ($ = function (e, n) {
                        (this.$high = (e + Math.floor(Math.ceil(n) / 4294967296)) >> 0),
                            (this.$low = n >>> 0),
                            (this.$val = this);
                    }).keyFor = function (e) {
                        return e.$high + '$' + e.$low;
                    };
                    break;
                case $kindUint64:
                    ($ = function (e, n) {
                        (this.$high = (e + Math.floor(Math.ceil(n) / 4294967296)) >>> 0),
                            (this.$low = n >>> 0),
                            (this.$val = this);
                    }).keyFor = function (e) {
                        return e.$high + '$' + e.$low;
                    };
                    break;
                case $kindComplex64:
                    ($ = function (e, n) {
                        (this.$real = $fround(e)),
                            (this.$imag = $fround(n)),
                            (this.$val = this);
                    }).keyFor = function (e) {
                        return e.$real + '$' + e.$imag;
                    };
                    break;
                case $kindComplex128:
                    ($ = function (e, n) {
                        (this.$real = e), (this.$imag = n), (this.$val = this);
                    }).keyFor = function (e) {
                        return e.$real + '$' + e.$imag;
                    };
                    break;
                case $kindArray:
                    (($ = function (e) {
                        this.$val = e;
                    }).wrapped = !0),
                        ($.ptr = $newType(4, $kindPtr, '*' + r, !1, '', !1, function (e) {
                            (this.$get = function () {
                                return e;
                            }),
                                (this.$set = function (e) {
                                    $.copy(this, e);
                                }),
                                (this.$val = e);
                        })),
                        ($.init = function (e, n) {
                            ($.elem = e),
                                ($.len = n),
                                ($.comparable = e.comparable),
                                ($.keyFor = function (n) {
                                    return Array.prototype.join.call(
                                        $mapArray(n, function (n) {
                                            return String(e.keyFor(n))
                                                .replace(/\\/g, '\\\\')
                                                .replace(/\$/g, '\\$');
                                        }),
                                        '$'
                                    );
                                }),
                                ($.copy = function (n, r) {
                                    $copyArray(n, r, 0, 0, r.length, e);
                                }),
                                $.ptr.init($),
                                Object.defineProperty($.ptr.nil, 'nilCheck', {
                                    get: $throwNilPointerError,
                                });
                        });
                    break;
                case $kindChan:
                    (($ = function (e) {
                        this.$val = e;
                    }).wrapped = !0),
                        ($.keyFor = $idKey),
                        ($.init = function (e, n, r) {
                            ($.elem = e), ($.sendOnly = n), ($.recvOnly = r);
                        });
                    break;
                case $kindFunc:
                    (($ = function (e) {
                        this.$val = e;
                    }).wrapped = !0),
                        ($.init = function (e, n, r) {
                            ($.params = e),
                                ($.results = n),
                                ($.variadic = r),
                                ($.comparable = !1);
                        });
                    break;
                case $kindInterface:
                    (($ = { implementedBy: {}, missingMethodFor: {} }).keyFor =
                        $ifaceKeyFor),
                        ($.init = function (e) {
                            ($.methods = e),
                                e.forEach(function (e) {
                                    $ifaceNil[e.prop] = $throwNilPointerError;
                                });
                        });
                    break;
                case $kindMap:
                    (($ = function (e) {
                        this.$val = e;
                    }).wrapped = !0),
                        ($.init = function (e, n) {
                            ($.key = e), ($.elem = n), ($.comparable = !1);
                        });
                    break;
                case $kindPtr:
                    (($ =
                        o ||
                        function (e, n, r) {
                            (this.$get = e),
                                (this.$set = n),
                                (this.$target = r),
                                (this.$val = this);
                        }).keyFor = $idKey),
                        ($.init = function (e) {
                            ($.elem = e),
                                ($.wrapped = e.kind === $kindArray),
                                ($.nil = new $(
                                    $throwNilPointerError,
                                    $throwNilPointerError
                                ));
                        });
                    break;
                case $kindSlice:
                    ($ = function (e) {
                        e.constructor !== $.nativeArray && (e = new $.nativeArray(e)),
                            (this.$array = e),
                            (this.$offset = 0),
                            (this.$length = e.length),
                            (this.$capacity = e.length),
                            (this.$val = this);
                    }).init = function (e) {
                        ($.elem = e),
                            ($.comparable = !1),
                            ($.nativeArray = $nativeArray(e.kind)),
                            ($.nil = new $([]));
                    };
                    break;
                case $kindStruct:
                    (($ = function (e) {
                        this.$val = e;
                    }).wrapped = !0),
                        ($.ptr = $newType(4, $kindPtr, '*' + r, !1, i, a, o)),
                        ($.ptr.elem = $),
                        ($.ptr.prototype.$get = function () {
                            return this;
                        }),
                        ($.ptr.prototype.$set = function (e) {
                            $.copy(this, e);
                        }),
                        ($.init = function (e, n) {
                            ($.pkgPath = e),
                                ($.fields = n),
                                n.forEach(function (e) {
                                    e.typ.comparable || ($.comparable = !1);
                                }),
                                ($.keyFor = function (e) {
                                    var r = e.$val;
                                    return $mapArray(n, function (e) {
                                        return String(e.typ.keyFor(r[e.prop]))
                                            .replace(/\\/g, '\\\\')
                                            .replace(/\$/g, '\\$');
                                    }).join('$');
                                }),
                                ($.copy = function (e, r) {
                                    for (var t = 0; t < n.length; t++) {
                                        var i = n[t];
                                        switch (i.typ.kind) {
                                            case $kindArray:
                                            case $kindStruct:
                                                i.typ.copy(e[i.prop], r[i.prop]);
                                                continue;
                                            default:
                                                e[i.prop] = r[i.prop];
                                                continue;
                                        }
                                    }
                                });
                            var r = {};
                            n.forEach(function (e) {
                                r[e.prop] = {
                                    get: $throwNilPointerError,
                                    set: $throwNilPointerError,
                                };
                            }),
                                ($.ptr.nil = Object.create(o.prototype, r)),
                                ($.ptr.nil.$val = $.ptr.nil),
                                $addMethodSynthesizer(function () {
                                    var e = function (e, n, r) {
                                        void 0 === e.prototype[n.prop] &&
                                            (e.prototype[n.prop] = function () {
                                                var e = this.$val[r.prop];
                                                return (
                                                    r.typ === $jsObjectPtr &&
                                                        (e = new $jsObjectPtr(e)),
                                                    void 0 === e.$val &&
                                                        (e = new r.typ(e)),
                                                    e[n.prop].apply(e, arguments)
                                                );
                                            });
                                    };
                                    n.forEach(function (n) {
                                        n.anonymous &&
                                            ($methodSet(n.typ).forEach(function (r) {
                                                e($, r, n), e($.ptr, r, n);
                                            }),
                                            $methodSet($ptrType(n.typ)).forEach(
                                                function (r) {
                                                    e($.ptr, r, n);
                                                }
                                            ));
                                    });
                                });
                        });
                    break;
                default:
                    $panic(new $String('invalid kind: ' + n));
            }
            switch (n) {
                case $kindBool:
                case $kindMap:
                    $.zero = function () {
                        return !1;
                    };
                    break;
                case $kindInt:
                case $kindInt8:
                case $kindInt16:
                case $kindInt32:
                case $kindUint:
                case $kindUint8:
                case $kindUint16:
                case $kindUint32:
                case $kindUintptr:
                case $kindUnsafePointer:
                case $kindFloat32:
                case $kindFloat64:
                    $.zero = function () {
                        return 0;
                    };
                    break;
                case $kindString:
                    $.zero = function () {
                        return '';
                    };
                    break;
                case $kindInt64:
                case $kindUint64:
                case $kindComplex64:
                case $kindComplex128:
                    var c = new $(0, 0);
                    $.zero = function () {
                        return c;
                    };
                    break;
                case $kindPtr:
                case $kindSlice:
                    $.zero = function () {
                        return $.nil;
                    };
                    break;
                case $kindChan:
                    $.zero = function () {
                        return $chanNil;
                    };
                    break;
                case $kindFunc:
                    $.zero = function () {
                        return $throwNilPointerError;
                    };
                    break;
                case $kindInterface:
                    $.zero = function () {
                        return $ifaceNil;
                    };
                    break;
                case $kindArray:
                    $.zero = function () {
                        var e = $nativeArray($.elem.kind);
                        if (e !== Array) return new e($.len);
                        for (var n = new Array($.len), r = 0; r < $.len; r++)
                            n[r] = $.elem.zero();
                        return n;
                    };
                    break;
                case $kindStruct:
                    $.zero = function () {
                        return new $.ptr();
                    };
                    break;
                default:
                    $panic(new $String('invalid kind: ' + n));
            }
            return (
                ($.id = $typeIDCounter),
                $typeIDCounter++,
                ($.size = e),
                ($.kind = n),
                ($.string = r),
                ($.named = t),
                ($.pkg = i),
                ($.exported = a),
                ($.methods = []),
                ($.methodSetCache = null),
                ($.comparable = !0),
                $
            );
        },
        $methodSet = function (e) {
            if (null !== e.methodSetCache) return e.methodSetCache;
            var n = {},
                r = e.kind === $kindPtr;
            if (r && e.elem.kind === $kindInterface) return (e.methodSetCache = []), [];
            for (var t = [{ typ: r ? e.elem : e, indirect: r }], i = {}; t.length > 0; ) {
                var a = [],
                    o = [];
                t.forEach(function (e) {
                    if (!i[e.typ.string])
                        switch (
                            ((i[e.typ.string] = !0),
                            e.typ.named &&
                                ((o = o.concat(e.typ.methods)),
                                e.indirect && (o = o.concat($ptrType(e.typ).methods))),
                            e.typ.kind)
                        ) {
                            case $kindStruct:
                                e.typ.fields.forEach(function (n) {
                                    if (n.anonymous) {
                                        var r = n.typ,
                                            t = r.kind === $kindPtr;
                                        a.push({
                                            typ: t ? r.elem : r,
                                            indirect: e.indirect || t,
                                        });
                                    }
                                });
                                break;
                            case $kindInterface:
                                o = o.concat(e.typ.methods);
                        }
                }),
                    o.forEach(function (e) {
                        void 0 === n[e.name] && (n[e.name] = e);
                    }),
                    (t = a);
            }
            return (
                (e.methodSetCache = []),
                Object.keys(n)
                    .sort()
                    .forEach(function (r) {
                        e.methodSetCache.push(n[r]);
                    }),
                e.methodSetCache
            );
        },
        $Bool = $newType(1, $kindBool, 'bool', !0, '', !1, null),
        $Int = $newType(4, $kindInt, 'int', !0, '', !1, null),
        $Int8 = $newType(1, $kindInt8, 'int8', !0, '', !1, null),
        $Int16 = $newType(2, $kindInt16, 'int16', !0, '', !1, null),
        $Int32 = $newType(4, $kindInt32, 'int32', !0, '', !1, null),
        $Int64 = $newType(8, $kindInt64, 'int64', !0, '', !1, null),
        $Uint = $newType(4, $kindUint, 'uint', !0, '', !1, null),
        $Uint8 = $newType(1, $kindUint8, 'uint8', !0, '', !1, null),
        $Uint16 = $newType(2, $kindUint16, 'uint16', !0, '', !1, null),
        $Uint32 = $newType(4, $kindUint32, 'uint32', !0, '', !1, null),
        $Uint64 = $newType(8, $kindUint64, 'uint64', !0, '', !1, null),
        $Uintptr = $newType(4, $kindUintptr, 'uintptr', !0, '', !1, null),
        $Float32 = $newType(4, $kindFloat32, 'float32', !0, '', !1, null),
        $Float64 = $newType(8, $kindFloat64, 'float64', !0, '', !1, null),
        $Complex64 = $newType(8, $kindComplex64, 'complex64', !0, '', !1, null),
        $Complex128 = $newType(16, $kindComplex128, 'complex128', !0, '', !1, null),
        $String = $newType(8, $kindString, 'string', !0, '', !1, null),
        $UnsafePointer = $newType(
            4,
            $kindUnsafePointer,
            'unsafe.Pointer',
            !0,
            '',
            !1,
            null
        ),
        $nativeArray = function (e) {
            switch (e) {
                case $kindInt:
                    return Int32Array;
                case $kindInt8:
                    return Int8Array;
                case $kindInt16:
                    return Int16Array;
                case $kindInt32:
                    return Int32Array;
                case $kindUint:
                    return Uint32Array;
                case $kindUint8:
                    return Uint8Array;
                case $kindUint16:
                    return Uint16Array;
                case $kindUint32:
                case $kindUintptr:
                    return Uint32Array;
                case $kindFloat32:
                    return Float32Array;
                case $kindFloat64:
                    return Float64Array;
                default:
                    return Array;
            }
        },
        $toNativeArray = function (e, n) {
            var r = $nativeArray(e);
            return r === Array ? n : new r(n);
        },
        $arrayTypes = {},
        $arrayType = function (e, n) {
            var r = e.id + '$' + n,
                t = $arrayTypes[r];
            return (
                void 0 === t &&
                    ((t = $newType(
                        12,
                        $kindArray,
                        '[' + n + ']' + e.string,
                        !1,
                        '',
                        !1,
                        null
                    )),
                    ($arrayTypes[r] = t),
                    t.init(e, n)),
                t
            );
        },
        $chanType = function (e, n, r) {
            var t = (r ? '<-' : '') + 'chan' + (n ? '<- ' : ' ') + e.string,
                i = n ? 'SendChan' : r ? 'RecvChan' : 'Chan',
                a = e[i];
            return (
                void 0 === a &&
                    ((a = $newType(4, $kindChan, t, !1, '', !1, null)),
                    (e[i] = a),
                    a.init(e, n, r)),
                a
            );
        },
        $Chan = function (e, n) {
            (n < 0 || n > 2147483647) &&
                $throwRuntimeError('makechan: size out of range'),
                (this.$elem = e),
                (this.$capacity = n),
                (this.$buffer = []),
                (this.$sendQueue = []),
                (this.$recvQueue = []),
                (this.$closed = !1);
        },
        $chanNil = new $Chan(null, 0);
    $chanNil.$sendQueue = $chanNil.$recvQueue = {
        length: 0,
        push: function () {},
        shift: function () {},
        indexOf: function () {
            return -1;
        },
    };
    var $funcTypes = {},
        $funcType = function (e, n, r) {
            var t =
                    $mapArray(e, function (e) {
                        return e.id;
                    }).join(',') +
                    '$' +
                    $mapArray(n, function (e) {
                        return e.id;
                    }).join(',') +
                    '$' +
                    r,
                i = $funcTypes[t];
            if (void 0 === i) {
                var a = $mapArray(e, function (e) {
                    return e.string;
                });
                r && (a[a.length - 1] = '...' + a[a.length - 1].substr(2));
                var o = 'func(' + a.join(', ') + ')';
                1 === n.length
                    ? (o += ' ' + n[0].string)
                    : n.length > 1 &&
                      (o +=
                          ' (' +
                          $mapArray(n, function (e) {
                              return e.string;
                          }).join(', ') +
                          ')'),
                    (i = $newType(4, $kindFunc, o, !1, '', !1, null)),
                    ($funcTypes[t] = i),
                    i.init(e, n, r);
            }
            return i;
        },
        $interfaceTypes = {},
        $interfaceType = function (e) {
            var n = $mapArray(e, function (e) {
                    return e.pkg + ',' + e.name + ',' + e.typ.id;
                }).join('$'),
                r = $interfaceTypes[n];
            if (void 0 === r) {
                var t = 'interface {}';
                0 !== e.length &&
                    (t =
                        'interface { ' +
                        $mapArray(e, function (e) {
                            return (
                                ('' !== e.pkg ? e.pkg + '.' : '') +
                                e.name +
                                e.typ.string.substr(4)
                            );
                        }).join('; ') +
                        ' }'),
                    (r = $newType(8, $kindInterface, t, !1, '', !1, null)),
                    ($interfaceTypes[n] = r),
                    r.init(e);
            }
            return r;
        },
        $emptyInterface = $interfaceType([]),
        $ifaceNil = {},
        $error = $newType(8, $kindInterface, 'error', !0, '', !1, null);
    $error.init([
        { prop: 'Error', name: 'Error', pkg: '', typ: $funcType([], [$String], !1) },
    ]);
    var $panicValue,
        $jsObjectPtr,
        $jsErrorPtr,
        $mapTypes = {},
        $mapType = function (e, n) {
            var r = e.id + '$' + n.id,
                t = $mapTypes[r];
            return (
                void 0 === t &&
                    ((t = $newType(
                        4,
                        $kindMap,
                        'map[' + e.string + ']' + n.string,
                        !1,
                        '',
                        !1,
                        null
                    )),
                    ($mapTypes[r] = t),
                    t.init(e, n)),
                t
            );
        },
        $makeMap = function (e, n) {
            for (var r = {}, t = 0; t < n.length; t++) {
                var i = n[t];
                r[e(i.k)] = i;
            }
            return r;
        },
        $ptrType = function (e) {
            var n = e.ptr;
            return (
                void 0 === n &&
                    ((n = $newType(
                        4,
                        $kindPtr,
                        '*' + e.string,
                        !1,
                        '',
                        e.exported,
                        null
                    )),
                    (e.ptr = n),
                    n.init(e)),
                n
            );
        },
        $newDataPointer = function (e, n) {
            return n.elem.kind === $kindStruct
                ? e
                : new n(
                      function () {
                          return e;
                      },
                      function (n) {
                          e = n;
                      }
                  );
        },
        $indexPtr = function (e, n, r) {
            return (
                (e.$ptr = e.$ptr || {}),
                e.$ptr[n] ||
                    (e.$ptr[n] = new r(
                        function () {
                            return e[n];
                        },
                        function (r) {
                            e[n] = r;
                        }
                    ))
            );
        },
        $sliceType = function (e) {
            var n = e.slice;
            return (
                void 0 === n &&
                    ((n = $newType(12, $kindSlice, '[]' + e.string, !1, '', !1, null)),
                    (e.slice = n),
                    n.init(e)),
                n
            );
        },
        $makeSlice = function (e, n, r) {
            (r = r || n),
                (n < 0 || n > 2147483647) &&
                    $throwRuntimeError('makeslice: len out of range'),
                (r < 0 || r < n || r > 2147483647) &&
                    $throwRuntimeError('makeslice: cap out of range');
            var t = new e.nativeArray(r);
            if (e.nativeArray === Array) for (var i = 0; i < r; i++) t[i] = e.elem.zero();
            var a = new e(t);
            return (a.$length = n), a;
        },
        $structTypes = {},
        $structType = function (e, n) {
            var r = $mapArray(n, function (e) {
                    return e.name + ',' + e.typ.id + ',' + e.tag;
                }).join('$'),
                t = $structTypes[r];
            if (void 0 === t) {
                var i =
                    'struct { ' +
                    $mapArray(n, function (e) {
                        return (
                            e.name +
                            ' ' +
                            e.typ.string +
                            ('' !== e.tag
                                ? ' "' +
                                  e.tag.replace(/\\/g, '\\\\').replace(/"/g, '\\"') +
                                  '"'
                                : '')
                        );
                    }).join('; ') +
                    ' }';
                0 === n.length && (i = 'struct {}'),
                    (t = $newType(0, $kindStruct, i, !1, '', !1, function () {
                        this.$val = this;
                        for (var e = 0; e < n.length; e++) {
                            var r = n[e],
                                t = arguments[e];
                            this[r.prop] = void 0 !== t ? t : r.typ.zero();
                        }
                    })),
                    ($structTypes[r] = t),
                    t.init(e, n);
            }
            return t;
        },
        $assertType = function (e, n, r) {
            var t,
                i = n.kind === $kindInterface,
                a = '';
            if (e === $ifaceNil) t = !1;
            else if (i) {
                var o = e.constructor.string;
                if (void 0 === (t = n.implementedBy[o])) {
                    t = !0;
                    for (
                        var $ = $methodSet(e.constructor), c = n.methods, u = 0;
                        u < c.length;
                        u++
                    ) {
                        for (var l = c[u], s = !1, f = 0; f < $.length; f++) {
                            var d = $[f];
                            if (d.name === l.name && d.pkg === l.pkg && d.typ === l.typ) {
                                s = !0;
                                break;
                            }
                        }
                        if (!s) {
                            (t = !1), (n.missingMethodFor[o] = l.name);
                            break;
                        }
                    }
                    n.implementedBy[o] = t;
                }
                t || (a = n.missingMethodFor[o]);
            } else t = e.constructor === n;
            if (!t) {
                if (r) return [n.zero(), !1];
                $panic(
                    new $packages.runtime.TypeAssertionError.ptr(
                        '',
                        e === $ifaceNil ? '' : e.constructor.string,
                        n.string,
                        a
                    )
                );
            }
            return (
                i || (e = e.$val), n === $jsObjectPtr && (e = e.object), r ? [e, !0] : e
            );
        },
        $stackDepthOffset = 0,
        $getStackDepth = function () {
            var e = new Error();
            if (void 0 !== e.stack) return $stackDepthOffset + e.stack.split('\n').length;
        },
        $panicStackDepth = null,
        $callDeferred = function (e, n, r) {
            if (!r && null !== e && e.index >= $curGoroutine.deferStack.length) throw n;
            if (null !== n) {
                var t = null;
                try {
                    $curGoroutine.deferStack.push(e), $panic(new $jsErrorPtr(n));
                } catch (e) {
                    t = e;
                }
                return $curGoroutine.deferStack.pop(), void $callDeferred(e, t);
            }
            if (!$curGoroutine.asleep) {
                $stackDepthOffset--;
                var i = $panicStackDepth,
                    a = $panicValue,
                    o = $curGoroutine.panicStack.pop();
                void 0 !== o &&
                    (($panicStackDepth = $getStackDepth()), ($panicValue = o));
                try {
                    for (;;) {
                        if (
                            null === e &&
                            void 0 ===
                                (e =
                                    $curGoroutine.deferStack[
                                        $curGoroutine.deferStack.length - 1
                                    ])
                        ) {
                            if ((($panicStackDepth = null), o.Object instanceof Error))
                                throw o.Object;
                            var $;
                            throw (
                                (($ =
                                    o.constructor === $String
                                        ? o.$val
                                        : void 0 !== o.Error
                                          ? o.Error()
                                          : void 0 !== o.String
                                            ? o.String()
                                            : o),
                                new Error($))
                            );
                        }
                        var c = e.pop();
                        if (void 0 === c) {
                            if (($curGoroutine.deferStack.pop(), void 0 !== o)) {
                                e = null;
                                continue;
                            }
                            return;
                        }
                        var u = c[0].apply(c[2], c[1]);
                        if (u && void 0 !== u.$blk) {
                            if ((e.push([u.$blk, [], u]), r)) throw null;
                            return;
                        }
                        if (void 0 !== o && null === $panicStackDepth) throw null;
                    }
                } finally {
                    void 0 !== o &&
                        (null !== $panicStackDepth && $curGoroutine.panicStack.push(o),
                        ($panicStackDepth = i),
                        ($panicValue = a)),
                        $stackDepthOffset++;
                }
            }
        },
        $panic = function (e) {
            $curGoroutine.panicStack.push(e), $callDeferred(null, null, !0);
        },
        $recover = function () {
            return null === $panicStackDepth ||
                (void 0 !== $panicStackDepth && $panicStackDepth !== $getStackDepth() - 2)
                ? $ifaceNil
                : (($panicStackDepth = null), $panicValue);
        },
        $throw = function (e) {
            throw e;
        },
        $noGoroutine = { asleep: !1, exit: !1, deferStack: [], panicStack: [] },
        $curGoroutine = $noGoroutine,
        $totalGoroutines = 0,
        $awakeGoroutines = 0,
        $checkForDeadlock = !0,
        $mainFinished = !1,
        $go = function (e, n) {
            $totalGoroutines++, $awakeGoroutines++;
            var r = function () {
                try {
                    $curGoroutine = r;
                    var t = e.apply(void 0, n);
                    if (t && void 0 !== t.$blk)
                        return (
                            (e = function () {
                                return t.$blk();
                            }),
                            void (n = [])
                        );
                    r.exit = !0;
                } catch (e) {
                    if (!r.exit) throw e;
                } finally {
                    ($curGoroutine = $noGoroutine),
                        r.exit && ($totalGoroutines--, (r.asleep = !0)),
                        r.asleep &&
                            ($awakeGoroutines--,
                            !$mainFinished &&
                                0 === $awakeGoroutines &&
                                $checkForDeadlock &&
                                (console.error(
                                    'fatal error: all goroutines are asleep - deadlock!'
                                ),
                                void 0 !== $global.process && $global.process.exit(2)));
                }
            };
            (r.asleep = !1),
                (r.exit = !1),
                (r.deferStack = []),
                (r.panicStack = []),
                $schedule(r);
        },
        $scheduled = [],
        $runScheduled = function () {
            try {
                for (var e; void 0 !== (e = $scheduled.shift()); ) e();
            } finally {
                $scheduled.length > 0 && setTimeout($runScheduled, 0);
            }
        },
        $schedule = function (e) {
            e.asleep && ((e.asleep = !1), $awakeGoroutines++),
                $scheduled.push(e),
                $curGoroutine === $noGoroutine && $runScheduled();
        },
        $setTimeout = function (e, n) {
            return (
                $awakeGoroutines++,
                setTimeout(function () {
                    $awakeGoroutines--, e();
                }, n)
            );
        },
        $block = function () {
            $curGoroutine === $noGoroutine &&
                $throwRuntimeError(
                    'cannot block in JavaScript callback, fix by wrapping code in goroutine'
                ),
                ($curGoroutine.asleep = !0);
        },
        $send = function (e, n) {
            e.$closed && $throwRuntimeError('send on closed channel');
            var r = e.$recvQueue.shift();
            if (void 0 === r) {
                if (!(e.$buffer.length < e.$capacity)) {
                    var t,
                        i = $curGoroutine;
                    return (
                        e.$sendQueue.push(function (e) {
                            return (t = e), $schedule(i), n;
                        }),
                        $block(),
                        {
                            $blk: function () {
                                t && $throwRuntimeError('send on closed channel');
                            },
                        }
                    );
                }
                e.$buffer.push(n);
            } else r([n, !0]);
        },
        $recv = function (e) {
            var n = e.$sendQueue.shift();
            void 0 !== n && e.$buffer.push(n(!1));
            var r = e.$buffer.shift();
            if (void 0 !== r) return [r, !0];
            if (e.$closed) return [e.$elem.zero(), !1];
            var t = $curGoroutine,
                i = {
                    $blk: function () {
                        return this.value;
                    },
                };
            return (
                e.$recvQueue.push(function (e) {
                    (i.value = e), $schedule(t);
                }),
                $block(),
                i
            );
        },
        $close = function (e) {
            for (
                e.$closed && $throwRuntimeError('close of closed channel'),
                    e.$closed = !0;
                ;

            ) {
                var n = e.$sendQueue.shift();
                if (void 0 === n) break;
                n(!0);
            }
            for (;;) {
                var r = e.$recvQueue.shift();
                if (void 0 === r) break;
                r([e.$elem.zero(), !1]);
            }
        },
        $select = function (e) {
            for (var n = [], r = -1, t = 0; t < e.length; t++) {
                var i,
                    a = (i = e[t])[0];
                switch (i.length) {
                    case 0:
                        r = t;
                        break;
                    case 1:
                        (0 !== a.$sendQueue.length ||
                            0 !== a.$buffer.length ||
                            a.$closed) &&
                            n.push(t);
                        break;
                    case 2:
                        a.$closed && $throwRuntimeError('send on closed channel'),
                            (0 !== a.$recvQueue.length ||
                                a.$buffer.length < a.$capacity) &&
                                n.push(t);
                }
            }
            if (
                (0 !== n.length && (r = n[Math.floor(Math.random() * n.length)]),
                -1 !== r)
            )
                switch ((i = e[r]).length) {
                    case 0:
                        return [r];
                    case 1:
                        return [r, $recv(i[0])];
                    case 2:
                        return $send(i[0], i[1]), [r];
                }
            var o = [],
                $ = $curGoroutine,
                c = {
                    $blk: function () {
                        return this.selection;
                    },
                },
                u = function () {
                    for (var e = 0; e < o.length; e++) {
                        var n = o[e],
                            r = n[0],
                            t = r.indexOf(n[1]);
                        -1 !== t && r.splice(t, 1);
                    }
                };
            for (t = 0; t < e.length; t++)
                !(function (n) {
                    var r = e[n];
                    switch (r.length) {
                        case 1:
                            var t = function (e) {
                                (c.selection = [n, e]), u(), $schedule($);
                            };
                            o.push([r[0].$recvQueue, t]), r[0].$recvQueue.push(t);
                            break;
                        case 2:
                            t = function () {
                                return (
                                    r[0].$closed &&
                                        $throwRuntimeError('send on closed channel'),
                                    (c.selection = [n]),
                                    u(),
                                    $schedule($),
                                    r[1]
                                );
                            };
                            o.push([r[0].$sendQueue, t]), r[0].$sendQueue.push(t);
                    }
                })(t);
            return $block(), c;
        },
        $needsExternalization = function (e) {
            switch (e.kind) {
                case $kindBool:
                case $kindInt:
                case $kindInt8:
                case $kindInt16:
                case $kindInt32:
                case $kindUint:
                case $kindUint8:
                case $kindUint16:
                case $kindUint32:
                case $kindUintptr:
                case $kindFloat32:
                case $kindFloat64:
                    return !1;
                default:
                    return e !== $jsObjectPtr;
            }
        },
        $externalize = function (e, n) {
            if (n === $jsObjectPtr) return e;
            switch (n.kind) {
                case $kindBool:
                case $kindInt:
                case $kindInt8:
                case $kindInt16:
                case $kindInt32:
                case $kindUint:
                case $kindUint8:
                case $kindUint16:
                case $kindUint32:
                case $kindUintptr:
                case $kindFloat32:
                case $kindFloat64:
                    return e;
                case $kindInt64:
                case $kindUint64:
                    return $flatten64(e);
                case $kindArray:
                    return $needsExternalization(n.elem)
                        ? $mapArray(e, function (e) {
                              return $externalize(e, n.elem);
                          })
                        : e;
                case $kindFunc:
                    return $externalizeFunction(e, n, !1);
                case $kindInterface:
                    return e === $ifaceNil
                        ? null
                        : e.constructor === $jsObjectPtr
                          ? e.$val.object
                          : $externalize(e.$val, e.constructor);
                case $kindMap:
                    for (var r = {}, t = $keys(e), i = 0; i < t.length; i++) {
                        var a = e[t[i]];
                        r[$externalize(a.k, n.key)] = $externalize(a.v, n.elem);
                    }
                    return r;
                case $kindPtr:
                    return e === n.nil ? null : $externalize(e.$get(), n.elem);
                case $kindSlice:
                    return $needsExternalization(n.elem)
                        ? $mapArray($sliceToArray(e), function (e) {
                              return $externalize(e, n.elem);
                          })
                        : $sliceToArray(e);
                case $kindString:
                    if ($isASCII(e)) return e;
                    var o,
                        $ = '';
                    for (i = 0; i < e.length; i += o[1]) {
                        var c = (o = $decodeRune(e, i))[0];
                        if (c > 65535) {
                            var u = Math.floor((c - 65536) / 1024) + 55296,
                                l = ((c - 65536) % 1024) + 56320;
                            $ += String.fromCharCode(u, l);
                        } else $ += String.fromCharCode(c);
                    }
                    return $;
                case $kindStruct:
                    var s = $packages.time;
                    if (void 0 !== s && e.constructor === s.Time.ptr) {
                        var f = $div64(e.UnixNano(), new $Int64(0, 1e6));
                        return new Date($flatten64(f));
                    }
                    var d = {},
                        p = function (e, n) {
                            if (n === $jsObjectPtr) return e;
                            switch (n.kind) {
                                case $kindPtr:
                                    return e === n.nil ? d : p(e.$get(), n.elem);
                                case $kindStruct:
                                    var r = n.fields[0];
                                    return p(e[r.prop], r.typ);
                                case $kindInterface:
                                    return p(e.$val, e.constructor);
                                default:
                                    return d;
                            }
                        },
                        h = p(e, n);
                    if (h !== d) return h;
                    h = {};
                    for (i = 0; i < n.fields.length; i++) {
                        var k = n.fields[i];
                        k.exported && (h[k.name] = $externalize(e[k.prop], k.typ));
                    }
                    return h;
            }
            $throwRuntimeError('cannot externalize ' + n.string);
        },
        $externalizeFunction = function (e, n, r) {
            return e === $throwNilPointerError
                ? null
                : (void 0 === e.$externalizeWrapper &&
                      (($checkForDeadlock = !1),
                      (e.$externalizeWrapper = function () {
                          for (var t = [], i = 0; i < n.params.length; i++) {
                              if (n.variadic && i === n.params.length - 1) {
                                  for (
                                      var a = n.params[i].elem, o = [], $ = i;
                                      $ < arguments.length;
                                      $++
                                  )
                                      o.push($internalize(arguments[$], a));
                                  t.push(new n.params[i](o));
                                  break;
                              }
                              t.push($internalize(arguments[i], n.params[i]));
                          }
                          var c = e.apply(r ? this : void 0, t);
                          switch (n.results.length) {
                              case 0:
                                  return;
                              case 1:
                                  return $externalize(c, n.results[0]);
                              default:
                                  for (i = 0; i < n.results.length; i++)
                                      c[i] = $externalize(c[i], n.results[i]);
                                  return c;
                          }
                      })),
                  e.$externalizeWrapper);
        },
        $internalize = function (e, n, r) {
            if (n === $jsObjectPtr) return e;
            if (
                (n === $jsObjectPtr.elem &&
                    $throwRuntimeError(
                        'cannot internalize js.Object, use *js.Object instead'
                    ),
                e && void 0 !== e.__internal_object__)
            )
                return $assertType(e.__internal_object__, n, !1);
            var t = $packages.time;
            if (void 0 !== t && n === t.Time)
                return (
                    (null !== e && void 0 !== e && e.constructor === Date) ||
                        $throwRuntimeError(
                            'cannot internalize time.Time from ' +
                                typeof e +
                                ', must be Date'
                        ),
                    t.Unix(new $Int64(0, 0), new $Int64(0, 1e6 * e.getTime()))
                );
            switch (n.kind) {
                case $kindBool:
                    return !!e;
                case $kindInt:
                    return parseInt(e);
                case $kindInt8:
                    return (parseInt(e) << 24) >> 24;
                case $kindInt16:
                    return (parseInt(e) << 16) >> 16;
                case $kindInt32:
                    return parseInt(e) >> 0;
                case $kindUint:
                    return parseInt(e);
                case $kindUint8:
                    return (parseInt(e) << 24) >>> 24;
                case $kindUint16:
                    return (parseInt(e) << 16) >>> 16;
                case $kindUint32:
                case $kindUintptr:
                    return parseInt(e) >>> 0;
                case $kindInt64:
                case $kindUint64:
                    return new n(0, e);
                case $kindFloat32:
                case $kindFloat64:
                    return parseFloat(e);
                case $kindArray:
                    return (
                        e.length !== n.len &&
                            $throwRuntimeError(
                                'got array with wrong size from JavaScript native'
                            ),
                        $mapArray(e, function (e) {
                            return $internalize(e, n.elem);
                        })
                    );
                case $kindFunc:
                    return function () {
                        for (var t = [], i = 0; i < n.params.length; i++) {
                            if (n.variadic && i === n.params.length - 1) {
                                for (
                                    var a = n.params[i].elem, o = arguments[i], $ = 0;
                                    $ < o.$length;
                                    $++
                                )
                                    t.push($externalize(o.$array[o.$offset + $], a));
                                break;
                            }
                            t.push($externalize(arguments[i], n.params[i]));
                        }
                        var c = e.apply(r, t);
                        switch (n.results.length) {
                            case 0:
                                return;
                            case 1:
                                return $internalize(c, n.results[0]);
                            default:
                                for (i = 0; i < n.results.length; i++)
                                    c[i] = $internalize(c[i], n.results[i]);
                                return c;
                        }
                    };
                case $kindInterface:
                    if (
                        (0 !== n.methods.length &&
                            $throwRuntimeError('cannot internalize ' + n.string),
                        null === e)
                    )
                        return $ifaceNil;
                    if (void 0 === e) return new $jsObjectPtr(void 0);
                    switch (e.constructor) {
                        case Int8Array:
                            return new ($sliceType($Int8))(e);
                        case Int16Array:
                            return new ($sliceType($Int16))(e);
                        case Int32Array:
                            return new ($sliceType($Int))(e);
                        case Uint8Array:
                            return new ($sliceType($Uint8))(e);
                        case Uint16Array:
                            return new ($sliceType($Uint16))(e);
                        case Uint32Array:
                            return new ($sliceType($Uint))(e);
                        case Float32Array:
                            return new ($sliceType($Float32))(e);
                        case Float64Array:
                            return new ($sliceType($Float64))(e);
                        case Array:
                            return $internalize(e, $sliceType($emptyInterface));
                        case Boolean:
                            return new $Bool(!!e);
                        case Date:
                            return void 0 === t
                                ? new $jsObjectPtr(e)
                                : new t.Time($internalize(e, t.Time));
                        case Function:
                            var i = $funcType(
                                [$sliceType($emptyInterface)],
                                [$jsObjectPtr],
                                !0
                            );
                            return new i($internalize(e, i));
                        case Number:
                            return new $Float64(parseFloat(e));
                        case String:
                            return new $String($internalize(e, $String));
                        default:
                            if ($global.Node && e instanceof $global.Node)
                                return new $jsObjectPtr(e);
                            var a = $mapType($String, $emptyInterface);
                            return new a($internalize(e, a));
                    }
                case $kindMap:
                    for (var o = {}, $ = $keys(e), c = 0; c < $.length; c++) {
                        var u = $internalize($[c], n.key);
                        o[n.key.keyFor(u)] = { k: u, v: $internalize(e[$[c]], n.elem) };
                    }
                    return o;
                case $kindPtr:
                    if (n.elem.kind === $kindStruct) return $internalize(e, n.elem);
                case $kindSlice:
                    return new n(
                        $mapArray(e, function (e) {
                            return $internalize(e, n.elem);
                        })
                    );
                case $kindString:
                    if (((e = String(e)), $isASCII(e))) return e;
                    var l = '';
                    for (c = 0; c < e.length; ) {
                        var s = e.charCodeAt(c);
                        if (55296 <= s && s <= 56319) {
                            var f = e.charCodeAt(c + 1);
                            (l += $encodeRune(1024 * (s - 55296) + f - 56320 + 65536)),
                                (c += 2);
                        } else (l += $encodeRune(s)), c++;
                    }
                    return l;
                case $kindStruct:
                    var d = {},
                        p = function (n) {
                            if (n === $jsObjectPtr) return e;
                            switch (
                                (n === $jsObjectPtr.elem &&
                                    $throwRuntimeError(
                                        'cannot internalize js.Object, use *js.Object instead'
                                    ),
                                n.kind)
                            ) {
                                case $kindPtr:
                                    return p(n.elem);
                                case $kindStruct:
                                    var r = n.fields[0],
                                        t = p(r.typ);
                                    if (t !== d) {
                                        var i = new n.ptr();
                                        return (i[r.prop] = t), i;
                                    }
                                    return d;
                                default:
                                    return d;
                            }
                        },
                        h = p(n);
                    if (h !== d) return h;
            }
            $throwRuntimeError('cannot internalize ' + n.string);
        },
        $isASCII = function (e) {
            for (var n = 0; n < e.length; n++) if (e.charCodeAt(n) >= 128) return !1;
            return !0;
        };

    $packages['github.com/gopherjs/gopherjs/js'] = (function () {
        var $pkg = {},
            $init,
            A,
            B,
            L,
            N,
            Q,
            K;
        A = $pkg.Object = $newType(
            0,
            $kindStruct,
            'js.Object',
            true,
            'github.com/gopherjs/gopherjs/js',
            true,
            function (object_) {
                this.$val = this;
                if (arguments.length === 0) {
                    this.object = null;
                    return;
                }
                this.object = object_;
            }
        );
        B = $pkg.Error = $newType(
            0,
            $kindStruct,
            'js.Error',
            true,
            'github.com/gopherjs/gopherjs/js',
            true,
            function (Object_) {
                this.$val = this;
                if (arguments.length === 0) {
                    this.Object = null;
                    return;
                }
                this.Object = Object_;
            }
        );
        L = $sliceType($emptyInterface);
        N = $ptrType(A);
        Q = $ptrType(B);
        A.ptr.prototype.Get = function (a) {
            var a, b;
            b = this;
            return b.object[$externalize(a, $String)];
        };
        A.prototype.Get = function (a) {
            return this.$val.Get(a);
        };
        A.ptr.prototype.Set = function (a, b) {
            var a, b, c;
            c = this;
            c.object[$externalize(a, $String)] = $externalize(b, $emptyInterface);
        };
        A.prototype.Set = function (a, b) {
            return this.$val.Set(a, b);
        };
        A.ptr.prototype.Delete = function (a) {
            var a, b;
            b = this;
            delete b.object[$externalize(a, $String)];
        };
        A.prototype.Delete = function (a) {
            return this.$val.Delete(a);
        };
        A.ptr.prototype.Length = function () {
            var a;
            a = this;
            return $parseInt(a.object.length);
        };
        A.prototype.Length = function () {
            return this.$val.Length();
        };
        A.ptr.prototype.Index = function (a) {
            var a, b;
            b = this;
            return b.object[a];
        };
        A.prototype.Index = function (a) {
            return this.$val.Index(a);
        };
        A.ptr.prototype.SetIndex = function (a, b) {
            var a, b, c;
            c = this;
            c.object[a] = $externalize(b, $emptyInterface);
        };
        A.prototype.SetIndex = function (a, b) {
            return this.$val.SetIndex(a, b);
        };
        A.ptr.prototype.Call = function (a, b) {
            var a, b, c, d;
            c = this;
            return (
                (d = c.object), d[$externalize(a, $String)].apply(d, $externalize(b, L))
            );
        };
        A.prototype.Call = function (a, b) {
            return this.$val.Call(a, b);
        };
        A.ptr.prototype.Invoke = function (a) {
            var a, b;
            b = this;
            return b.object.apply(undefined, $externalize(a, L));
        };
        A.prototype.Invoke = function (a) {
            return this.$val.Invoke(a);
        };
        A.ptr.prototype.New = function (a) {
            var a, b;
            b = this;
            return new ($global.Function.prototype.bind.apply(
                b.object,
                [undefined].concat($externalize(a, L))
            ))();
        };
        A.prototype.New = function (a) {
            return this.$val.New(a);
        };
        A.ptr.prototype.Bool = function () {
            var a;
            a = this;
            return !!a.object;
        };
        A.prototype.Bool = function () {
            return this.$val.Bool();
        };
        A.ptr.prototype.String = function () {
            var a;
            a = this;
            return $internalize(a.object, $String);
        };
        A.prototype.String = function () {
            return this.$val.String();
        };
        A.ptr.prototype.Int = function () {
            var a;
            a = this;
            return $parseInt(a.object) >> 0;
        };
        A.prototype.Int = function () {
            return this.$val.Int();
        };
        A.ptr.prototype.Int64 = function () {
            var a;
            a = this;
            return $internalize(a.object, $Int64);
        };
        A.prototype.Int64 = function () {
            return this.$val.Int64();
        };
        A.ptr.prototype.Uint64 = function () {
            var a;
            a = this;
            return $internalize(a.object, $Uint64);
        };
        A.prototype.Uint64 = function () {
            return this.$val.Uint64();
        };
        A.ptr.prototype.Float = function () {
            var a;
            a = this;
            return $parseFloat(a.object);
        };
        A.prototype.Float = function () {
            return this.$val.Float();
        };
        A.ptr.prototype.Interface = function () {
            var a;
            a = this;
            return $internalize(a.object, $emptyInterface);
        };
        A.prototype.Interface = function () {
            return this.$val.Interface();
        };
        A.ptr.prototype.Unsafe = function () {
            var a;
            a = this;
            return a.object;
        };
        A.prototype.Unsafe = function () {
            return this.$val.Unsafe();
        };
        B.ptr.prototype.Error = function () {
            var a;
            a = this;
            return 'JavaScript error: ' + $internalize(a.Object.message, $String);
        };
        B.prototype.Error = function () {
            return this.$val.Error();
        };
        B.ptr.prototype.Stack = function () {
            var a;
            a = this;
            return $internalize(a.Object.stack, $String);
        };
        B.prototype.Stack = function () {
            return this.$val.Stack();
        };
        K = function () {
            var a;
            a = new B.ptr(null);
            $unused(a);
        };
        N.methods = [
            { prop: 'Get', name: 'Get', pkg: '', typ: $funcType([$String], [N], false) },
            {
                prop: 'Set',
                name: 'Set',
                pkg: '',
                typ: $funcType([$String, $emptyInterface], [], false),
            },
            {
                prop: 'Delete',
                name: 'Delete',
                pkg: '',
                typ: $funcType([$String], [], false),
            },
            {
                prop: 'Length',
                name: 'Length',
                pkg: '',
                typ: $funcType([], [$Int], false),
            },
            { prop: 'Index', name: 'Index', pkg: '', typ: $funcType([$Int], [N], false) },
            {
                prop: 'SetIndex',
                name: 'SetIndex',
                pkg: '',
                typ: $funcType([$Int, $emptyInterface], [], false),
            },
            {
                prop: 'Call',
                name: 'Call',
                pkg: '',
                typ: $funcType([$String, L], [N], true),
            },
            { prop: 'Invoke', name: 'Invoke', pkg: '', typ: $funcType([L], [N], true) },
            { prop: 'New', name: 'New', pkg: '', typ: $funcType([L], [N], true) },
            { prop: 'Bool', name: 'Bool', pkg: '', typ: $funcType([], [$Bool], false) },
            {
                prop: 'String',
                name: 'String',
                pkg: '',
                typ: $funcType([], [$String], false),
            },
            { prop: 'Int', name: 'Int', pkg: '', typ: $funcType([], [$Int], false) },
            {
                prop: 'Int64',
                name: 'Int64',
                pkg: '',
                typ: $funcType([], [$Int64], false),
            },
            {
                prop: 'Uint64',
                name: 'Uint64',
                pkg: '',
                typ: $funcType([], [$Uint64], false),
            },
            {
                prop: 'Float',
                name: 'Float',
                pkg: '',
                typ: $funcType([], [$Float64], false),
            },
            {
                prop: 'Interface',
                name: 'Interface',
                pkg: '',
                typ: $funcType([], [$emptyInterface], false),
            },
            {
                prop: 'Unsafe',
                name: 'Unsafe',
                pkg: '',
                typ: $funcType([], [$Uintptr], false),
            },
        ];
        Q.methods = [
            {
                prop: 'Error',
                name: 'Error',
                pkg: '',
                typ: $funcType([], [$String], false),
            },
            {
                prop: 'Stack',
                name: 'Stack',
                pkg: '',
                typ: $funcType([], [$String], false),
            },
        ];
        A.init('github.com/gopherjs/gopherjs/js', [
            {
                prop: 'object',
                name: 'object',
                anonymous: false,
                exported: false,
                typ: N,
                tag: '',
            },
        ]);
        B.init('', [
            {
                prop: 'Object',
                name: 'Object',
                anonymous: true,
                exported: true,
                typ: N,
                tag: '',
            },
        ]);
        $init = function () {
            $pkg.$init = function () {};
            var $f,
                $c = false,
                $s = 0,
                $r;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        K();
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: $init };
            }
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        $pkg.$init = $init;
        return $pkg;
    })();
    $packages['runtime/internal/sys'] = (function () {
        var $pkg = {},
            $init;
        $init = function () {
            $pkg.$init = function () {};
            var $f,
                $c = false,
                $s = 0,
                $r;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: $init };
            }
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        $pkg.$init = $init;
        return $pkg;
    })();
    $packages['runtime'] = (function () {
        var $pkg = {},
            $init,
            B,
            A,
            AP,
            AQ,
            BF,
            E,
            F,
            N,
            AJ;
        B = $packages['github.com/gopherjs/gopherjs/js'];
        A = $packages['runtime/internal/sys'];
        AP = $pkg.TypeAssertionError = $newType(
            0,
            $kindStruct,
            'runtime.TypeAssertionError',
            true,
            'runtime',
            true,
            function (
                interfaceString_,
                concreteString_,
                assertedString_,
                missingMethod_
            ) {
                this.$val = this;
                if (arguments.length === 0) {
                    this.interfaceString = '';
                    this.concreteString = '';
                    this.assertedString = '';
                    this.missingMethod = '';
                    return;
                }
                this.interfaceString = interfaceString_;
                this.concreteString = concreteString_;
                this.assertedString = assertedString_;
                this.missingMethod = missingMethod_;
            }
        );
        AQ = $pkg.errorString = $newType(
            8,
            $kindString,
            'runtime.errorString',
            true,
            'runtime',
            false,
            null
        );
        BF = $ptrType(AP);
        E = function () {
            var a, b;
            a = $packages[$externalize('github.com/gopherjs/gopherjs/js', $String)];
            $jsObjectPtr = a.Object.ptr;
            $jsErrorPtr = a.Error.ptr;
            $throwRuntimeError = AJ;
            b = $ifaceNil;
            b = new AP.ptr('', '', '', '');
            $unused(b);
        };
        F = function () {
            var a, b;
            a = $global.process;
            if (a === undefined) {
                return '/';
            }
            b = a.env.GOROOT;
            if (!(b === undefined)) {
                return $internalize(b, $String);
            }
            return '/usr/local/go';
        };
        $pkg.GOROOT = F;
        N = function () {
            $curGoroutine.exit = $externalize(true, $Bool);
            $throw(null);
        };
        $pkg.Goexit = N;
        AJ = function (a) {
            var a;
            $panic(new AQ(a));
        };
        AP.ptr.prototype.RuntimeError = function () {};
        AP.prototype.RuntimeError = function () {
            return this.$val.RuntimeError();
        };
        AP.ptr.prototype.Error = function () {
            var a, b;
            a = this;
            b = a.interfaceString;
            if (b === '') {
                b = 'interface';
            }
            if (a.concreteString === '') {
                return 'interface conversion: ' + b + ' is nil, not ' + a.assertedString;
            }
            if (a.missingMethod === '') {
                return (
                    'interface conversion: ' +
                    b +
                    ' is ' +
                    a.concreteString +
                    ', not ' +
                    a.assertedString
                );
            }
            return (
                'interface conversion: ' +
                a.concreteString +
                ' is not ' +
                a.assertedString +
                ': missing method ' +
                a.missingMethod
            );
        };
        AP.prototype.Error = function () {
            return this.$val.Error();
        };
        AQ.prototype.RuntimeError = function () {
            var a;
            a = this.$val;
        };
        $ptrType(AQ).prototype.RuntimeError = function () {
            return new AQ(this.$get()).RuntimeError();
        };
        AQ.prototype.Error = function () {
            var a;
            a = this.$val;
            return 'runtime error: ' + a;
        };
        $ptrType(AQ).prototype.Error = function () {
            return new AQ(this.$get()).Error();
        };
        BF.methods = [
            {
                prop: 'RuntimeError',
                name: 'RuntimeError',
                pkg: '',
                typ: $funcType([], [], false),
            },
            {
                prop: 'Error',
                name: 'Error',
                pkg: '',
                typ: $funcType([], [$String], false),
            },
        ];
        AQ.methods = [
            {
                prop: 'RuntimeError',
                name: 'RuntimeError',
                pkg: '',
                typ: $funcType([], [], false),
            },
            {
                prop: 'Error',
                name: 'Error',
                pkg: '',
                typ: $funcType([], [$String], false),
            },
        ];
        AP.init('runtime', [
            {
                prop: 'interfaceString',
                name: 'interfaceString',
                anonymous: false,
                exported: false,
                typ: $String,
                tag: '',
            },
            {
                prop: 'concreteString',
                name: 'concreteString',
                anonymous: false,
                exported: false,
                typ: $String,
                tag: '',
            },
            {
                prop: 'assertedString',
                name: 'assertedString',
                anonymous: false,
                exported: false,
                typ: $String,
                tag: '',
            },
            {
                prop: 'missingMethod',
                name: 'missingMethod',
                anonymous: false,
                exported: false,
                typ: $String,
                tag: '',
            },
        ]);
        $init = function () {
            $pkg.$init = function () {};
            var $f,
                $c = false,
                $s = 0,
                $r;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        $r = B.$init();
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                        $r = A.$init();
                        $s = 2;
                    case 2:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                        E();
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: $init };
            }
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        $pkg.$init = $init;
        return $pkg;
    })();
    $packages['errors'] = (function () {
        var $pkg = {},
            $init,
            B,
            C,
            A;
        B = $pkg.errorString = $newType(
            0,
            $kindStruct,
            'errors.errorString',
            true,
            'errors',
            false,
            function (s_) {
                this.$val = this;
                if (arguments.length === 0) {
                    this.s = '';
                    return;
                }
                this.s = s_;
            }
        );
        C = $ptrType(B);
        A = function (a) {
            var a;
            return new B.ptr(a);
        };
        $pkg.New = A;
        B.ptr.prototype.Error = function () {
            var a;
            a = this;
            return a.s;
        };
        B.prototype.Error = function () {
            return this.$val.Error();
        };
        C.methods = [
            {
                prop: 'Error',
                name: 'Error',
                pkg: '',
                typ: $funcType([], [$String], false),
            },
        ];
        B.init('errors', [
            {
                prop: 's',
                name: 's',
                anonymous: false,
                exported: false,
                typ: $String,
                tag: '',
            },
        ]);
        $init = function () {
            $pkg.$init = function () {};
            var $f,
                $c = false,
                $s = 0,
                $r;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: $init };
            }
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        $pkg.$init = $init;
        return $pkg;
    })();
    $packages['github.com/gopherjs/gopherjs/nosync'] = (function () {
        var $pkg = {},
            $init,
            E,
            M,
            N;
        E = $pkg.Once = $newType(
            0,
            $kindStruct,
            'nosync.Once',
            true,
            'github.com/gopherjs/gopherjs/nosync',
            true,
            function (doing_, done_) {
                this.$val = this;
                if (arguments.length === 0) {
                    this.doing = false;
                    this.done = false;
                    return;
                }
                this.doing = doing_;
                this.done = done_;
            }
        );
        M = $funcType([], [], false);
        N = $ptrType(E);
        E.ptr.prototype.Do = function (a) {
            var a, b, $s, $deferred, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                a = $f.a;
                b = $f.b;
                $s = $f.$s;
                $deferred = $f.$deferred;
                $r = $f.$r;
            }
            var $err = null;
            try {
                s: while (true) {
                    switch ($s) {
                        case 0:
                            $deferred = [];
                            $deferred.index = $curGoroutine.deferStack.length;
                            $curGoroutine.deferStack.push($deferred);
                            b = [b];
                            b[0] = this;
                            if (b[0].done) {
                                $s = -1;
                                return;
                            }
                            if (b[0].doing) {
                                $panic(new $String('nosync: Do called within f'));
                            }
                            b[0].doing = true;
                            $deferred.push([
                                (function (b) {
                                    return function () {
                                        b[0].doing = false;
                                        b[0].done = true;
                                    };
                                })(b),
                                [],
                            ]);
                            $r = a();
                            $s = 1;
                        case 1:
                            if ($c) {
                                $c = false;
                                $r = $r.$blk();
                            }
                            if ($r && $r.$blk !== undefined) {
                                break s;
                            }
                            $s = -1;
                            return;
                    }
                    return;
                }
            } catch (err) {
                $err = err;
                $s = -1;
            } finally {
                $callDeferred($deferred, $err);
                if ($curGoroutine.asleep) {
                    if ($f === undefined) {
                        $f = { $blk: E.ptr.prototype.Do };
                    }
                    $f.a = a;
                    $f.b = b;
                    $f.$s = $s;
                    $f.$deferred = $deferred;
                    $f.$r = $r;
                    return $f;
                }
            }
        };
        E.prototype.Do = function (a) {
            return this.$val.Do(a);
        };
        N.methods = [{ prop: 'Do', name: 'Do', pkg: '', typ: $funcType([M], [], false) }];
        E.init('github.com/gopherjs/gopherjs/nosync', [
            {
                prop: 'doing',
                name: 'doing',
                anonymous: false,
                exported: false,
                typ: $Bool,
                tag: '',
            },
            {
                prop: 'done',
                name: 'done',
                anonymous: false,
                exported: false,
                typ: $Bool,
                tag: '',
            },
        ]);
        $init = function () {
            $pkg.$init = function () {};
            var $f,
                $c = false,
                $s = 0,
                $r;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: $init };
            }
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        $pkg.$init = $init;
        return $pkg;
    })();
    $packages['internal/race'] = (function () {
        var $pkg = {},
            $init,
            A,
            B;
        A = function (a) {
            var a;
        };
        $pkg.Acquire = A;
        B = function (a) {
            var a;
        };
        $pkg.Release = B;
        $init = function () {
            $pkg.$init = function () {};
            var $f,
                $c = false,
                $s = 0,
                $r;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: $init };
            }
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        $pkg.$init = $init;
        return $pkg;
    })();
    $packages['sync/atomic'] = (function () {
        var $pkg = {},
            $init,
            A,
            H,
            N;
        A = $packages['github.com/gopherjs/gopherjs/js'];
        H = function (ad, ae, af) {
            var ad, ae, af;
            if (ad.$get() === ae) {
                ad.$set(af);
                return true;
            }
            return false;
        };
        $pkg.CompareAndSwapInt32 = H;
        N = function (ad, ae) {
            var ad, ae, af;
            af = (ad.$get() + ae) >> 0;
            ad.$set(af);
            return af;
        };
        $pkg.AddInt32 = N;
        $init = function () {
            $pkg.$init = function () {};
            var $f,
                $c = false,
                $s = 0,
                $r;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        $r = A.$init();
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: $init };
            }
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        $pkg.$init = $init;
        return $pkg;
    })();
    $packages['sync'] = (function () {
        var $pkg = {},
            $init,
            A,
            C,
            D,
            B,
            F,
            Z,
            AC,
            AD,
            AO,
            AY,
            AZ,
            BA,
            BB,
            BC,
            BI,
            BL,
            BM,
            BQ,
            CA,
            CD,
            H,
            I,
            W,
            AJ,
            G,
            K,
            L,
            M,
            N,
            O,
            P,
            AH,
            AK,
            AL,
            AT,
            AU;
        A = $packages['github.com/gopherjs/gopherjs/js'];
        C = $packages['internal/race'];
        D = $packages['runtime'];
        B = $packages['sync/atomic'];
        F = $pkg.Pool = $newType(
            0,
            $kindStruct,
            'sync.Pool',
            true,
            'sync',
            true,
            function (local_, localSize_, store_, New_) {
                this.$val = this;
                if (arguments.length === 0) {
                    this.local = 0;
                    this.localSize = 0;
                    this.store = BM.nil;
                    this.New = $throwNilPointerError;
                    return;
                }
                this.local = local_;
                this.localSize = localSize_;
                this.store = store_;
                this.New = New_;
            }
        );
        Z = $pkg.Mutex = $newType(
            0,
            $kindStruct,
            'sync.Mutex',
            true,
            'sync',
            true,
            function (state_, sema_) {
                this.$val = this;
                if (arguments.length === 0) {
                    this.state = 0;
                    this.sema = 0;
                    return;
                }
                this.state = state_;
                this.sema = sema_;
            }
        );
        AC = $pkg.poolLocalInternal = $newType(
            0,
            $kindStruct,
            'sync.poolLocalInternal',
            true,
            'sync',
            false,
            function (private$0_, shared_, Mutex_) {
                this.$val = this;
                if (arguments.length === 0) {
                    this.private$0 = $ifaceNil;
                    this.shared = BM.nil;
                    this.Mutex = new Z.ptr(0, 0);
                    return;
                }
                this.private$0 = private$0_;
                this.shared = shared_;
                this.Mutex = Mutex_;
            }
        );
        AD = $pkg.poolLocal = $newType(
            0,
            $kindStruct,
            'sync.poolLocal',
            true,
            'sync',
            false,
            function (poolLocalInternal_, pad_) {
                this.$val = this;
                if (arguments.length === 0) {
                    this.poolLocalInternal = new AC.ptr(
                        $ifaceNil,
                        BM.nil,
                        new Z.ptr(0, 0)
                    );
                    this.pad = CD.zero();
                    return;
                }
                this.poolLocalInternal = poolLocalInternal_;
                this.pad = pad_;
            }
        );
        AO = $pkg.notifyList = $newType(
            0,
            $kindStruct,
            'sync.notifyList',
            true,
            'sync',
            false,
            function (wait_, notify_, lock_, head_, tail_) {
                this.$val = this;
                if (arguments.length === 0) {
                    this.wait = 0;
                    this.notify = 0;
                    this.lock = 0;
                    this.head = 0;
                    this.tail = 0;
                    return;
                }
                this.wait = wait_;
                this.notify = notify_;
                this.lock = lock_;
                this.head = head_;
                this.tail = tail_;
            }
        );
        AY = $ptrType(F);
        AZ = $sliceType(AY);
        BA = $ptrType($Uint32);
        BB = $chanType($Bool, false, false);
        BC = $sliceType(BB);
        BI = $ptrType($Int32);
        BL = $ptrType(AD);
        BM = $sliceType($emptyInterface);
        BQ = $funcType([], [$emptyInterface], false);
        CA = $ptrType(Z);
        CD = $arrayType($Uint8, 100);
        F.ptr.prototype.Get = function () {
            var l, m, n, o, p, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                l = $f.l;
                m = $f.m;
                n = $f.n;
                o = $f.o;
                p = $f.p;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        l = this;
                        if (l.store.$length === 0) {
                            $s = 1;
                            continue;
                        }
                        $s = 2;
                        continue;
                    case 1:
                        if (!(l.New === $throwNilPointerError)) {
                            $s = 3;
                            continue;
                        }
                        $s = 4;
                        continue;
                    case 3:
                        m = l.New();
                        $s = 5;
                    case 5:
                        if ($c) {
                            $c = false;
                            m = m.$blk();
                        }
                        if (m && m.$blk !== undefined) {
                            break s;
                        }
                        $s = -1;
                        return m;
                    case 4:
                        $s = -1;
                        return $ifaceNil;
                    case 2:
                        p =
                            ((n = l.store),
                            (o = (l.store.$length - 1) >> 0),
                            o < 0 || o >= n.$length
                                ? ($throwRuntimeError('index out of range'), undefined)
                                : n.$array[n.$offset + o]);
                        l.store = $subslice(l.store, 0, (l.store.$length - 1) >> 0);
                        $s = -1;
                        return p;
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: F.ptr.prototype.Get };
            }
            $f.l = l;
            $f.m = m;
            $f.n = n;
            $f.o = o;
            $f.p = p;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        F.prototype.Get = function () {
            return this.$val.Get();
        };
        F.ptr.prototype.Put = function (l) {
            var l, m;
            m = this;
            if ($interfaceIsEqual(l, $ifaceNil)) {
                return;
            }
            m.store = $append(m.store, l);
        };
        F.prototype.Put = function (l) {
            return this.$val.Put(l);
        };
        G = function (l) {
            var l;
        };
        K = function (l, m) {
            var l, m, n, o, p, q, r, s, t, u, v, w, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                l = $f.l;
                m = $f.m;
                n = $f.n;
                o = $f.o;
                p = $f.p;
                q = $f.q;
                r = $f.r;
                s = $f.s;
                t = $f.t;
                u = $f.u;
                v = $f.v;
                w = $f.w;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        if (
                            (l.$get() -
                                ((n = I[BA.keyFor(l)]), n !== undefined ? n.v : 0)) >>>
                                0 ===
                            0
                        ) {
                            $s = 1;
                            continue;
                        }
                        $s = 2;
                        continue;
                    case 1:
                        o = new $Chan($Bool, 0);
                        if (m) {
                            p = l;
                            (H || $throwRuntimeError('assignment to entry in nil map'))[
                                BA.keyFor(p)
                            ] = {
                                k: p,
                                v: $appendSlice(
                                    new BC([o]),
                                    ((q = H[BA.keyFor(l)]),
                                    q !== undefined ? q.v : BC.nil)
                                ),
                            };
                        } else {
                            r = l;
                            (H || $throwRuntimeError('assignment to entry in nil map'))[
                                BA.keyFor(r)
                            ] = {
                                k: r,
                                v: $append(
                                    ((s = H[BA.keyFor(l)]),
                                    s !== undefined ? s.v : BC.nil),
                                    o
                                ),
                            };
                        }
                        t = $recv(o);
                        $s = 3;
                    case 3:
                        if ($c) {
                            $c = false;
                            t = t.$blk();
                        }
                        if (t && t.$blk !== undefined) {
                            break s;
                        }
                        t[0];
                        u = l;
                        (I || $throwRuntimeError('assignment to entry in nil map'))[
                            BA.keyFor(u)
                        ] = {
                            k: u,
                            v:
                                (((v = I[BA.keyFor(l)]), v !== undefined ? v.v : 0) -
                                    1) >>>
                                0,
                        };
                        if (((w = I[BA.keyFor(l)]), w !== undefined ? w.v : 0) === 0) {
                            delete I[BA.keyFor(l)];
                        }
                    case 2:
                        l.$set((l.$get() - 1) >>> 0);
                        $s = -1;
                        return;
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: K };
            }
            $f.l = l;
            $f.m = m;
            $f.n = n;
            $f.o = o;
            $f.p = p;
            $f.q = q;
            $f.r = r;
            $f.s = s;
            $f.t = t;
            $f.u = u;
            $f.v = v;
            $f.w = w;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        L = function (l, m) {
            var l, m, n, o, p, q, r, s, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                l = $f.l;
                m = $f.m;
                n = $f.n;
                o = $f.o;
                p = $f.p;
                q = $f.q;
                r = $f.r;
                s = $f.s;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        l.$set((l.$get() + 1) >>> 0);
                        o = ((n = H[BA.keyFor(l)]), n !== undefined ? n.v : BC.nil);
                        if (o.$length === 0) {
                            $s = -1;
                            return;
                        }
                        p =
                            0 >= o.$length
                                ? ($throwRuntimeError('index out of range'), undefined)
                                : o.$array[o.$offset + 0];
                        o = $subslice(o, 1);
                        q = l;
                        (H || $throwRuntimeError('assignment to entry in nil map'))[
                            BA.keyFor(q)
                        ] = { k: q, v: o };
                        if (o.$length === 0) {
                            delete H[BA.keyFor(l)];
                        }
                        r = l;
                        (I || $throwRuntimeError('assignment to entry in nil map'))[
                            BA.keyFor(r)
                        ] = {
                            k: r,
                            v:
                                (((s = I[BA.keyFor(l)]), s !== undefined ? s.v : 0) +
                                    1) >>>
                                0,
                        };
                        $r = $send(p, true);
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                        $s = -1;
                        return;
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: L };
            }
            $f.l = l;
            $f.m = m;
            $f.n = n;
            $f.o = o;
            $f.p = p;
            $f.q = q;
            $f.r = r;
            $f.s = s;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        M = function (l) {
            var l;
        };
        N = function (l) {
            var l;
            return false;
        };
        O = function () {
            return $mul64(
                $internalize(new $global.Date().getTime(), $Int64),
                new $Int64(0, 1000000)
            );
        };
        P = function (l) {
            var l;
            $throwRuntimeError($externalize(l, $String));
        };
        Z.ptr.prototype.Lock = function () {
            var l, m, n, o, p, q, r, s, t, u, v, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                l = $f.l;
                m = $f.m;
                n = $f.n;
                o = $f.o;
                p = $f.p;
                q = $f.q;
                r = $f.r;
                s = $f.s;
                t = $f.t;
                u = $f.u;
                v = $f.v;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        l = this;
                        if (
                            B.CompareAndSwapInt32(
                                l.$ptr_state ||
                                    (l.$ptr_state = new BI(
                                        function () {
                                            return this.$target.state;
                                        },
                                        function ($v) {
                                            this.$target.state = $v;
                                        },
                                        l
                                    )),
                                0,
                                1
                            )
                        ) {
                            if (false) {
                                C.Acquire(l);
                            }
                            $s = -1;
                            return;
                        }
                        m = new $Int64(0, 0);
                        n = false;
                        o = false;
                        p = 0;
                        q = l.state;
                    case 1:
                        if ((q & 5) === 1 && N(p)) {
                            $s = 3;
                            continue;
                        }
                        $s = 4;
                        continue;
                    case 3:
                        if (
                            !o &&
                            (q & 2) === 0 &&
                            !((q >> 3) >> 0 === 0) &&
                            B.CompareAndSwapInt32(
                                l.$ptr_state ||
                                    (l.$ptr_state = new BI(
                                        function () {
                                            return this.$target.state;
                                        },
                                        function ($v) {
                                            this.$target.state = $v;
                                        },
                                        l
                                    )),
                                q,
                                q | 2
                            )
                        ) {
                            o = true;
                        }
                        AU();
                        p = (p + 1) >> 0;
                        q = l.state;
                        $s = 1;
                        continue;
                    case 4:
                        r = q;
                        if ((q & 4) === 0) {
                            r = r | 1;
                        }
                        if (!((q & 5) === 0)) {
                            r = (r + 8) >> 0;
                        }
                        if (n && !((q & 1) === 0)) {
                            r = r | 4;
                        }
                        if (o) {
                            if ((r & 2) === 0) {
                                P('sync: inconsistent mutex state');
                            }
                            r = (r & ~2) >> 0;
                        }
                        if (
                            B.CompareAndSwapInt32(
                                l.$ptr_state ||
                                    (l.$ptr_state = new BI(
                                        function () {
                                            return this.$target.state;
                                        },
                                        function ($v) {
                                            this.$target.state = $v;
                                        },
                                        l
                                    )),
                                q,
                                r
                            )
                        ) {
                            $s = 5;
                            continue;
                        }
                        $s = 6;
                        continue;
                    case 5:
                        if ((q & 5) === 0) {
                            $s = 2;
                            continue;
                        }
                        s = !(m.$high === 0 && m.$low === 0);
                        if (m.$high === 0 && m.$low === 0) {
                            m = O();
                        }
                        $r = K(
                            l.$ptr_sema ||
                                (l.$ptr_sema = new BA(
                                    function () {
                                        return this.$target.sema;
                                    },
                                    function ($v) {
                                        this.$target.sema = $v;
                                    },
                                    l
                                )),
                            s
                        );
                        $s = 8;
                    case 8:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                        n =
                            n ||
                            ((t =
                                ((u = O()),
                                new $Int64(u.$high - m.$high, u.$low - m.$low))),
                            t.$high > 0 || (t.$high === 0 && t.$low > 1000000));
                        q = l.state;
                        if (!((q & 4) === 0)) {
                            if (!((q & 3) === 0) || (q >> 3) >> 0 === 0) {
                                P('sync: inconsistent mutex state');
                            }
                            v = -7;
                            if (!n || (q >> 3) >> 0 === 1) {
                                v = (v - 4) >> 0;
                            }
                            B.AddInt32(
                                l.$ptr_state ||
                                    (l.$ptr_state = new BI(
                                        function () {
                                            return this.$target.state;
                                        },
                                        function ($v) {
                                            this.$target.state = $v;
                                        },
                                        l
                                    )),
                                v
                            );
                            $s = 2;
                            continue;
                        }
                        o = true;
                        p = 0;
                        $s = 7;
                        continue;
                    case 6:
                        q = l.state;
                    case 7:
                        $s = 1;
                        continue;
                    case 2:
                        if (false) {
                            C.Acquire(l);
                        }
                        $s = -1;
                        return;
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: Z.ptr.prototype.Lock };
            }
            $f.l = l;
            $f.m = m;
            $f.n = n;
            $f.o = o;
            $f.p = p;
            $f.q = q;
            $f.r = r;
            $f.s = s;
            $f.t = t;
            $f.u = u;
            $f.v = v;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        Z.prototype.Lock = function () {
            return this.$val.Lock();
        };
        Z.ptr.prototype.Unlock = function () {
            var l, m, n, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                l = $f.l;
                m = $f.m;
                n = $f.n;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        l = this;
                        if (false) {
                            $unused(l.state);
                            C.Release(l);
                        }
                        m = B.AddInt32(
                            l.$ptr_state ||
                                (l.$ptr_state = new BI(
                                    function () {
                                        return this.$target.state;
                                    },
                                    function ($v) {
                                        this.$target.state = $v;
                                    },
                                    l
                                )),
                            -1
                        );
                        if ((((m + 1) >> 0) & 1) === 0) {
                            P('sync: unlock of unlocked mutex');
                        }
                        if ((m & 4) === 0) {
                            $s = 1;
                            continue;
                        }
                        $s = 2;
                        continue;
                    case 1:
                        n = m;
                    case 4:
                        if ((n >> 3) >> 0 === 0 || !((n & 7) === 0)) {
                            $s = -1;
                            return;
                        }
                        m = ((n - 8) >> 0) | 2;
                        if (
                            B.CompareAndSwapInt32(
                                l.$ptr_state ||
                                    (l.$ptr_state = new BI(
                                        function () {
                                            return this.$target.state;
                                        },
                                        function ($v) {
                                            this.$target.state = $v;
                                        },
                                        l
                                    )),
                                n,
                                m
                            )
                        ) {
                            $s = 6;
                            continue;
                        }
                        $s = 7;
                        continue;
                    case 6:
                        $r = L(
                            l.$ptr_sema ||
                                (l.$ptr_sema = new BA(
                                    function () {
                                        return this.$target.sema;
                                    },
                                    function ($v) {
                                        this.$target.sema = $v;
                                    },
                                    l
                                )),
                            false
                        );
                        $s = 8;
                    case 8:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                        $s = -1;
                        return;
                    case 7:
                        n = l.state;
                        $s = 4;
                        continue;
                    case 5:
                        $s = 3;
                        continue;
                    case 2:
                        $r = L(
                            l.$ptr_sema ||
                                (l.$ptr_sema = new BA(
                                    function () {
                                        return this.$target.sema;
                                    },
                                    function ($v) {
                                        this.$target.sema = $v;
                                    },
                                    l
                                )),
                            true
                        );
                        $s = 9;
                    case 9:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                    case 3:
                        $s = -1;
                        return;
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: Z.ptr.prototype.Unlock };
            }
            $f.l = l;
            $f.m = m;
            $f.n = n;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        Z.prototype.Unlock = function () {
            return this.$val.Unlock();
        };
        AH = function () {
            var l, m, n, o, p, q, r, s, t, u;
            l = AJ;
            m = 0;
            while (true) {
                if (!(m < l.$length)) {
                    break;
                }
                n = m;
                o =
                    m < 0 || m >= l.$length
                        ? ($throwRuntimeError('index out of range'), undefined)
                        : l.$array[l.$offset + m];
                n < 0 || n >= AJ.$length
                    ? ($throwRuntimeError('index out of range'), undefined)
                    : (AJ.$array[AJ.$offset + n] = AY.nil);
                p = 0;
                while (true) {
                    if (!(p < o.localSize >> 0)) {
                        break;
                    }
                    q = AL(o.local, p);
                    q.poolLocalInternal.private$0 = $ifaceNil;
                    r = q.poolLocalInternal.shared;
                    s = 0;
                    while (true) {
                        if (!(s < r.$length)) {
                            break;
                        }
                        t = s;
                        (u = q.poolLocalInternal.shared),
                            t < 0 || t >= u.$length
                                ? ($throwRuntimeError('index out of range'), undefined)
                                : (u.$array[u.$offset + t] = $ifaceNil);
                        s++;
                    }
                    q.poolLocalInternal.shared = BM.nil;
                    p = (p + 1) >> 0;
                }
                o.local = 0;
                o.localSize = 0;
                m++;
            }
            AJ = new AZ([]);
        };
        AK = function () {
            G(AH);
        };
        AL = function (l, m) {
            var l, m, n;
            n = (l + ($imul(m >>> 0, 128) >>> 0)) >>> 0;
            return $pointerOfStructConversion(n, BL);
        };
        AT = function () {
            var l;
            l = new AO.ptr(0, 0, 0, 0, 0);
            M(20);
        };
        AU = function () {
            $throwRuntimeError('native function not implemented: sync.runtime_doSpin');
        };
        AY.methods = [
            {
                prop: 'Get',
                name: 'Get',
                pkg: '',
                typ: $funcType([], [$emptyInterface], false),
            },
            {
                prop: 'Put',
                name: 'Put',
                pkg: '',
                typ: $funcType([$emptyInterface], [], false),
            },
            {
                prop: 'getSlow',
                name: 'getSlow',
                pkg: 'sync',
                typ: $funcType([], [$emptyInterface], false),
            },
            { prop: 'pin', name: 'pin', pkg: 'sync', typ: $funcType([], [BL], false) },
            {
                prop: 'pinSlow',
                name: 'pinSlow',
                pkg: 'sync',
                typ: $funcType([], [BL], false),
            },
        ];
        CA.methods = [
            { prop: 'Lock', name: 'Lock', pkg: '', typ: $funcType([], [], false) },
            { prop: 'Unlock', name: 'Unlock', pkg: '', typ: $funcType([], [], false) },
        ];
        F.init('sync', [
            {
                prop: 'local',
                name: 'local',
                anonymous: false,
                exported: false,
                typ: $UnsafePointer,
                tag: '',
            },
            {
                prop: 'localSize',
                name: 'localSize',
                anonymous: false,
                exported: false,
                typ: $Uintptr,
                tag: '',
            },
            {
                prop: 'store',
                name: 'store',
                anonymous: false,
                exported: false,
                typ: BM,
                tag: '',
            },
            {
                prop: 'New',
                name: 'New',
                anonymous: false,
                exported: true,
                typ: BQ,
                tag: '',
            },
        ]);
        Z.init('sync', [
            {
                prop: 'state',
                name: 'state',
                anonymous: false,
                exported: false,
                typ: $Int32,
                tag: '',
            },
            {
                prop: 'sema',
                name: 'sema',
                anonymous: false,
                exported: false,
                typ: $Uint32,
                tag: '',
            },
        ]);
        AC.init('sync', [
            {
                prop: 'private$0',
                name: 'private',
                anonymous: false,
                exported: false,
                typ: $emptyInterface,
                tag: '',
            },
            {
                prop: 'shared',
                name: 'shared',
                anonymous: false,
                exported: false,
                typ: BM,
                tag: '',
            },
            {
                prop: 'Mutex',
                name: 'Mutex',
                anonymous: true,
                exported: true,
                typ: Z,
                tag: '',
            },
        ]);
        AD.init('sync', [
            {
                prop: 'poolLocalInternal',
                name: 'poolLocalInternal',
                anonymous: true,
                exported: false,
                typ: AC,
                tag: '',
            },
            {
                prop: 'pad',
                name: 'pad',
                anonymous: false,
                exported: false,
                typ: CD,
                tag: '',
            },
        ]);
        AO.init('sync', [
            {
                prop: 'wait',
                name: 'wait',
                anonymous: false,
                exported: false,
                typ: $Uint32,
                tag: '',
            },
            {
                prop: 'notify',
                name: 'notify',
                anonymous: false,
                exported: false,
                typ: $Uint32,
                tag: '',
            },
            {
                prop: 'lock',
                name: 'lock',
                anonymous: false,
                exported: false,
                typ: $Uintptr,
                tag: '',
            },
            {
                prop: 'head',
                name: 'head',
                anonymous: false,
                exported: false,
                typ: $UnsafePointer,
                tag: '',
            },
            {
                prop: 'tail',
                name: 'tail',
                anonymous: false,
                exported: false,
                typ: $UnsafePointer,
                tag: '',
            },
        ]);
        $init = function () {
            $pkg.$init = function () {};
            var $f,
                $c = false,
                $s = 0,
                $r;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        $r = A.$init();
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                        $r = C.$init();
                        $s = 2;
                    case 2:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                        $r = D.$init();
                        $s = 3;
                    case 3:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                        $r = B.$init();
                        $s = 4;
                    case 4:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                        AJ = AZ.nil;
                        H = {};
                        I = {};
                        W = new Uint8Array(8);
                        AK();
                        AT();
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: $init };
            }
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        $pkg.$init = $init;
        return $pkg;
    })();
    $packages['syscall'] = (function () {
        var $pkg = {},
            $init,
            D,
            A,
            E,
            B,
            C,
            FI,
            FJ,
            NC,
            NE,
            NL,
            OO,
            PA,
            PM,
            PN,
            PO,
            PP,
            F,
            G,
            P,
            Q,
            R,
            AY,
            CH,
            CI,
            EK,
            FK,
            FL,
            FM,
            GS,
            H,
            I,
            J,
            M,
            N,
            S,
            T,
            U,
            CJ,
            DG,
            DH,
            FN,
            KY,
            KZ;
        D = $packages['errors'];
        A = $packages['github.com/gopherjs/gopherjs/js'];
        E = $packages['internal/race'];
        B = $packages['runtime'];
        C = $packages['sync'];
        FI = $pkg.mmapper = $newType(
            0,
            $kindStruct,
            'syscall.mmapper',
            true,
            'syscall',
            false,
            function (Mutex_, active_, mmap_, munmap_) {
                this.$val = this;
                if (arguments.length === 0) {
                    this.Mutex = new C.Mutex.ptr(0, 0);
                    this.active = false;
                    this.mmap = $throwNilPointerError;
                    this.munmap = $throwNilPointerError;
                    return;
                }
                this.Mutex = Mutex_;
                this.active = active_;
                this.mmap = mmap_;
                this.munmap = munmap_;
            }
        );
        FJ = $pkg.Errno = $newType(
            4,
            $kindUintptr,
            'syscall.Errno',
            true,
            'syscall',
            true,
            null
        );
        NC = $sliceType($Uint8);
        NE = $sliceType($String);
        NL = $ptrType($Uint8);
        OO = $arrayType($Uint8, 32);
        PA = $structType('syscall', [
            {
                prop: 'addr',
                name: 'addr',
                anonymous: false,
                exported: false,
                typ: $Uintptr,
                tag: '',
            },
            {
                prop: 'len',
                name: 'len',
                anonymous: false,
                exported: false,
                typ: $Int,
                tag: '',
            },
            {
                prop: 'cap',
                name: 'cap',
                anonymous: false,
                exported: false,
                typ: $Int,
                tag: '',
            },
        ]);
        PM = $ptrType(FI);
        PN = $mapType(NL, NC);
        PO = $funcType(
            [$Uintptr, $Uintptr, $Int, $Int, $Int, $Int64],
            [$Uintptr, $error],
            false
        );
        PP = $funcType([$Uintptr, $Uintptr], [$error], false);
        H = function () {
            $flushConsole = function () {
                if (!(G.$length === 0)) {
                    $global.console.log($externalize($bytesToString(G), $String));
                    G = NC.nil;
                }
            };
        };
        I = function () {
            if (!F) {
                $global.console.error(
                    $externalize(
                        'warning: system calls not available, see https://github.com/gopherjs/gopherjs/blob/master/doc/syscalls.md',
                        $String
                    )
                );
            }
            F = true;
        };
        J = function (i) {
            var i, j, k;
            j = $global.goPrintToConsole;
            if (!(j === undefined)) {
                j(i);
                return;
            }
            G = $appendSlice(G, i);
            while (true) {
                k = M(G, 10);
                if (k === -1) {
                    break;
                }
                $global.console.log(
                    $externalize($bytesToString($subslice(G, 0, k)), $String)
                );
                G = $subslice(G, (k + 1) >> 0);
            }
        };
        M = function (i, j) {
            var i, j, k, l, m, n;
            k = i;
            l = 0;
            while (true) {
                if (!(l < k.$length)) {
                    break;
                }
                m = l;
                n =
                    l < 0 || l >= k.$length
                        ? ($throwRuntimeError('index out of range'), undefined)
                        : k.$array[k.$offset + l];
                if (n === j) {
                    return m;
                }
                l++;
            }
            return -1;
        };
        N = function () {
            var i, j, k, l, m, n;
            i = $global.process;
            if (i === undefined) {
                return NE.nil;
            }
            j = i.env;
            k = $global.Object.keys(j);
            l = $makeSlice(NE, $parseInt(k.length));
            m = 0;
            while (true) {
                if (!(m < $parseInt(k.length))) {
                    break;
                }
                n = $internalize(k[m], $String);
                m < 0 || m >= l.$length
                    ? ($throwRuntimeError('index out of range'), undefined)
                    : (l.$array[l.$offset + m] =
                          n + '=' + $internalize(j[$externalize(n, $String)], $String));
                m = (m + 1) >> 0;
            }
            return l;
        };
        S = function (i) {
            var i, j, $deferred;
            var $err = null;
            try {
                $deferred = [];
                $deferred.index = $curGoroutine.deferStack.length;
                $curGoroutine.deferStack.push($deferred);
                $deferred.push([
                    function () {
                        $recover();
                    },
                    [],
                ]);
                if (P === null) {
                    if (Q) {
                        return null;
                    }
                    Q = true;
                    j = $global.require;
                    if (j === undefined) {
                        $panic(new $String(''));
                    }
                    P = j($externalize('syscall', $String));
                }
                return P[$externalize(i, $String)];
            } catch (err) {
                $err = err;
                return null;
            } finally {
                $callDeferred($deferred, $err);
            }
        };
        T = function (i, j, k, l) {
            var aa, ab, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, x, y, z;
            m = 0;
            n = 0;
            o = 0;
            p = S('Syscall');
            if (!(p === null)) {
                q = p(i, j, k, l);
                r = ($parseInt(q[0]) >> 0) >>> 0;
                s = ($parseInt(q[1]) >> 0) >>> 0;
                t = ($parseInt(q[2]) >> 0) >>> 0;
                m = r;
                n = s;
                o = t;
                return [m, n, o];
            }
            if (i === 4 && (j === 1 || j === 2)) {
                u = k;
                v = $makeSlice(NC, $parseInt(u.length));
                v.$array = u;
                J(v);
                w = $parseInt(u.length) >>> 0;
                x = 0;
                y = 0;
                m = w;
                n = x;
                o = y;
                return [m, n, o];
            }
            if (i === 1) {
                B.Goexit();
            }
            I();
            z = R >>> 0;
            aa = 0;
            ab = 13;
            m = z;
            n = aa;
            o = ab;
            return [m, n, o];
        };
        $pkg.Syscall = T;
        U = function (i, j, k, l, m, n, o) {
            var i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, x, y, z;
            p = 0;
            q = 0;
            r = 0;
            s = S('Syscall6');
            if (!(s === null)) {
                t = s(i, j, k, l, m, n, o);
                u = ($parseInt(t[0]) >> 0) >>> 0;
                v = ($parseInt(t[1]) >> 0) >>> 0;
                w = ($parseInt(t[2]) >> 0) >>> 0;
                p = u;
                q = v;
                r = w;
                return [p, q, r];
            }
            if (!(i === 202)) {
                I();
            }
            x = R >>> 0;
            y = 0;
            z = 13;
            p = x;
            q = y;
            r = z;
            return [p, q, r];
        };
        $pkg.Syscall6 = U;
        CJ = function (i) {
            var i, j;
            j = 8;
            if (true) {
                j = 4;
            } else if (false) {
                j = 8;
            } else if (false) {
                if (CH === 'amd64') {
                    j = 8;
                }
            }
            if (i === 0) {
                return j;
            }
            return ((((i + j) >> 0) - 1) >> 0) & (~((j - 1) >> 0) >> 0);
        };
        DG = function (i) {
            var i;
            if (i < 0) {
                return '-' + DH(-i >>> 0);
            }
            return DH(i >>> 0);
        };
        DH = function (i) {
            var i, j, k, l, m;
            j = OO.zero();
            k = 31;
            while (true) {
                if (!(i >= 10)) {
                    break;
                }
                k < 0 || k >= j.length
                    ? ($throwRuntimeError('index out of range'), undefined)
                    : (j[k] =
                          (((((l = i % 10),
                          l === l ? l : $throwRuntimeError('integer divide by zero')) +
                              48) >>>
                              0) <<
                              24) >>>
                          24);
                k = (k - 1) >> 0;
                i =
                    ((m = i / 10),
                    m === m && m !== 1 / 0 && m !== -1 / 0
                        ? m >>> 0
                        : $throwRuntimeError('integer divide by zero'));
            }
            k < 0 || k >= j.length
                ? ($throwRuntimeError('index out of range'), undefined)
                : (j[k] = (((i + 48) >>> 0) << 24) >>> 24);
            return $bytesToString($subslice(new NC(j), k));
        };
        FI.ptr.prototype.Mmap = function (i, j, k, l, m) {
            var aa,
                ab,
                ac,
                ad,
                i,
                j,
                k,
                l,
                m,
                n,
                o,
                p,
                q,
                r,
                s,
                t,
                u,
                v,
                w,
                x,
                y,
                z,
                $s,
                $deferred,
                $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                aa = $f.aa;
                ab = $f.ab;
                ac = $f.ac;
                ad = $f.ad;
                i = $f.i;
                j = $f.j;
                k = $f.k;
                l = $f.l;
                m = $f.m;
                n = $f.n;
                o = $f.o;
                p = $f.p;
                q = $f.q;
                r = $f.r;
                s = $f.s;
                t = $f.t;
                u = $f.u;
                v = $f.v;
                w = $f.w;
                x = $f.x;
                y = $f.y;
                z = $f.z;
                $s = $f.$s;
                $deferred = $f.$deferred;
                $r = $f.$r;
            }
            var $err = null;
            try {
                s: while (true) {
                    switch ($s) {
                        case 0:
                            $deferred = [];
                            $deferred.index = $curGoroutine.deferStack.length;
                            $curGoroutine.deferStack.push($deferred);
                            n = [n];
                            o = NC.nil;
                            p = $ifaceNil;
                            q = this;
                            if (k <= 0) {
                                r = NC.nil;
                                s = new FJ(22);
                                o = r;
                                p = s;
                                $s = -1;
                                return [o, p];
                            }
                            u = q.mmap(0, k >>> 0, l, m, i, j);
                            $s = 1;
                        case 1:
                            if ($c) {
                                $c = false;
                                u = u.$blk();
                            }
                            if (u && u.$blk !== undefined) {
                                break s;
                            }
                            t = u;
                            v = t[0];
                            w = t[1];
                            if (!$interfaceIsEqual(w, $ifaceNil)) {
                                x = NC.nil;
                                y = w;
                                o = x;
                                p = y;
                                $s = -1;
                                return [o, p];
                            }
                            n[0] = new PA.ptr(v, k, k);
                            z = n[0];
                            aa = $indexPtr(
                                z.$array,
                                z.$offset + ((z.$capacity - 1) >> 0),
                                NL
                            );
                            $r = q.Mutex.Lock();
                            $s = 2;
                        case 2:
                            if ($c) {
                                $c = false;
                                $r = $r.$blk();
                            }
                            if ($r && $r.$blk !== undefined) {
                                break s;
                            }
                            $deferred.push([$methodVal(q.Mutex, 'Unlock'), []]);
                            ab = aa;
                            (q.active ||
                                $throwRuntimeError('assignment to entry in nil map'))[
                                NL.keyFor(ab)
                            ] = { k: ab, v: z };
                            ac = z;
                            ad = $ifaceNil;
                            o = ac;
                            p = ad;
                            $s = -1;
                            return [o, p];
                    }
                    return;
                }
            } catch (err) {
                $err = err;
                $s = -1;
            } finally {
                $callDeferred($deferred, $err);
                if (!$curGoroutine.asleep) {
                    return [o, p];
                }
                if ($curGoroutine.asleep) {
                    if ($f === undefined) {
                        $f = { $blk: FI.ptr.prototype.Mmap };
                    }
                    $f.aa = aa;
                    $f.ab = ab;
                    $f.ac = ac;
                    $f.ad = ad;
                    $f.i = i;
                    $f.j = j;
                    $f.k = k;
                    $f.l = l;
                    $f.m = m;
                    $f.n = n;
                    $f.o = o;
                    $f.p = p;
                    $f.q = q;
                    $f.r = r;
                    $f.s = s;
                    $f.t = t;
                    $f.u = u;
                    $f.v = v;
                    $f.w = w;
                    $f.x = x;
                    $f.y = y;
                    $f.z = z;
                    $f.$s = $s;
                    $f.$deferred = $deferred;
                    $f.$r = $r;
                    return $f;
                }
            }
        };
        FI.prototype.Mmap = function (i, j, k, l, m) {
            return this.$val.Mmap(i, j, k, l, m);
        };
        FI.ptr.prototype.Munmap = function (i) {
            var i, j, k, l, m, n, o, p, $s, $deferred, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                i = $f.i;
                j = $f.j;
                k = $f.k;
                l = $f.l;
                m = $f.m;
                n = $f.n;
                o = $f.o;
                p = $f.p;
                $s = $f.$s;
                $deferred = $f.$deferred;
                $r = $f.$r;
            }
            var $err = null;
            try {
                s: while (true) {
                    switch ($s) {
                        case 0:
                            $deferred = [];
                            $deferred.index = $curGoroutine.deferStack.length;
                            $curGoroutine.deferStack.push($deferred);
                            j = $ifaceNil;
                            k = this;
                            if (i.$length === 0 || !(i.$length === i.$capacity)) {
                                j = new FJ(22);
                                $s = -1;
                                return j;
                            }
                            l = $indexPtr(
                                i.$array,
                                i.$offset + ((i.$capacity - 1) >> 0),
                                NL
                            );
                            $r = k.Mutex.Lock();
                            $s = 1;
                        case 1:
                            if ($c) {
                                $c = false;
                                $r = $r.$blk();
                            }
                            if ($r && $r.$blk !== undefined) {
                                break s;
                            }
                            $deferred.push([$methodVal(k.Mutex, 'Unlock'), []]);
                            n =
                                ((m = k.active[NL.keyFor(l)]),
                                m !== undefined ? m.v : NC.nil);
                            if (
                                n === NC.nil ||
                                !(
                                    $indexPtr(n.$array, n.$offset + 0, NL) ===
                                    $indexPtr(i.$array, i.$offset + 0, NL)
                                )
                            ) {
                                j = new FJ(22);
                                $s = -1;
                                return j;
                            }
                            o = k.munmap($sliceToArray(n), n.$length >>> 0);
                            $s = 2;
                        case 2:
                            if ($c) {
                                $c = false;
                                o = o.$blk();
                            }
                            if (o && o.$blk !== undefined) {
                                break s;
                            }
                            p = o;
                            if (!$interfaceIsEqual(p, $ifaceNil)) {
                                j = p;
                                $s = -1;
                                return j;
                            }
                            delete k.active[NL.keyFor(l)];
                            j = $ifaceNil;
                            $s = -1;
                            return j;
                    }
                    return;
                }
            } catch (err) {
                $err = err;
                $s = -1;
            } finally {
                $callDeferred($deferred, $err);
                if (!$curGoroutine.asleep) {
                    return j;
                }
                if ($curGoroutine.asleep) {
                    if ($f === undefined) {
                        $f = { $blk: FI.ptr.prototype.Munmap };
                    }
                    $f.i = i;
                    $f.j = j;
                    $f.k = k;
                    $f.l = l;
                    $f.m = m;
                    $f.n = n;
                    $f.o = o;
                    $f.p = p;
                    $f.$s = $s;
                    $f.$deferred = $deferred;
                    $f.$r = $r;
                    return $f;
                }
            }
        };
        FI.prototype.Munmap = function (i) {
            return this.$val.Munmap(i);
        };
        FJ.prototype.Error = function () {
            var i, j;
            i = this.$val;
            if (0 <= i >> 0 && i >> 0 < 106) {
                j =
                    i < 0 || i >= GS.length
                        ? ($throwRuntimeError('index out of range'), undefined)
                        : GS[i];
                if (!(j === '')) {
                    return j;
                }
            }
            return 'errno ' + DG(i >> 0);
        };
        $ptrType(FJ).prototype.Error = function () {
            return new FJ(this.$get()).Error();
        };
        FJ.prototype.Temporary = function () {
            var i;
            i = this.$val;
            return i === 4 || i === 24 || i === 54 || i === 53 || new FJ(i).Timeout();
        };
        $ptrType(FJ).prototype.Temporary = function () {
            return new FJ(this.$get()).Temporary();
        };
        FJ.prototype.Timeout = function () {
            var i;
            i = this.$val;
            return i === 35 || i === 35 || i === 60;
        };
        $ptrType(FJ).prototype.Timeout = function () {
            return new FJ(this.$get()).Timeout();
        };
        FN = function (i) {
            var i, j;
            j = i;
            if (j === 0) {
                return $ifaceNil;
            } else if (j === 35) {
                return FK;
            } else if (j === 22) {
                return FL;
            } else if (j === 2) {
                return FM;
            }
            return new FJ(i);
        };
        KY = function (i, j, k, l, m, n) {
            var i, j, k, l, m, n, o, p, q, r, s;
            o = 0;
            p = $ifaceNil;
            q = U(197, i, j, k >>> 0, l >>> 0, m >>> 0, n.$low >>> 0);
            r = q[0];
            s = q[2];
            o = r;
            if (!(s === 0)) {
                p = FN(s);
            }
            return [o, p];
        };
        KZ = function (i, j) {
            var i, j, k, l, m;
            k = $ifaceNil;
            l = T(73, i, j, 0);
            m = l[2];
            if (!(m === 0)) {
                k = FN(m);
            }
            return k;
        };
        PM.methods = [
            {
                prop: 'Mmap',
                name: 'Mmap',
                pkg: '',
                typ: $funcType([$Int, $Int64, $Int, $Int, $Int], [NC, $error], false),
            },
            {
                prop: 'Munmap',
                name: 'Munmap',
                pkg: '',
                typ: $funcType([NC], [$error], false),
            },
        ];
        FJ.methods = [
            {
                prop: 'Error',
                name: 'Error',
                pkg: '',
                typ: $funcType([], [$String], false),
            },
            {
                prop: 'Temporary',
                name: 'Temporary',
                pkg: '',
                typ: $funcType([], [$Bool], false),
            },
            {
                prop: 'Timeout',
                name: 'Timeout',
                pkg: '',
                typ: $funcType([], [$Bool], false),
            },
        ];
        FI.init('syscall', [
            {
                prop: 'Mutex',
                name: 'Mutex',
                anonymous: true,
                exported: true,
                typ: C.Mutex,
                tag: '',
            },
            {
                prop: 'active',
                name: 'active',
                anonymous: false,
                exported: false,
                typ: PN,
                tag: '',
            },
            {
                prop: 'mmap',
                name: 'mmap',
                anonymous: false,
                exported: false,
                typ: PO,
                tag: '',
            },
            {
                prop: 'munmap',
                name: 'munmap',
                anonymous: false,
                exported: false,
                typ: PP,
                tag: '',
            },
        ]);
        $init = function () {
            $pkg.$init = function () {};
            var $f,
                $c = false,
                $s = 0,
                $r;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        $r = D.$init();
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                        $r = A.$init();
                        $s = 2;
                    case 2:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                        $r = E.$init();
                        $s = 3;
                    case 3:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                        $r = B.$init();
                        $s = 4;
                    case 4:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                        $r = C.$init();
                        $s = 5;
                    case 5:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                        G = NC.nil;
                        P = null;
                        CH = '';
                        F = false;
                        Q = false;
                        R = -1;
                        AY = N();
                        FK = new FJ(35);
                        FL = new FJ(22);
                        FM = new FJ(2);
                        GS = $toNativeArray($kindString, [
                            '',
                            'operation not permitted',
                            'no such file or directory',
                            'no such process',
                            'interrupted system call',
                            'input/output error',
                            'device not configured',
                            'argument list too long',
                            'exec format error',
                            'bad file descriptor',
                            'no child processes',
                            'resource deadlock avoided',
                            'cannot allocate memory',
                            'permission denied',
                            'bad address',
                            'block device required',
                            'resource busy',
                            'file exists',
                            'cross-device link',
                            'operation not supported by device',
                            'not a directory',
                            'is a directory',
                            'invalid argument',
                            'too many open files in system',
                            'too many open files',
                            'inappropriate ioctl for device',
                            'text file busy',
                            'file too large',
                            'no space left on device',
                            'illegal seek',
                            'read-only file system',
                            'too many links',
                            'broken pipe',
                            'numerical argument out of domain',
                            'result too large',
                            'resource temporarily unavailable',
                            'operation now in progress',
                            'operation already in progress',
                            'socket operation on non-socket',
                            'destination address required',
                            'message too long',
                            'protocol wrong type for socket',
                            'protocol not available',
                            'protocol not supported',
                            'socket type not supported',
                            'operation not supported',
                            'protocol family not supported',
                            'address family not supported by protocol family',
                            'address already in use',
                            "can't assign requested address",
                            'network is down',
                            'network is unreachable',
                            'network dropped connection on reset',
                            'software caused connection abort',
                            'connection reset by peer',
                            'no buffer space available',
                            'socket is already connected',
                            'socket is not connected',
                            "can't send after socket shutdown",
                            "too many references: can't splice",
                            'operation timed out',
                            'connection refused',
                            'too many levels of symbolic links',
                            'file name too long',
                            'host is down',
                            'no route to host',
                            'directory not empty',
                            'too many processes',
                            'too many users',
                            'disc quota exceeded',
                            'stale NFS file handle',
                            'too many levels of remote in path',
                            'RPC struct is bad',
                            'RPC version wrong',
                            'RPC prog. not avail',
                            'program version wrong',
                            'bad procedure for program',
                            'no locks available',
                            'function not implemented',
                            'inappropriate file type or format',
                            'authentication error',
                            'need authenticator',
                            'device power is off',
                            'device error',
                            'value too large to be stored in data type',
                            'bad executable (or shared library)',
                            'bad CPU type in executable',
                            'shared library version mismatch',
                            'malformed Mach-o file',
                            'operation canceled',
                            'identifier removed',
                            'no message of desired type',
                            'illegal byte sequence',
                            'attribute not found',
                            'bad message',
                            'EMULTIHOP (Reserved)',
                            'no message available on STREAM',
                            'ENOLINK (Reserved)',
                            'no STREAM resources',
                            'not a STREAM',
                            'protocol error',
                            'STREAM ioctl timeout',
                            'operation not supported on socket',
                            'policy not found',
                            'state not recoverable',
                            'previous owner died',
                        ]);
                        EK = new FI.ptr(new C.Mutex.ptr(0, 0), {}, KY, KZ);
                        CI = CJ(0);
                        H();
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: $init };
            }
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        $pkg.$init = $init;
        return $pkg;
    })();
    $packages['time'] = (function () {
        var $pkg = {},
            $init,
            C,
            B,
            E,
            A,
            D,
            AE,
            BK,
            BL,
            BN,
            BR,
            CH,
            CI,
            CJ,
            DI,
            DJ,
            DK,
            DM,
            DO,
            DP,
            DQ,
            DR,
            DS,
            DV,
            EA,
            EE,
            O,
            Q,
            T,
            U,
            V,
            W,
            AA,
            AD,
            AQ,
            BM,
            BO,
            BY,
            CK,
            DG,
            CL,
            DH,
            CM,
            CO,
            CW,
            F,
            H,
            P,
            R,
            S,
            X,
            Y,
            Z,
            AB,
            AC,
            AF,
            AG,
            AH,
            AI,
            AJ,
            AK,
            AM,
            AN,
            AO,
            AP,
            AR,
            BP,
            BQ,
            BS,
            BT,
            BU,
            BX,
            BZ,
            CB,
            CC,
            CD,
            CE,
            CF,
            CG,
            CN;
        C = $packages['errors'];
        B = $packages['github.com/gopherjs/gopherjs/js'];
        E = $packages['github.com/gopherjs/gopherjs/nosync'];
        A = $packages['runtime'];
        D = $packages['syscall'];
        AE = $pkg.ParseError = $newType(
            0,
            $kindStruct,
            'time.ParseError',
            true,
            'time',
            true,
            function (Layout_, Value_, LayoutElem_, ValueElem_, Message_) {
                this.$val = this;
                if (arguments.length === 0) {
                    this.Layout = '';
                    this.Value = '';
                    this.LayoutElem = '';
                    this.ValueElem = '';
                    this.Message = '';
                    return;
                }
                this.Layout = Layout_;
                this.Value = Value_;
                this.LayoutElem = LayoutElem_;
                this.ValueElem = ValueElem_;
                this.Message = Message_;
            }
        );
        BK = $pkg.Time = $newType(
            0,
            $kindStruct,
            'time.Time',
            true,
            'time',
            true,
            function (wall_, ext_, loc_) {
                this.$val = this;
                if (arguments.length === 0) {
                    this.wall = new $Uint64(0, 0);
                    this.ext = new $Int64(0, 0);
                    this.loc = DS.nil;
                    return;
                }
                this.wall = wall_;
                this.ext = ext_;
                this.loc = loc_;
            }
        );
        BL = $pkg.Month = $newType(4, $kindInt, 'time.Month', true, 'time', true, null);
        BN = $pkg.Weekday = $newType(
            4,
            $kindInt,
            'time.Weekday',
            true,
            'time',
            true,
            null
        );
        BR = $pkg.Duration = $newType(
            8,
            $kindInt64,
            'time.Duration',
            true,
            'time',
            true,
            null
        );
        CH = $pkg.Location = $newType(
            0,
            $kindStruct,
            'time.Location',
            true,
            'time',
            true,
            function (name_, zone_, tx_, cacheStart_, cacheEnd_, cacheZone_) {
                this.$val = this;
                if (arguments.length === 0) {
                    this.name = '';
                    this.zone = DI.nil;
                    this.tx = DJ.nil;
                    this.cacheStart = new $Int64(0, 0);
                    this.cacheEnd = new $Int64(0, 0);
                    this.cacheZone = DK.nil;
                    return;
                }
                this.name = name_;
                this.zone = zone_;
                this.tx = tx_;
                this.cacheStart = cacheStart_;
                this.cacheEnd = cacheEnd_;
                this.cacheZone = cacheZone_;
            }
        );
        CI = $pkg.zone = $newType(
            0,
            $kindStruct,
            'time.zone',
            true,
            'time',
            false,
            function (name_, offset_, isDST_) {
                this.$val = this;
                if (arguments.length === 0) {
                    this.name = '';
                    this.offset = 0;
                    this.isDST = false;
                    return;
                }
                this.name = name_;
                this.offset = offset_;
                this.isDST = isDST_;
            }
        );
        CJ = $pkg.zoneTrans = $newType(
            0,
            $kindStruct,
            'time.zoneTrans',
            true,
            'time',
            false,
            function (when_, index_, isstd_, isutc_) {
                this.$val = this;
                if (arguments.length === 0) {
                    this.when = new $Int64(0, 0);
                    this.index = 0;
                    this.isstd = false;
                    this.isutc = false;
                    return;
                }
                this.when = when_;
                this.index = index_;
                this.isstd = isstd_;
                this.isutc = isutc_;
            }
        );
        DI = $sliceType(CI);
        DJ = $sliceType(CJ);
        DK = $ptrType(CI);
        DM = $sliceType($String);
        DO = $arrayType($Uint8, 20);
        DP = $sliceType($Uint8);
        DQ = $arrayType($Uint8, 9);
        DR = $arrayType($Uint8, 64);
        DS = $ptrType(CH);
        DV = $arrayType($Uint8, 32);
        EA = $ptrType(AE);
        EE = $ptrType(BK);
        F = function () {
            $unused(CC(new $Int64(0, 0), new $Int64(0, 0)));
        };
        H = function () {
            var g, h, i, j;
            g = new $global.Date();
            h = $internalize(g, $String);
            i = P(h, 40);
            j = P(h, 41);
            if (i === -1 || j === -1) {
                CL.name = 'UTC';
                return;
            }
            CL.name = $substring(h, (i + 1) >> 0, j);
            CL.zone = new DI([
                new CI.ptr(
                    CL.name,
                    $imul($parseInt(g.getTimezoneOffset()) >> 0, -60),
                    false
                ),
            ]);
        };
        P = function (g, h) {
            var g, h;
            return $parseInt(g.indexOf($global.String.fromCharCode(h))) >> 0;
        };
        R = function (g) {
            var g, h;
            if (g.length === 0) {
                return false;
            }
            h = g.charCodeAt(0);
            return 97 <= h && h <= 122;
        };
        S = function (g) {
            var aa,
                ab,
                ac,
                ad,
                ae,
                af,
                ag,
                ah,
                ai,
                aj,
                ak,
                al,
                am,
                an,
                ao,
                ap,
                aq,
                ar,
                as,
                at,
                au,
                av,
                aw,
                ax,
                ay,
                az,
                ba,
                bb,
                bc,
                bd,
                be,
                bf,
                bg,
                bh,
                bi,
                bj,
                bk,
                bl,
                bm,
                bn,
                bo,
                bp,
                bq,
                br,
                bs,
                bt,
                bu,
                bv,
                bw,
                bx,
                by,
                bz,
                ca,
                cb,
                cc,
                cd,
                ce,
                cf,
                cg,
                ch,
                ci,
                cj,
                ck,
                cl,
                cm,
                cn,
                co,
                cp,
                cq,
                cr,
                cs,
                ct,
                cu,
                cv,
                cw,
                cx,
                cy,
                cz,
                g,
                h,
                i,
                j,
                k,
                l,
                m,
                n,
                o,
                p,
                q,
                r,
                s,
                t,
                u,
                v,
                w,
                x,
                y,
                z;
            h = '';
            i = 0;
            j = '';
            k = 0;
            while (true) {
                if (!(k < g.length)) {
                    break;
                }
                l = g.charCodeAt(k) >> 0;
                m = l;
                if (m === 74) {
                    if (
                        g.length >= (k + 3) >> 0 &&
                        $substring(g, k, (k + 3) >> 0) === 'Jan'
                    ) {
                        if (
                            g.length >= (k + 7) >> 0 &&
                            $substring(g, k, (k + 7) >> 0) === 'January'
                        ) {
                            n = $substring(g, 0, k);
                            o = 257;
                            p = $substring(g, (k + 7) >> 0);
                            h = n;
                            i = o;
                            j = p;
                            return [h, i, j];
                        }
                        if (!R($substring(g, (k + 3) >> 0))) {
                            q = $substring(g, 0, k);
                            r = 258;
                            s = $substring(g, (k + 3) >> 0);
                            h = q;
                            i = r;
                            j = s;
                            return [h, i, j];
                        }
                    }
                } else if (m === 77) {
                    if (g.length >= (k + 3) >> 0) {
                        if ($substring(g, k, (k + 3) >> 0) === 'Mon') {
                            if (
                                g.length >= (k + 6) >> 0 &&
                                $substring(g, k, (k + 6) >> 0) === 'Monday'
                            ) {
                                t = $substring(g, 0, k);
                                u = 261;
                                v = $substring(g, (k + 6) >> 0);
                                h = t;
                                i = u;
                                j = v;
                                return [h, i, j];
                            }
                            if (!R($substring(g, (k + 3) >> 0))) {
                                w = $substring(g, 0, k);
                                x = 262;
                                y = $substring(g, (k + 3) >> 0);
                                h = w;
                                i = x;
                                j = y;
                                return [h, i, j];
                            }
                        }
                        if ($substring(g, k, (k + 3) >> 0) === 'MST') {
                            z = $substring(g, 0, k);
                            aa = 21;
                            ab = $substring(g, (k + 3) >> 0);
                            h = z;
                            i = aa;
                            j = ab;
                            return [h, i, j];
                        }
                    }
                } else if (m === 48) {
                    if (
                        g.length >= (k + 2) >> 0 &&
                        49 <= g.charCodeAt((k + 1) >> 0) &&
                        g.charCodeAt((k + 1) >> 0) <= 54
                    ) {
                        ac = $substring(g, 0, k);
                        ad =
                            ((ae = ((g.charCodeAt((k + 1) >> 0) - 49) << 24) >>> 24),
                            ae < 0 || ae >= Q.length
                                ? ($throwRuntimeError('index out of range'), undefined)
                                : Q[ae]);
                        af = $substring(g, (k + 2) >> 0);
                        h = ac;
                        i = ad;
                        j = af;
                        return [h, i, j];
                    }
                } else if (m === 49) {
                    if (g.length >= (k + 2) >> 0 && g.charCodeAt((k + 1) >> 0) === 53) {
                        ag = $substring(g, 0, k);
                        ah = 522;
                        ai = $substring(g, (k + 2) >> 0);
                        h = ag;
                        i = ah;
                        j = ai;
                        return [h, i, j];
                    }
                    aj = $substring(g, 0, k);
                    ak = 259;
                    al = $substring(g, (k + 1) >> 0);
                    h = aj;
                    i = ak;
                    j = al;
                    return [h, i, j];
                } else if (m === 50) {
                    if (
                        g.length >= (k + 4) >> 0 &&
                        $substring(g, k, (k + 4) >> 0) === '2006'
                    ) {
                        am = $substring(g, 0, k);
                        an = 273;
                        ao = $substring(g, (k + 4) >> 0);
                        h = am;
                        i = an;
                        j = ao;
                        return [h, i, j];
                    }
                    ap = $substring(g, 0, k);
                    aq = 263;
                    ar = $substring(g, (k + 1) >> 0);
                    h = ap;
                    i = aq;
                    j = ar;
                    return [h, i, j];
                } else if (m === 95) {
                    if (g.length >= (k + 2) >> 0 && g.charCodeAt((k + 1) >> 0) === 50) {
                        if (
                            g.length >= (k + 5) >> 0 &&
                            $substring(g, (k + 1) >> 0, (k + 5) >> 0) === '2006'
                        ) {
                            as = $substring(g, 0, (k + 1) >> 0);
                            at = 273;
                            au = $substring(g, (k + 5) >> 0);
                            h = as;
                            i = at;
                            j = au;
                            return [h, i, j];
                        }
                        av = $substring(g, 0, k);
                        aw = 264;
                        ax = $substring(g, (k + 2) >> 0);
                        h = av;
                        i = aw;
                        j = ax;
                        return [h, i, j];
                    }
                } else if (m === 51) {
                    ay = $substring(g, 0, k);
                    az = 523;
                    ba = $substring(g, (k + 1) >> 0);
                    h = ay;
                    i = az;
                    j = ba;
                    return [h, i, j];
                } else if (m === 52) {
                    bb = $substring(g, 0, k);
                    bc = 525;
                    bd = $substring(g, (k + 1) >> 0);
                    h = bb;
                    i = bc;
                    j = bd;
                    return [h, i, j];
                } else if (m === 53) {
                    be = $substring(g, 0, k);
                    bf = 527;
                    bg = $substring(g, (k + 1) >> 0);
                    h = be;
                    i = bf;
                    j = bg;
                    return [h, i, j];
                } else if (m === 80) {
                    if (g.length >= (k + 2) >> 0 && g.charCodeAt((k + 1) >> 0) === 77) {
                        bh = $substring(g, 0, k);
                        bi = 531;
                        bj = $substring(g, (k + 2) >> 0);
                        h = bh;
                        i = bi;
                        j = bj;
                        return [h, i, j];
                    }
                } else if (m === 112) {
                    if (g.length >= (k + 2) >> 0 && g.charCodeAt((k + 1) >> 0) === 109) {
                        bk = $substring(g, 0, k);
                        bl = 532;
                        bm = $substring(g, (k + 2) >> 0);
                        h = bk;
                        i = bl;
                        j = bm;
                        return [h, i, j];
                    }
                } else if (m === 45) {
                    if (
                        g.length >= (k + 7) >> 0 &&
                        $substring(g, k, (k + 7) >> 0) === '-070000'
                    ) {
                        bn = $substring(g, 0, k);
                        bo = 28;
                        bp = $substring(g, (k + 7) >> 0);
                        h = bn;
                        i = bo;
                        j = bp;
                        return [h, i, j];
                    }
                    if (
                        g.length >= (k + 9) >> 0 &&
                        $substring(g, k, (k + 9) >> 0) === '-07:00:00'
                    ) {
                        bq = $substring(g, 0, k);
                        br = 31;
                        bs = $substring(g, (k + 9) >> 0);
                        h = bq;
                        i = br;
                        j = bs;
                        return [h, i, j];
                    }
                    if (
                        g.length >= (k + 5) >> 0 &&
                        $substring(g, k, (k + 5) >> 0) === '-0700'
                    ) {
                        bt = $substring(g, 0, k);
                        bu = 27;
                        bv = $substring(g, (k + 5) >> 0);
                        h = bt;
                        i = bu;
                        j = bv;
                        return [h, i, j];
                    }
                    if (
                        g.length >= (k + 6) >> 0 &&
                        $substring(g, k, (k + 6) >> 0) === '-07:00'
                    ) {
                        bw = $substring(g, 0, k);
                        bx = 30;
                        by = $substring(g, (k + 6) >> 0);
                        h = bw;
                        i = bx;
                        j = by;
                        return [h, i, j];
                    }
                    if (
                        g.length >= (k + 3) >> 0 &&
                        $substring(g, k, (k + 3) >> 0) === '-07'
                    ) {
                        bz = $substring(g, 0, k);
                        ca = 29;
                        cb = $substring(g, (k + 3) >> 0);
                        h = bz;
                        i = ca;
                        j = cb;
                        return [h, i, j];
                    }
                } else if (m === 90) {
                    if (
                        g.length >= (k + 7) >> 0 &&
                        $substring(g, k, (k + 7) >> 0) === 'Z070000'
                    ) {
                        cc = $substring(g, 0, k);
                        cd = 23;
                        ce = $substring(g, (k + 7) >> 0);
                        h = cc;
                        i = cd;
                        j = ce;
                        return [h, i, j];
                    }
                    if (
                        g.length >= (k + 9) >> 0 &&
                        $substring(g, k, (k + 9) >> 0) === 'Z07:00:00'
                    ) {
                        cf = $substring(g, 0, k);
                        cg = 26;
                        ch = $substring(g, (k + 9) >> 0);
                        h = cf;
                        i = cg;
                        j = ch;
                        return [h, i, j];
                    }
                    if (
                        g.length >= (k + 5) >> 0 &&
                        $substring(g, k, (k + 5) >> 0) === 'Z0700'
                    ) {
                        ci = $substring(g, 0, k);
                        cj = 22;
                        ck = $substring(g, (k + 5) >> 0);
                        h = ci;
                        i = cj;
                        j = ck;
                        return [h, i, j];
                    }
                    if (
                        g.length >= (k + 6) >> 0 &&
                        $substring(g, k, (k + 6) >> 0) === 'Z07:00'
                    ) {
                        cl = $substring(g, 0, k);
                        cm = 25;
                        cn = $substring(g, (k + 6) >> 0);
                        h = cl;
                        i = cm;
                        j = cn;
                        return [h, i, j];
                    }
                    if (
                        g.length >= (k + 3) >> 0 &&
                        $substring(g, k, (k + 3) >> 0) === 'Z07'
                    ) {
                        co = $substring(g, 0, k);
                        cp = 24;
                        cq = $substring(g, (k + 3) >> 0);
                        h = co;
                        i = cp;
                        j = cq;
                        return [h, i, j];
                    }
                } else if (m === 46) {
                    if (
                        (k + 1) >> 0 < g.length &&
                        (g.charCodeAt((k + 1) >> 0) === 48 ||
                            g.charCodeAt((k + 1) >> 0) === 57)
                    ) {
                        cr = g.charCodeAt((k + 1) >> 0);
                        cs = (k + 1) >> 0;
                        while (true) {
                            if (!(cs < g.length && g.charCodeAt(cs) === cr)) {
                                break;
                            }
                            cs = (cs + 1) >> 0;
                        }
                        if (!AG(g, cs)) {
                            ct = 32;
                            if (g.charCodeAt((k + 1) >> 0) === 57) {
                                ct = 33;
                            }
                            ct = ct | ((((cs - ((k + 1) >> 0)) >> 0) << 16) >> 0);
                            cu = $substring(g, 0, k);
                            cv = ct;
                            cw = $substring(g, cs);
                            h = cu;
                            i = cv;
                            j = cw;
                            return [h, i, j];
                        }
                    }
                }
                k = (k + 1) >> 0;
            }
            cx = g;
            cy = 0;
            cz = '';
            h = cx;
            i = cy;
            j = cz;
            return [h, i, j];
        };
        X = function (g, h) {
            var g, h, i, j, k;
            i = 0;
            while (true) {
                if (!(i < g.length)) {
                    break;
                }
                j = g.charCodeAt(i);
                k = h.charCodeAt(i);
                if (!(j === k)) {
                    j = (j | 32) >>> 0;
                    k = (k | 32) >>> 0;
                    if (!(j === k) || j < 97 || j > 122) {
                        return false;
                    }
                }
                i = (i + 1) >> 0;
            }
            return true;
        };
        Y = function (g, h) {
            var g, h, i, j, k, l;
            i = g;
            j = 0;
            while (true) {
                if (!(j < i.$length)) {
                    break;
                }
                k = j;
                l =
                    j < 0 || j >= i.$length
                        ? ($throwRuntimeError('index out of range'), undefined)
                        : i.$array[i.$offset + j];
                if (h.length >= l.length && X($substring(h, 0, l.length), l)) {
                    return [k, $substring(h, l.length), $ifaceNil];
                }
                j++;
            }
            return [-1, h, AD];
        };
        Z = function (g, h, i) {
            var g, h, i, j, k, l, m, n, o;
            j = h >>> 0;
            if (h < 0) {
                g = $append(g, 45);
                j = -h >>> 0;
            }
            k = DO.zero();
            l = 20;
            while (true) {
                if (!(j >= 10)) {
                    break;
                }
                l = (l - 1) >> 0;
                n =
                    ((m = j / 10),
                    m === m && m !== 1 / 0 && m !== -1 / 0
                        ? m >>> 0
                        : $throwRuntimeError('integer divide by zero'));
                l < 0 || l >= k.length
                    ? ($throwRuntimeError('index out of range'), undefined)
                    : (k[l] =
                          (((((48 + j) >>> 0) - ((n * 10) >>> 0)) >>> 0) << 24) >>> 24);
                j = n;
            }
            l = (l - 1) >> 0;
            l < 0 || l >= k.length
                ? ($throwRuntimeError('index out of range'), undefined)
                : (k[l] = (((48 + j) >>> 0) << 24) >>> 24);
            o = (20 - l) >> 0;
            while (true) {
                if (!(o < i)) {
                    break;
                }
                g = $append(g, 48);
                o = (o + 1) >> 0;
            }
            return $appendSlice(g, $subslice(new DP(k), l));
        };
        AB = function (g) {
            var g, h, i, j, k, l, m, n, o, p, q;
            h = 0;
            i = $ifaceNil;
            j = false;
            if (!(g === '') && (g.charCodeAt(0) === 45 || g.charCodeAt(0) === 43)) {
                j = g.charCodeAt(0) === 45;
                g = $substring(g, 1);
            }
            k = AR(g);
            l = k[0];
            m = k[1];
            i = k[2];
            h = (l.$low + (l.$high >> 31) * 4294967296) >> 0;
            if (!$interfaceIsEqual(i, $ifaceNil) || !(m === '')) {
                n = 0;
                o = AA;
                h = n;
                i = o;
                return [h, i];
            }
            if (j) {
                h = -h;
            }
            p = h;
            q = $ifaceNil;
            h = p;
            i = q;
            return [h, i];
        };
        AC = function (g, h, i, j) {
            var g, h, i, j, k, l, m, n, o, p;
            k = h;
            l = DQ.zero();
            m = 9;
            while (true) {
                if (!(m > 0)) {
                    break;
                }
                m = (m - 1) >> 0;
                m < 0 || m >= l.length
                    ? ($throwRuntimeError('index out of range'), undefined)
                    : (l[m] =
                          (((((n = k % 10),
                          n === n ? n : $throwRuntimeError('integer divide by zero')) +
                              48) >>>
                              0) <<
                              24) >>>
                          24);
                k =
                    ((o = k / 10),
                    o === o && o !== 1 / 0 && o !== -1 / 0
                        ? o >>> 0
                        : $throwRuntimeError('integer divide by zero'));
            }
            if (i > 9) {
                i = 9;
            }
            if (j) {
                while (true) {
                    if (
                        !(
                            i > 0 &&
                            ((p = (i - 1) >> 0),
                            p < 0 || p >= l.length
                                ? ($throwRuntimeError('index out of range'), undefined)
                                : l[p]) === 48
                        )
                    ) {
                        break;
                    }
                    i = (i - 1) >> 0;
                }
                if (i === 0) {
                    return g;
                }
            }
            g = $append(g, 46);
            return $appendSlice(g, $subslice(new DP(l), 0, i));
        };
        BK.ptr.prototype.String = function () {
            var g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                k = $f.k;
                l = $f.l;
                m = $f.m;
                n = $f.n;
                o = $f.o;
                p = $f.p;
                q = $f.q;
                r = $f.r;
                s = $f.s;
                t = $f.t;
                u = $f.u;
                v = $f.v;
                w = $f.w;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        g = this;
                        h = $clone(g, BK).Format(
                            '2006-01-02 15:04:05.999999999 -0700 MST'
                        );
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            h = h.$blk();
                        }
                        if (h && h.$blk !== undefined) {
                            break s;
                        }
                        i = h;
                        if (
                            !((j =
                                ((k = g.wall),
                                new $Uint64(k.$high & 2147483648, (k.$low & 0) >>> 0))),
                            j.$high === 0 && j.$low === 0)
                        ) {
                            m = ((l = g.ext), new $Uint64(l.$high, l.$low));
                            n = 43;
                            if (
                                ((o = g.ext),
                                o.$high < 0 || (o.$high === 0 && o.$low < 0))
                            ) {
                                n = 45;
                                m = new $Uint64(-m.$high, -m.$low);
                            }
                            p = $div64(m, new $Uint64(0, 1000000000), false);
                            q = $div64(m, new $Uint64(0, 1000000000), true);
                            r = p;
                            m = q;
                            s = $div64(r, new $Uint64(0, 1000000000), false);
                            t = $div64(r, new $Uint64(0, 1000000000), true);
                            u = s;
                            r = t;
                            v = DP.nil;
                            v = $appendSlice(v, ' m=');
                            v = $append(v, n);
                            w = 0;
                            if (!(u.$high === 0 && u.$low === 0)) {
                                v = Z(v, u.$low >> 0, 0);
                                w = 9;
                            }
                            v = Z(v, r.$low >> 0, w);
                            v = $append(v, 46);
                            v = Z(v, m.$low >> 0, 9);
                            i = i + $bytesToString(v);
                        }
                        $s = -1;
                        return i;
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.String };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.k = k;
            $f.l = l;
            $f.m = m;
            $f.n = n;
            $f.o = o;
            $f.p = p;
            $f.q = q;
            $f.r = r;
            $f.s = s;
            $f.t = t;
            $f.u = u;
            $f.v = v;
            $f.w = w;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.String = function () {
            return this.$val.String();
        };
        BK.ptr.prototype.Format = function (g) {
            var g, h, i, j, k, l, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                k = $f.k;
                l = $f.l;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        h = this;
                        i = DP.nil;
                        j = (g.length + 10) >> 0;
                        if (j < 64) {
                            k = DR.zero();
                            i = $subslice(new DP(k), 0, 0);
                        } else {
                            i = $makeSlice(DP, 0, j);
                        }
                        l = $clone(h, BK).AppendFormat(i, g);
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            l = l.$blk();
                        }
                        if (l && l.$blk !== undefined) {
                            break s;
                        }
                        i = l;
                        $s = -1;
                        return $bytesToString(i);
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.Format };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.k = k;
            $f.l = l;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.Format = function (g) {
            return this.$val.Format(g);
        };
        BK.ptr.prototype.AppendFormat = function (g, h) {
            var aa,
                ab,
                ac,
                ad,
                ae,
                af,
                ag,
                ah,
                ai,
                aj,
                ak,
                al,
                am,
                an,
                ao,
                ap,
                aq,
                ar,
                as,
                g,
                h,
                i,
                j,
                k,
                l,
                m,
                n,
                o,
                p,
                q,
                r,
                s,
                t,
                u,
                v,
                w,
                x,
                y,
                z,
                $s,
                $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                aa = $f.aa;
                ab = $f.ab;
                ac = $f.ac;
                ad = $f.ad;
                ae = $f.ae;
                af = $f.af;
                ag = $f.ag;
                ah = $f.ah;
                ai = $f.ai;
                aj = $f.aj;
                ak = $f.ak;
                al = $f.al;
                am = $f.am;
                an = $f.an;
                ao = $f.ao;
                ap = $f.ap;
                aq = $f.aq;
                ar = $f.ar;
                as = $f.as;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                k = $f.k;
                l = $f.l;
                m = $f.m;
                n = $f.n;
                o = $f.o;
                p = $f.p;
                q = $f.q;
                r = $f.r;
                s = $f.s;
                t = $f.t;
                u = $f.u;
                v = $f.v;
                w = $f.w;
                x = $f.x;
                y = $f.y;
                z = $f.z;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        i = this;
                        k = $clone(i, BK).locabs();
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            k = k.$blk();
                        }
                        if (k && k.$blk !== undefined) {
                            break s;
                        }
                        j = k;
                        l = j[0];
                        m = j[1];
                        n = j[2];
                        o = -1;
                        p = 0;
                        q = 0;
                        r = -1;
                        s = 0;
                        t = 0;
                        while (true) {
                            if (!!(h === '')) {
                                break;
                            }
                            u = S(h);
                            v = u[0];
                            w = u[1];
                            x = u[2];
                            if (!(v === '')) {
                                g = $appendSlice(g, v);
                            }
                            if (w === 0) {
                                break;
                            }
                            h = x;
                            if (o < 0 && !((w & 256) === 0)) {
                                y = BX(n, true);
                                o = y[0];
                                p = y[1];
                                q = y[2];
                            }
                            if (r < 0 && !((w & 512) === 0)) {
                                z = BQ(n);
                                r = z[0];
                                s = z[1];
                                t = z[2];
                            }
                            switch (0) {
                                default:
                                    aa = w & 65535;
                                    if (aa === 274) {
                                        ab = o;
                                        if (ab < 0) {
                                            ab = -ab;
                                        }
                                        g = Z(
                                            g,
                                            ((ac = ab % 100),
                                            ac === ac
                                                ? ac
                                                : $throwRuntimeError(
                                                      'integer divide by zero'
                                                  )),
                                            2
                                        );
                                    } else if (aa === 273) {
                                        g = Z(g, o, 4);
                                    } else if (aa === 258) {
                                        g = $appendSlice(
                                            g,
                                            $substring(new BL(p).String(), 0, 3)
                                        );
                                    } else if (aa === 257) {
                                        ad = new BL(p).String();
                                        g = $appendSlice(g, ad);
                                    } else if (aa === 259) {
                                        g = Z(g, p >> 0, 0);
                                    } else if (aa === 260) {
                                        g = Z(g, p >> 0, 2);
                                    } else if (aa === 262) {
                                        g = $appendSlice(
                                            g,
                                            $substring(new BN(BP(n)).String(), 0, 3)
                                        );
                                    } else if (aa === 261) {
                                        ae = new BN(BP(n)).String();
                                        g = $appendSlice(g, ae);
                                    } else if (aa === 263) {
                                        g = Z(g, q, 0);
                                    } else if (aa === 264) {
                                        if (q < 10) {
                                            g = $append(g, 32);
                                        }
                                        g = Z(g, q, 0);
                                    } else if (aa === 265) {
                                        g = Z(g, q, 2);
                                    } else if (aa === 522) {
                                        g = Z(g, r, 2);
                                    } else if (aa === 523) {
                                        ag =
                                            ((af = r % 12),
                                            af === af
                                                ? af
                                                : $throwRuntimeError(
                                                      'integer divide by zero'
                                                  ));
                                        if (ag === 0) {
                                            ag = 12;
                                        }
                                        g = Z(g, ag, 0);
                                    } else if (aa === 524) {
                                        ai =
                                            ((ah = r % 12),
                                            ah === ah
                                                ? ah
                                                : $throwRuntimeError(
                                                      'integer divide by zero'
                                                  ));
                                        if (ai === 0) {
                                            ai = 12;
                                        }
                                        g = Z(g, ai, 2);
                                    } else if (aa === 525) {
                                        g = Z(g, s, 0);
                                    } else if (aa === 526) {
                                        g = Z(g, s, 2);
                                    } else if (aa === 527) {
                                        g = Z(g, t, 0);
                                    } else if (aa === 528) {
                                        g = Z(g, t, 2);
                                    } else if (aa === 531) {
                                        if (r >= 12) {
                                            g = $appendSlice(g, 'PM');
                                        } else {
                                            g = $appendSlice(g, 'AM');
                                        }
                                    } else if (aa === 532) {
                                        if (r >= 12) {
                                            g = $appendSlice(g, 'pm');
                                        } else {
                                            g = $appendSlice(g, 'am');
                                        }
                                    } else if (
                                        aa === 22 ||
                                        aa === 25 ||
                                        aa === 23 ||
                                        aa === 24 ||
                                        aa === 26 ||
                                        aa === 27 ||
                                        aa === 30 ||
                                        aa === 28 ||
                                        aa === 29 ||
                                        aa === 31
                                    ) {
                                        if (
                                            m === 0 &&
                                            (w === 22 ||
                                                w === 25 ||
                                                w === 23 ||
                                                w === 24 ||
                                                w === 26)
                                        ) {
                                            g = $append(g, 90);
                                            break;
                                        }
                                        ak =
                                            ((aj = m / 60),
                                            aj === aj && aj !== 1 / 0 && aj !== -1 / 0
                                                ? aj >> 0
                                                : $throwRuntimeError(
                                                      'integer divide by zero'
                                                  ));
                                        al = m;
                                        if (ak < 0) {
                                            g = $append(g, 45);
                                            ak = -ak;
                                            al = -al;
                                        } else {
                                            g = $append(g, 43);
                                        }
                                        g = Z(
                                            g,
                                            ((am = ak / 60),
                                            am === am && am !== 1 / 0 && am !== -1 / 0
                                                ? am >> 0
                                                : $throwRuntimeError(
                                                      'integer divide by zero'
                                                  )),
                                            2
                                        );
                                        if (
                                            w === 25 ||
                                            w === 30 ||
                                            w === 26 ||
                                            w === 31
                                        ) {
                                            g = $append(g, 58);
                                        }
                                        if (!(w === 29) && !(w === 24)) {
                                            g = Z(
                                                g,
                                                ((an = ak % 60),
                                                an === an
                                                    ? an
                                                    : $throwRuntimeError(
                                                          'integer divide by zero'
                                                      )),
                                                2
                                            );
                                        }
                                        if (
                                            w === 23 ||
                                            w === 28 ||
                                            w === 31 ||
                                            w === 26
                                        ) {
                                            if (w === 31 || w === 26) {
                                                g = $append(g, 58);
                                            }
                                            g = Z(
                                                g,
                                                ((ao = al % 60),
                                                ao === ao
                                                    ? ao
                                                    : $throwRuntimeError(
                                                          'integer divide by zero'
                                                      )),
                                                2
                                            );
                                        }
                                    } else if (aa === 21) {
                                        if (!(l === '')) {
                                            g = $appendSlice(g, l);
                                            break;
                                        }
                                        aq =
                                            ((ap = m / 60),
                                            ap === ap && ap !== 1 / 0 && ap !== -1 / 0
                                                ? ap >> 0
                                                : $throwRuntimeError(
                                                      'integer divide by zero'
                                                  ));
                                        if (aq < 0) {
                                            g = $append(g, 45);
                                            aq = -aq;
                                        } else {
                                            g = $append(g, 43);
                                        }
                                        g = Z(
                                            g,
                                            ((ar = aq / 60),
                                            ar === ar && ar !== 1 / 0 && ar !== -1 / 0
                                                ? ar >> 0
                                                : $throwRuntimeError(
                                                      'integer divide by zero'
                                                  )),
                                            2
                                        );
                                        g = Z(
                                            g,
                                            ((as = aq % 60),
                                            as === as
                                                ? as
                                                : $throwRuntimeError(
                                                      'integer divide by zero'
                                                  )),
                                            2
                                        );
                                    } else if (aa === 32 || aa === 33) {
                                        g = AC(
                                            g,
                                            $clone(i, BK).Nanosecond() >>> 0,
                                            (w >> 16) >> 0,
                                            (w & 65535) === 33
                                        );
                                    }
                            }
                        }
                        $s = -1;
                        return g;
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.AppendFormat };
            }
            $f.aa = aa;
            $f.ab = ab;
            $f.ac = ac;
            $f.ad = ad;
            $f.ae = ae;
            $f.af = af;
            $f.ag = ag;
            $f.ah = ah;
            $f.ai = ai;
            $f.aj = aj;
            $f.ak = ak;
            $f.al = al;
            $f.am = am;
            $f.an = an;
            $f.ao = ao;
            $f.ap = ap;
            $f.aq = aq;
            $f.ar = ar;
            $f.as = as;
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.k = k;
            $f.l = l;
            $f.m = m;
            $f.n = n;
            $f.o = o;
            $f.p = p;
            $f.q = q;
            $f.r = r;
            $f.s = s;
            $f.t = t;
            $f.u = u;
            $f.v = v;
            $f.w = w;
            $f.x = x;
            $f.y = y;
            $f.z = z;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.AppendFormat = function (g, h) {
            return this.$val.AppendFormat(g, h);
        };
        AF = function (g) {
            var g;
            return '"' + g + '"';
        };
        AE.ptr.prototype.Error = function () {
            var g;
            g = this;
            if (g.Message === '') {
                return (
                    'parsing time ' +
                    AF(g.Value) +
                    ' as ' +
                    AF(g.Layout) +
                    ': cannot parse ' +
                    AF(g.ValueElem) +
                    ' as ' +
                    AF(g.LayoutElem)
                );
            }
            return 'parsing time ' + AF(g.Value) + g.Message;
        };
        AE.prototype.Error = function () {
            return this.$val.Error();
        };
        AG = function (g, h) {
            var g, h, i;
            if (g.length <= h) {
                return false;
            }
            i = g.charCodeAt(h);
            return 48 <= i && i <= 57;
        };
        AH = function (g, h) {
            var g, h;
            if (!AG(g, 0)) {
                return [0, g, AD];
            }
            if (!AG(g, 1)) {
                if (h) {
                    return [0, g, AD];
                }
                return [
                    (((g.charCodeAt(0) - 48) << 24) >>> 24) >> 0,
                    $substring(g, 1),
                    $ifaceNil,
                ];
            }
            return [
                ($imul((((g.charCodeAt(0) - 48) << 24) >>> 24) >> 0, 10) +
                    ((((g.charCodeAt(1) - 48) << 24) >>> 24) >> 0)) >>
                    0,
                $substring(g, 2),
                $ifaceNil,
            ];
        };
        AI = function (g) {
            var g;
            while (true) {
                if (!(g.length > 0 && g.charCodeAt(0) === 32)) {
                    break;
                }
                g = $substring(g, 1);
            }
            return g;
        };
        AJ = function (g, h) {
            var g, h;
            while (true) {
                if (!(h.length > 0)) {
                    break;
                }
                if (h.charCodeAt(0) === 32) {
                    if (g.length > 0 && !(g.charCodeAt(0) === 32)) {
                        return [g, AD];
                    }
                    h = AI(h);
                    g = AI(g);
                    continue;
                }
                if (g.length === 0 || !(g.charCodeAt(0) === h.charCodeAt(0))) {
                    return [g, AD];
                }
                h = $substring(h, 1);
                g = $substring(g, 1);
            }
            return [g, $ifaceNil];
        };
        AK = function (g, h) {
            var g, h, i, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        i = AM(g, h, $pkg.UTC, $pkg.Local);
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            i = i.$blk();
                        }
                        if (i && i.$blk !== undefined) {
                            break s;
                        }
                        $s = -1;
                        return i;
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: AK };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        $pkg.Parse = AK;
        AM = function (g, h, i, j) {
            var aa,
                ab,
                ac,
                ad,
                ae,
                af,
                ag,
                ah,
                ai,
                aj,
                ak,
                al,
                am,
                an,
                ao,
                ap,
                aq,
                ar,
                as,
                at,
                au,
                av,
                aw,
                ax,
                ay,
                az,
                ba,
                bb,
                bc,
                bd,
                be,
                bf,
                bg,
                bh,
                bi,
                bj,
                bk,
                bl,
                bm,
                bn,
                bo,
                bp,
                bq,
                br,
                bs,
                bt,
                bu,
                bv,
                bw,
                bx,
                by,
                bz,
                ca,
                cb,
                cc,
                cd,
                ce,
                cf,
                cg,
                ch,
                ci,
                cj,
                ck,
                cl,
                cm,
                cn,
                co,
                cp,
                cq,
                cr,
                cs,
                ct,
                cu,
                cv,
                cw,
                cx,
                cy,
                cz,
                da,
                db,
                dc,
                dd,
                de,
                df,
                dg,
                dh,
                di,
                dj,
                dk,
                dl,
                dm,
                dn,
                dp,
                dq,
                dr,
                ds,
                dt,
                du,
                dv,
                dw,
                dx,
                dy,
                dz,
                ea,
                g,
                h,
                i,
                j,
                k,
                l,
                m,
                n,
                o,
                p,
                q,
                r,
                s,
                t,
                u,
                v,
                w,
                x,
                y,
                z,
                $s,
                $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                aa = $f.aa;
                ab = $f.ab;
                ac = $f.ac;
                ad = $f.ad;
                ae = $f.ae;
                af = $f.af;
                ag = $f.ag;
                ah = $f.ah;
                ai = $f.ai;
                aj = $f.aj;
                ak = $f.ak;
                al = $f.al;
                am = $f.am;
                an = $f.an;
                ao = $f.ao;
                ap = $f.ap;
                aq = $f.aq;
                ar = $f.ar;
                as = $f.as;
                at = $f.at;
                au = $f.au;
                av = $f.av;
                aw = $f.aw;
                ax = $f.ax;
                ay = $f.ay;
                az = $f.az;
                ba = $f.ba;
                bb = $f.bb;
                bc = $f.bc;
                bd = $f.bd;
                be = $f.be;
                bf = $f.bf;
                bg = $f.bg;
                bh = $f.bh;
                bi = $f.bi;
                bj = $f.bj;
                bk = $f.bk;
                bl = $f.bl;
                bm = $f.bm;
                bn = $f.bn;
                bo = $f.bo;
                bp = $f.bp;
                bq = $f.bq;
                br = $f.br;
                bs = $f.bs;
                bt = $f.bt;
                bu = $f.bu;
                bv = $f.bv;
                bw = $f.bw;
                bx = $f.bx;
                by = $f.by;
                bz = $f.bz;
                ca = $f.ca;
                cb = $f.cb;
                cc = $f.cc;
                cd = $f.cd;
                ce = $f.ce;
                cf = $f.cf;
                cg = $f.cg;
                ch = $f.ch;
                ci = $f.ci;
                cj = $f.cj;
                ck = $f.ck;
                cl = $f.cl;
                cm = $f.cm;
                cn = $f.cn;
                co = $f.co;
                cp = $f.cp;
                cq = $f.cq;
                cr = $f.cr;
                cs = $f.cs;
                ct = $f.ct;
                cu = $f.cu;
                cv = $f.cv;
                cw = $f.cw;
                cx = $f.cx;
                cy = $f.cy;
                cz = $f.cz;
                da = $f.da;
                db = $f.db;
                dc = $f.dc;
                dd = $f.dd;
                de = $f.de;
                df = $f.df;
                dg = $f.dg;
                dh = $f.dh;
                di = $f.di;
                dj = $f.dj;
                dk = $f.dk;
                dl = $f.dl;
                dm = $f.dm;
                dn = $f.dn;
                dp = $f.dp;
                dq = $f.dq;
                dr = $f.dr;
                ds = $f.ds;
                dt = $f.dt;
                du = $f.du;
                dv = $f.dv;
                dw = $f.dw;
                dx = $f.dx;
                dy = $f.dy;
                dz = $f.dz;
                ea = $f.ea;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                k = $f.k;
                l = $f.l;
                m = $f.m;
                n = $f.n;
                o = $f.o;
                p = $f.p;
                q = $f.q;
                r = $f.r;
                s = $f.s;
                t = $f.t;
                u = $f.u;
                v = $f.v;
                w = $f.w;
                x = $f.x;
                y = $f.y;
                z = $f.z;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        k = g;
                        l = h;
                        m = k;
                        n = l;
                        o = '';
                        p = false;
                        q = false;
                        r = 0;
                        s = 1;
                        t = 1;
                        u = 0;
                        v = 0;
                        w = 0;
                        x = 0;
                        y = DS.nil;
                        z = -1;
                        aa = '';
                        while (true) {
                            ab = $ifaceNil;
                            ac = S(g);
                            ad = ac[0];
                            ae = ac[1];
                            af = ac[2];
                            ag = $substring(g, ad.length, (g.length - af.length) >> 0);
                            ah = AJ(h, ad);
                            h = ah[0];
                            ab = ah[1];
                            if (!$interfaceIsEqual(ab, $ifaceNil)) {
                                $s = -1;
                                return [
                                    new BK.ptr(
                                        new $Uint64(0, 0),
                                        new $Int64(0, 0),
                                        DS.nil
                                    ),
                                    new AE.ptr(m, n, ad, h, ''),
                                ];
                            }
                            if (ae === 0) {
                                if (!(h.length === 0)) {
                                    $s = -1;
                                    return [
                                        new BK.ptr(
                                            new $Uint64(0, 0),
                                            new $Int64(0, 0),
                                            DS.nil
                                        ),
                                        new AE.ptr(m, n, '', h, ': extra text: ' + h),
                                    ];
                                }
                                break;
                            }
                            g = af;
                            ai = '';
                            switch (0) {
                                default:
                                    aj = ae & 65535;
                                    if (aj === 274) {
                                        if (h.length < 2) {
                                            ab = AD;
                                            break;
                                        }
                                        ak = $substring(h, 0, 2);
                                        al = $substring(h, 2);
                                        ai = ak;
                                        h = al;
                                        am = AB(ai);
                                        r = am[0];
                                        ab = am[1];
                                        if (r >= 69) {
                                            r = (r + 1900) >> 0;
                                        } else {
                                            r = (r + 2000) >> 0;
                                        }
                                    } else if (aj === 273) {
                                        if (h.length < 4 || !AG(h, 0)) {
                                            ab = AD;
                                            break;
                                        }
                                        an = $substring(h, 0, 4);
                                        ao = $substring(h, 4);
                                        ai = an;
                                        h = ao;
                                        ap = AB(ai);
                                        r = ap[0];
                                        ab = ap[1];
                                    } else if (aj === 258) {
                                        aq = Y(V, h);
                                        s = aq[0];
                                        h = aq[1];
                                        ab = aq[2];
                                        s = (s + 1) >> 0;
                                    } else if (aj === 257) {
                                        ar = Y(W, h);
                                        s = ar[0];
                                        h = ar[1];
                                        ab = ar[2];
                                        s = (s + 1) >> 0;
                                    } else if (aj === 259 || aj === 260) {
                                        as = AH(h, ae === 260);
                                        s = as[0];
                                        h = as[1];
                                        ab = as[2];
                                        if (s <= 0 || 12 < s) {
                                            o = 'month';
                                        }
                                    } else if (aj === 262) {
                                        at = Y(U, h);
                                        h = at[1];
                                        ab = at[2];
                                    } else if (aj === 261) {
                                        au = Y(T, h);
                                        h = au[1];
                                        ab = au[2];
                                    } else if (aj === 263 || aj === 264 || aj === 265) {
                                        if (
                                            ae === 264 &&
                                            h.length > 0 &&
                                            h.charCodeAt(0) === 32
                                        ) {
                                            h = $substring(h, 1);
                                        }
                                        av = AH(h, ae === 265);
                                        t = av[0];
                                        h = av[1];
                                        ab = av[2];
                                        if (t < 0) {
                                            o = 'day';
                                        }
                                    } else if (aj === 522) {
                                        aw = AH(h, false);
                                        u = aw[0];
                                        h = aw[1];
                                        ab = aw[2];
                                        if (u < 0 || 24 <= u) {
                                            o = 'hour';
                                        }
                                    } else if (aj === 523 || aj === 524) {
                                        ax = AH(h, ae === 524);
                                        u = ax[0];
                                        h = ax[1];
                                        ab = ax[2];
                                        if (u < 0 || 12 < u) {
                                            o = 'hour';
                                        }
                                    } else if (aj === 525 || aj === 526) {
                                        ay = AH(h, ae === 526);
                                        v = ay[0];
                                        h = ay[1];
                                        ab = ay[2];
                                        if (v < 0 || 60 <= v) {
                                            o = 'minute';
                                        }
                                    } else if (aj === 527 || aj === 528) {
                                        az = AH(h, ae === 528);
                                        w = az[0];
                                        h = az[1];
                                        ab = az[2];
                                        if (w < 0 || 60 <= w) {
                                            o = 'second';
                                            break;
                                        }
                                        if (
                                            h.length >= 2 &&
                                            h.charCodeAt(0) === 46 &&
                                            AG(h, 1)
                                        ) {
                                            ba = S(g);
                                            ae = ba[1];
                                            ae = ae & 65535;
                                            if (ae === 32 || ae === 33) {
                                                break;
                                            }
                                            bb = 2;
                                            while (true) {
                                                if (!(bb < h.length && AG(h, bb))) {
                                                    break;
                                                }
                                                bb = (bb + 1) >> 0;
                                            }
                                            bc = AP(h, bb);
                                            x = bc[0];
                                            o = bc[1];
                                            ab = bc[2];
                                            h = $substring(h, bb);
                                        }
                                    } else if (aj === 531) {
                                        if (h.length < 2) {
                                            ab = AD;
                                            break;
                                        }
                                        bd = $substring(h, 0, 2);
                                        be = $substring(h, 2);
                                        ai = bd;
                                        h = be;
                                        bf = ai;
                                        if (bf === 'PM') {
                                            q = true;
                                        } else if (bf === 'AM') {
                                            p = true;
                                        } else {
                                            ab = AD;
                                        }
                                    } else if (aj === 532) {
                                        if (h.length < 2) {
                                            ab = AD;
                                            break;
                                        }
                                        bg = $substring(h, 0, 2);
                                        bh = $substring(h, 2);
                                        ai = bg;
                                        h = bh;
                                        bi = ai;
                                        if (bi === 'pm') {
                                            q = true;
                                        } else if (bi === 'am') {
                                            p = true;
                                        } else {
                                            ab = AD;
                                        }
                                    } else if (
                                        aj === 22 ||
                                        aj === 25 ||
                                        aj === 23 ||
                                        aj === 24 ||
                                        aj === 26 ||
                                        aj === 27 ||
                                        aj === 29 ||
                                        aj === 30 ||
                                        aj === 28 ||
                                        aj === 31
                                    ) {
                                        if (
                                            (ae === 22 || ae === 24 || ae === 25) &&
                                            h.length >= 1 &&
                                            h.charCodeAt(0) === 90
                                        ) {
                                            h = $substring(h, 1);
                                            y = $pkg.UTC;
                                            break;
                                        }
                                        bj = '';
                                        bk = '';
                                        bl = '';
                                        bm = '';
                                        bn = bj;
                                        bo = bk;
                                        bp = bl;
                                        bq = bm;
                                        if (ae === 25 || ae === 30) {
                                            if (h.length < 6) {
                                                ab = AD;
                                                break;
                                            }
                                            if (!(h.charCodeAt(3) === 58)) {
                                                ab = AD;
                                                break;
                                            }
                                            br = $substring(h, 0, 1);
                                            bs = $substring(h, 1, 3);
                                            bt = $substring(h, 4, 6);
                                            bu = '00';
                                            bv = $substring(h, 6);
                                            bn = br;
                                            bo = bs;
                                            bp = bt;
                                            bq = bu;
                                            h = bv;
                                        } else if (ae === 29 || ae === 24) {
                                            if (h.length < 3) {
                                                ab = AD;
                                                break;
                                            }
                                            bw = $substring(h, 0, 1);
                                            bx = $substring(h, 1, 3);
                                            by = '00';
                                            bz = '00';
                                            ca = $substring(h, 3);
                                            bn = bw;
                                            bo = bx;
                                            bp = by;
                                            bq = bz;
                                            h = ca;
                                        } else if (ae === 26 || ae === 31) {
                                            if (h.length < 9) {
                                                ab = AD;
                                                break;
                                            }
                                            if (
                                                !(h.charCodeAt(3) === 58) ||
                                                !(h.charCodeAt(6) === 58)
                                            ) {
                                                ab = AD;
                                                break;
                                            }
                                            cb = $substring(h, 0, 1);
                                            cc = $substring(h, 1, 3);
                                            cd = $substring(h, 4, 6);
                                            ce = $substring(h, 7, 9);
                                            cf = $substring(h, 9);
                                            bn = cb;
                                            bo = cc;
                                            bp = cd;
                                            bq = ce;
                                            h = cf;
                                        } else if (ae === 23 || ae === 28) {
                                            if (h.length < 7) {
                                                ab = AD;
                                                break;
                                            }
                                            cg = $substring(h, 0, 1);
                                            ch = $substring(h, 1, 3);
                                            ci = $substring(h, 3, 5);
                                            cj = $substring(h, 5, 7);
                                            ck = $substring(h, 7);
                                            bn = cg;
                                            bo = ch;
                                            bp = ci;
                                            bq = cj;
                                            h = ck;
                                        } else {
                                            if (h.length < 5) {
                                                ab = AD;
                                                break;
                                            }
                                            cl = $substring(h, 0, 1);
                                            cm = $substring(h, 1, 3);
                                            cn = $substring(h, 3, 5);
                                            co = '00';
                                            cp = $substring(h, 5);
                                            bn = cl;
                                            bo = cm;
                                            bp = cn;
                                            bq = co;
                                            h = cp;
                                        }
                                        cq = 0;
                                        cr = 0;
                                        cs = 0;
                                        ct = cq;
                                        cu = cr;
                                        cv = cs;
                                        cw = AB(bo);
                                        ct = cw[0];
                                        ab = cw[1];
                                        if ($interfaceIsEqual(ab, $ifaceNil)) {
                                            cx = AB(bp);
                                            cu = cx[0];
                                            ab = cx[1];
                                        }
                                        if ($interfaceIsEqual(ab, $ifaceNil)) {
                                            cy = AB(bq);
                                            cv = cy[0];
                                            ab = cy[1];
                                        }
                                        z =
                                            ($imul(($imul(ct, 60) + cu) >> 0, 60) + cv) >>
                                            0;
                                        cz = bn.charCodeAt(0);
                                        if (cz === 43) {
                                        } else if (cz === 45) {
                                            z = -z;
                                        } else {
                                            ab = AD;
                                        }
                                    } else if (aj === 21) {
                                        if (
                                            h.length >= 3 &&
                                            $substring(h, 0, 3) === 'UTC'
                                        ) {
                                            y = $pkg.UTC;
                                            h = $substring(h, 3);
                                            break;
                                        }
                                        da = AN(h);
                                        db = da[0];
                                        dc = da[1];
                                        if (!dc) {
                                            ab = AD;
                                            break;
                                        }
                                        dd = $substring(h, 0, db);
                                        de = $substring(h, db);
                                        aa = dd;
                                        h = de;
                                    } else if (aj === 32) {
                                        df = (1 + ((ae >> 16) >> 0)) >> 0;
                                        if (h.length < df) {
                                            ab = AD;
                                            break;
                                        }
                                        dg = AP(h, df);
                                        x = dg[0];
                                        o = dg[1];
                                        ab = dg[2];
                                        h = $substring(h, df);
                                    } else if (aj === 33) {
                                        if (
                                            h.length < 2 ||
                                            !(h.charCodeAt(0) === 46) ||
                                            h.charCodeAt(1) < 48 ||
                                            57 < h.charCodeAt(1)
                                        ) {
                                            break;
                                        }
                                        dh = 0;
                                        while (true) {
                                            if (
                                                !(
                                                    dh < 9 &&
                                                    (dh + 1) >> 0 < h.length &&
                                                    48 <= h.charCodeAt((dh + 1) >> 0) &&
                                                    h.charCodeAt((dh + 1) >> 0) <= 57
                                                )
                                            ) {
                                                break;
                                            }
                                            dh = (dh + 1) >> 0;
                                        }
                                        di = AP(h, (1 + dh) >> 0);
                                        x = di[0];
                                        o = di[1];
                                        ab = di[2];
                                        h = $substring(h, (1 + dh) >> 0);
                                    }
                            }
                            if (!(o === '')) {
                                $s = -1;
                                return [
                                    new BK.ptr(
                                        new $Uint64(0, 0),
                                        new $Int64(0, 0),
                                        DS.nil
                                    ),
                                    new AE.ptr(m, n, ag, h, ': ' + o + ' out of range'),
                                ];
                            }
                            if (!$interfaceIsEqual(ab, $ifaceNil)) {
                                $s = -1;
                                return [
                                    new BK.ptr(
                                        new $Uint64(0, 0),
                                        new $Int64(0, 0),
                                        DS.nil
                                    ),
                                    new AE.ptr(m, n, ag, h, ''),
                                ];
                            }
                        }
                        if (q && u < 12) {
                            u = (u + 12) >> 0;
                        } else if (p && u === 12) {
                            u = 0;
                        }
                        if (t < 1 || t > BZ(s >> 0, r)) {
                            $s = -1;
                            return [
                                new BK.ptr(new $Uint64(0, 0), new $Int64(0, 0), DS.nil),
                                new AE.ptr(m, n, '', h, ': day out of range'),
                            ];
                        }
                        if (!(y === DS.nil)) {
                            $s = 1;
                            continue;
                        }
                        $s = 2;
                        continue;
                    case 1:
                        dj = CF(r, s >> 0, t, u, v, w, x, y);
                        $s = 3;
                    case 3:
                        if ($c) {
                            $c = false;
                            dj = dj.$blk();
                        }
                        if (dj && dj.$blk !== undefined) {
                            break s;
                        }
                        $s = -1;
                        return [dj, $ifaceNil];
                    case 2:
                        if (!(z === -1)) {
                            $s = 4;
                            continue;
                        }
                        $s = 5;
                        continue;
                    case 4:
                        dk = CF(r, s >> 0, t, u, v, w, x, $pkg.UTC);
                        $s = 6;
                    case 6:
                        if ($c) {
                            $c = false;
                            dk = dk.$blk();
                        }
                        if (dk && dk.$blk !== undefined) {
                            break s;
                        }
                        dl = $clone(dk, BK);
                        dl.addSec(
                            ((dm = new $Int64(0, z)), new $Int64(-dm.$high, -dm.$low))
                        );
                        dp = j.lookup(dl.unixSec());
                        $s = 7;
                    case 7:
                        if ($c) {
                            $c = false;
                            dp = dp.$blk();
                        }
                        if (dp && dp.$blk !== undefined) {
                            break s;
                        }
                        dn = dp;
                        dq = dn[0];
                        dr = dn[1];
                        if (dr === z && (aa === '' || dq === aa)) {
                            dl.setLoc(j);
                            $s = -1;
                            return [dl, $ifaceNil];
                        }
                        dl.setLoc(CN(aa, z));
                        $s = -1;
                        return [dl, $ifaceNil];
                    case 5:
                        if (!(aa === '')) {
                            $s = 8;
                            continue;
                        }
                        $s = 9;
                        continue;
                    case 8:
                        ds = CF(r, s >> 0, t, u, v, w, x, $pkg.UTC);
                        $s = 10;
                    case 10:
                        if ($c) {
                            $c = false;
                            ds = ds.$blk();
                        }
                        if (ds && ds.$blk !== undefined) {
                            break s;
                        }
                        dt = $clone(ds, BK);
                        dv = j.lookupName(aa, dt.unixSec());
                        $s = 11;
                    case 11:
                        if ($c) {
                            $c = false;
                            dv = dv.$blk();
                        }
                        if (dv && dv.$blk !== undefined) {
                            break s;
                        }
                        du = dv;
                        dw = du[0];
                        dx = du[1];
                        if (dx) {
                            dt.addSec(
                                ((dy = new $Int64(0, dw)),
                                new $Int64(-dy.$high, -dy.$low))
                            );
                            dt.setLoc(j);
                            $s = -1;
                            return [dt, $ifaceNil];
                        }
                        if (aa.length > 3 && $substring(aa, 0, 3) === 'GMT') {
                            dz = AB($substring(aa, 3));
                            dw = dz[0];
                            dw = $imul(dw, 3600);
                        }
                        dt.setLoc(CN(aa, dw));
                        $s = -1;
                        return [dt, $ifaceNil];
                    case 9:
                        ea = CF(r, s >> 0, t, u, v, w, x, i);
                        $s = 12;
                    case 12:
                        if ($c) {
                            $c = false;
                            ea = ea.$blk();
                        }
                        if (ea && ea.$blk !== undefined) {
                            break s;
                        }
                        $s = -1;
                        return [ea, $ifaceNil];
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: AM };
            }
            $f.aa = aa;
            $f.ab = ab;
            $f.ac = ac;
            $f.ad = ad;
            $f.ae = ae;
            $f.af = af;
            $f.ag = ag;
            $f.ah = ah;
            $f.ai = ai;
            $f.aj = aj;
            $f.ak = ak;
            $f.al = al;
            $f.am = am;
            $f.an = an;
            $f.ao = ao;
            $f.ap = ap;
            $f.aq = aq;
            $f.ar = ar;
            $f.as = as;
            $f.at = at;
            $f.au = au;
            $f.av = av;
            $f.aw = aw;
            $f.ax = ax;
            $f.ay = ay;
            $f.az = az;
            $f.ba = ba;
            $f.bb = bb;
            $f.bc = bc;
            $f.bd = bd;
            $f.be = be;
            $f.bf = bf;
            $f.bg = bg;
            $f.bh = bh;
            $f.bi = bi;
            $f.bj = bj;
            $f.bk = bk;
            $f.bl = bl;
            $f.bm = bm;
            $f.bn = bn;
            $f.bo = bo;
            $f.bp = bp;
            $f.bq = bq;
            $f.br = br;
            $f.bs = bs;
            $f.bt = bt;
            $f.bu = bu;
            $f.bv = bv;
            $f.bw = bw;
            $f.bx = bx;
            $f.by = by;
            $f.bz = bz;
            $f.ca = ca;
            $f.cb = cb;
            $f.cc = cc;
            $f.cd = cd;
            $f.ce = ce;
            $f.cf = cf;
            $f.cg = cg;
            $f.ch = ch;
            $f.ci = ci;
            $f.cj = cj;
            $f.ck = ck;
            $f.cl = cl;
            $f.cm = cm;
            $f.cn = cn;
            $f.co = co;
            $f.cp = cp;
            $f.cq = cq;
            $f.cr = cr;
            $f.cs = cs;
            $f.ct = ct;
            $f.cu = cu;
            $f.cv = cv;
            $f.cw = cw;
            $f.cx = cx;
            $f.cy = cy;
            $f.cz = cz;
            $f.da = da;
            $f.db = db;
            $f.dc = dc;
            $f.dd = dd;
            $f.de = de;
            $f.df = df;
            $f.dg = dg;
            $f.dh = dh;
            $f.di = di;
            $f.dj = dj;
            $f.dk = dk;
            $f.dl = dl;
            $f.dm = dm;
            $f.dn = dn;
            $f.dp = dp;
            $f.dq = dq;
            $f.dr = dr;
            $f.ds = ds;
            $f.dt = dt;
            $f.du = du;
            $f.dv = dv;
            $f.dw = dw;
            $f.dx = dx;
            $f.dy = dy;
            $f.dz = dz;
            $f.ea = ea;
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.k = k;
            $f.l = l;
            $f.m = m;
            $f.n = n;
            $f.o = o;
            $f.p = p;
            $f.q = q;
            $f.r = r;
            $f.s = s;
            $f.t = t;
            $f.u = u;
            $f.v = v;
            $f.w = w;
            $f.x = x;
            $f.y = y;
            $f.z = z;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        AN = function (g) {
            var aa, ab, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, x, y, z;
            h = 0;
            i = false;
            if (g.length < 3) {
                j = 0;
                k = false;
                h = j;
                i = k;
                return [h, i];
            }
            if (
                g.length >= 4 &&
                ($substring(g, 0, 4) === 'ChST' || $substring(g, 0, 4) === 'MeST')
            ) {
                l = 4;
                m = true;
                h = l;
                i = m;
                return [h, i];
            }
            if ($substring(g, 0, 3) === 'GMT') {
                h = AO(g);
                n = h;
                o = true;
                h = n;
                i = o;
                return [h, i];
            }
            p = 0;
            p = 0;
            while (true) {
                if (!(p < 6)) {
                    break;
                }
                if (p >= g.length) {
                    break;
                }
                q = g.charCodeAt(p);
                if (q < 65 || 90 < q) {
                    break;
                }
                p = (p + 1) >> 0;
            }
            r = p;
            if (r === 0 || r === 1 || r === 2 || r === 6) {
                s = 0;
                t = false;
                h = s;
                i = t;
                return [h, i];
            } else if (r === 5) {
                if (g.charCodeAt(4) === 84) {
                    u = 5;
                    v = true;
                    h = u;
                    i = v;
                    return [h, i];
                }
            } else if (r === 4) {
                if (g.charCodeAt(3) === 84 || $substring(g, 0, 4) === 'WITA') {
                    w = 4;
                    x = true;
                    h = w;
                    i = x;
                    return [h, i];
                }
            } else if (r === 3) {
                y = 3;
                z = true;
                h = y;
                i = z;
                return [h, i];
            }
            aa = 0;
            ab = false;
            h = aa;
            i = ab;
            return [h, i];
        };
        AO = function (g) {
            var g, h, i, j, k, l;
            g = $substring(g, 3);
            if (g.length === 0) {
                return 3;
            }
            h = g.charCodeAt(0);
            if (!(h === 45) && !(h === 43)) {
                return 3;
            }
            i = AR($substring(g, 1));
            j = i[0];
            k = i[1];
            l = i[2];
            if (!$interfaceIsEqual(l, $ifaceNil)) {
                return 3;
            }
            if (h === 45) {
                j = new $Int64(-j.$high, -j.$low);
            }
            if (
                (j.$high === 0 && j.$low === 0) ||
                j.$high < -1 ||
                (j.$high === -1 && j.$low < 4294967282) ||
                0 < j.$high ||
                (0 === j.$high && 12 < j.$low)
            ) {
                return 3;
            }
            return (((3 + g.length) >> 0) - k.length) >> 0;
        };
        AP = function (g, h) {
            var g, h, i, j, k, l, m, n;
            i = 0;
            j = '';
            k = $ifaceNil;
            if (!(g.charCodeAt(0) === 46)) {
                k = AD;
                return [i, j, k];
            }
            l = AB($substring(g, 1, h));
            i = l[0];
            k = l[1];
            if (!$interfaceIsEqual(k, $ifaceNil)) {
                return [i, j, k];
            }
            if (i < 0 || 1000000000 <= i) {
                j = 'fractional second';
                return [i, j, k];
            }
            m = (10 - h) >> 0;
            n = 0;
            while (true) {
                if (!(n < m)) {
                    break;
                }
                i = $imul(i, 10);
                n = (n + 1) >> 0;
            }
            return [i, j, k];
        };
        AR = function (g) {
            var g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, x;
            h = new $Int64(0, 0);
            i = '';
            j = $ifaceNil;
            k = 0;
            while (true) {
                if (!(k < g.length)) {
                    break;
                }
                l = g.charCodeAt(k);
                if (l < 48 || l > 57) {
                    break;
                }
                if (
                    h.$high > 214748364 ||
                    (h.$high === 214748364 && h.$low > 3435973836)
                ) {
                    m = new $Int64(0, 0);
                    n = '';
                    o = AQ;
                    h = m;
                    i = n;
                    j = o;
                    return [h, i, j];
                }
                h =
                    ((p =
                        ((q = $mul64(h, new $Int64(0, 10))),
                        (r = new $Int64(0, l)),
                        new $Int64(q.$high + r.$high, q.$low + r.$low))),
                    new $Int64(p.$high - 0, p.$low - 48));
                if (h.$high < 0 || (h.$high === 0 && h.$low < 0)) {
                    s = new $Int64(0, 0);
                    t = '';
                    u = AQ;
                    h = s;
                    i = t;
                    j = u;
                    return [h, i, j];
                }
                k = (k + 1) >> 0;
            }
            v = h;
            w = $substring(g, k);
            x = $ifaceNil;
            h = v;
            i = w;
            j = x;
            return [h, i, j];
        };
        BK.ptr.prototype.nsec = function () {
            var g, h;
            g = this;
            return (
                ((h = g.wall), new $Uint64(h.$high & 0, (h.$low & 1073741823) >>> 0))
                    .$low >> 0
            );
        };
        BK.prototype.nsec = function () {
            return this.$val.nsec();
        };
        BK.ptr.prototype.sec = function () {
            var g, h, i, j, k;
            g = this;
            if (
                !((h =
                    ((i = g.wall),
                    new $Uint64(i.$high & 2147483648, (i.$low & 0) >>> 0))),
                h.$high === 0 && h.$low === 0)
            ) {
                return (
                    (j =
                        ((k = $shiftRightUint64($shiftLeft64(g.wall, 1), 31)),
                        new $Int64(k.$high, k.$low))),
                    new $Int64(13 + j.$high, 3618733952 + j.$low)
                );
            }
            return g.ext;
        };
        BK.prototype.sec = function () {
            return this.$val.sec();
        };
        BK.ptr.prototype.unixSec = function () {
            var g, h;
            g = this;
            return (h = g.sec()), new $Int64(h.$high + -15, h.$low + 2288912640);
        };
        BK.prototype.unixSec = function () {
            return this.$val.unixSec();
        };
        BK.ptr.prototype.addSec = function (g) {
            var g, h, i, j, k, l, m, n, o, p, q, r, s;
            h = this;
            if (
                !((i =
                    ((j = h.wall),
                    new $Uint64(j.$high & 2147483648, (j.$low & 0) >>> 0))),
                i.$high === 0 && i.$low === 0)
            ) {
                l =
                    ((k = $shiftRightUint64($shiftLeft64(h.wall, 1), 31)),
                    new $Int64(k.$high, k.$low));
                m = new $Int64(l.$high + g.$high, l.$low + g.$low);
                if (
                    (0 < m.$high || (0 === m.$high && 0 <= m.$low)) &&
                    (m.$high < 1 || (m.$high === 1 && m.$low <= 4294967295))
                ) {
                    h.wall =
                        ((n =
                            ((o =
                                ((p = h.wall),
                                new $Uint64(p.$high & 0, (p.$low & 1073741823) >>> 0))),
                            (q = $shiftLeft64(new $Uint64(m.$high, m.$low), 30)),
                            new $Uint64(o.$high | q.$high, (o.$low | q.$low) >>> 0))),
                        new $Uint64(n.$high | 2147483648, (n.$low | 0) >>> 0));
                    return;
                }
                h.stripMono();
            }
            h.ext =
                ((r = h.ext), (s = g), new $Int64(r.$high + s.$high, r.$low + s.$low));
        };
        BK.prototype.addSec = function (g) {
            return this.$val.addSec(g);
        };
        BK.ptr.prototype.setLoc = function (g) {
            var g, h;
            h = this;
            if (g === CK) {
                g = DS.nil;
            }
            h.stripMono();
            h.loc = g;
        };
        BK.prototype.setLoc = function (g) {
            return this.$val.setLoc(g);
        };
        BK.ptr.prototype.stripMono = function () {
            var g, h, i, j, k;
            g = this;
            if (
                !((h =
                    ((i = g.wall),
                    new $Uint64(i.$high & 2147483648, (i.$low & 0) >>> 0))),
                h.$high === 0 && h.$low === 0)
            ) {
                g.ext = g.sec();
                g.wall =
                    ((j = g.wall),
                    (k = new $Uint64(0, 1073741823)),
                    new $Uint64(j.$high & k.$high, (j.$low & k.$low) >>> 0));
            }
        };
        BK.prototype.stripMono = function () {
            return this.$val.stripMono();
        };
        BK.ptr.prototype.After = function (g) {
            var g, h, i, j, k, l, m, n, o, p;
            h = this;
            if (
                !((i =
                    ((j =
                        ((k = h.wall),
                        (l = g.wall),
                        new $Uint64(k.$high & l.$high, (k.$low & l.$low) >>> 0))),
                    new $Uint64(j.$high & 2147483648, (j.$low & 0) >>> 0))),
                i.$high === 0 && i.$low === 0)
            ) {
                return (
                    (m = h.ext),
                    (n = g.ext),
                    m.$high > n.$high || (m.$high === n.$high && m.$low > n.$low)
                );
            }
            o = h.sec();
            p = g.sec();
            return (
                o.$high > p.$high ||
                (o.$high === p.$high && o.$low > p.$low) ||
                (o.$high === p.$high && o.$low === p.$low && h.nsec() > g.nsec())
            );
        };
        BK.prototype.After = function (g) {
            return this.$val.After(g);
        };
        BK.ptr.prototype.Before = function (g) {
            var g, h, i, j, k, l, m, n, o, p, q, r;
            h = this;
            if (
                !((i =
                    ((j =
                        ((k = h.wall),
                        (l = g.wall),
                        new $Uint64(k.$high & l.$high, (k.$low & l.$low) >>> 0))),
                    new $Uint64(j.$high & 2147483648, (j.$low & 0) >>> 0))),
                i.$high === 0 && i.$low === 0)
            ) {
                return (
                    (m = h.ext),
                    (n = g.ext),
                    m.$high < n.$high || (m.$high === n.$high && m.$low < n.$low)
                );
            }
            return (
                ((o = h.sec()),
                (p = g.sec()),
                o.$high < p.$high || (o.$high === p.$high && o.$low < p.$low)) ||
                (((q = h.sec()),
                (r = g.sec()),
                q.$high === r.$high && q.$low === r.$low) &&
                    h.nsec() < g.nsec())
            );
        };
        BK.prototype.Before = function (g) {
            return this.$val.Before(g);
        };
        BK.ptr.prototype.Equal = function (g) {
            var g, h, i, j, k, l, m, n, o, p;
            h = this;
            if (
                !((i =
                    ((j =
                        ((k = h.wall),
                        (l = g.wall),
                        new $Uint64(k.$high & l.$high, (k.$low & l.$low) >>> 0))),
                    new $Uint64(j.$high & 2147483648, (j.$low & 0) >>> 0))),
                i.$high === 0 && i.$low === 0)
            ) {
                return (m = h.ext), (n = g.ext), m.$high === n.$high && m.$low === n.$low;
            }
            return (
                ((o = h.sec()),
                (p = g.sec()),
                o.$high === p.$high && o.$low === p.$low) && h.nsec() === g.nsec()
            );
        };
        BK.prototype.Equal = function (g) {
            return this.$val.Equal(g);
        };
        BL.prototype.String = function () {
            var g, h, i, j;
            g = this.$val;
            if (1 <= g && g <= 12) {
                return (
                    (h = (g - 1) >> 0),
                    h < 0 || h >= BM.length
                        ? ($throwRuntimeError('index out of range'), undefined)
                        : BM[h]
                );
            }
            i = $makeSlice(DP, 20);
            j = BT(i, new $Uint64(0, g));
            return '%!Month(' + $bytesToString($subslice(i, j)) + ')';
        };
        $ptrType(BL).prototype.String = function () {
            return new BL(this.$get()).String();
        };
        BN.prototype.String = function () {
            var g;
            g = this.$val;
            return g < 0 || g >= BO.length
                ? ($throwRuntimeError('index out of range'), undefined)
                : BO[g];
        };
        $ptrType(BN).prototype.String = function () {
            return new BN(this.$get()).String();
        };
        BK.ptr.prototype.IsZero = function () {
            var g, h;
            g = this;
            return ((h = g.sec()), h.$high === 0 && h.$low === 0) && g.nsec() === 0;
        };
        BK.prototype.IsZero = function () {
            return this.$val.IsZero();
        };
        BK.ptr.prototype.abs = function () {
            var g, h, i, j, k, l, m, n, o, p, q, r, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                k = $f.k;
                l = $f.l;
                m = $f.m;
                n = $f.n;
                o = $f.o;
                p = $f.p;
                q = $f.q;
                r = $f.r;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        g = this;
                        h = g.loc;
                        if (h === DS.nil || h === CL) {
                            $s = 1;
                            continue;
                        }
                        $s = 2;
                        continue;
                    case 1:
                        i = h.get();
                        $s = 3;
                    case 3:
                        if ($c) {
                            $c = false;
                            i = i.$blk();
                        }
                        if (i && i.$blk !== undefined) {
                            break s;
                        }
                        h = i;
                    case 2:
                        j = g.unixSec();
                        if (!(h === CK)) {
                            $s = 4;
                            continue;
                        }
                        $s = 5;
                        continue;
                    case 4:
                        if (
                            !(h.cacheZone === DK.nil) &&
                            ((k = h.cacheStart),
                            k.$high < j.$high ||
                                (k.$high === j.$high && k.$low <= j.$low)) &&
                            ((l = h.cacheEnd),
                            j.$high < l.$high || (j.$high === l.$high && j.$low < l.$low))
                        ) {
                            $s = 6;
                            continue;
                        }
                        $s = 7;
                        continue;
                    case 6:
                        j =
                            ((m = new $Int64(0, h.cacheZone.offset)),
                            new $Int64(j.$high + m.$high, j.$low + m.$low));
                        $s = 8;
                        continue;
                    case 7:
                        o = h.lookup(j);
                        $s = 9;
                    case 9:
                        if ($c) {
                            $c = false;
                            o = o.$blk();
                        }
                        if (o && o.$blk !== undefined) {
                            break s;
                        }
                        n = o;
                        p = n[1];
                        j =
                            ((q = new $Int64(0, p)),
                            new $Int64(j.$high + q.$high, j.$low + q.$low));
                    case 8:
                    case 5:
                        $s = -1;
                        return (
                            (r = new $Int64(j.$high + 2147483646, j.$low + 450480384)),
                            new $Uint64(r.$high, r.$low)
                        );
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.abs };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.k = k;
            $f.l = l;
            $f.m = m;
            $f.n = n;
            $f.o = o;
            $f.p = p;
            $f.q = q;
            $f.r = r;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.abs = function () {
            return this.$val.abs();
        };
        BK.ptr.prototype.locabs = function () {
            var g, h, i, j, k, l, m, n, o, p, q, r, s, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                k = $f.k;
                l = $f.l;
                m = $f.m;
                n = $f.n;
                o = $f.o;
                p = $f.p;
                q = $f.q;
                r = $f.r;
                s = $f.s;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        g = '';
                        h = 0;
                        i = new $Uint64(0, 0);
                        j = this;
                        k = j.loc;
                        if (k === DS.nil || k === CL) {
                            $s = 1;
                            continue;
                        }
                        $s = 2;
                        continue;
                    case 1:
                        l = k.get();
                        $s = 3;
                    case 3:
                        if ($c) {
                            $c = false;
                            l = l.$blk();
                        }
                        if (l && l.$blk !== undefined) {
                            break s;
                        }
                        k = l;
                    case 2:
                        m = j.unixSec();
                        if (!(k === CK)) {
                            $s = 4;
                            continue;
                        }
                        $s = 5;
                        continue;
                    case 4:
                        if (
                            !(k.cacheZone === DK.nil) &&
                            ((n = k.cacheStart),
                            n.$high < m.$high ||
                                (n.$high === m.$high && n.$low <= m.$low)) &&
                            ((o = k.cacheEnd),
                            m.$high < o.$high || (m.$high === o.$high && m.$low < o.$low))
                        ) {
                            $s = 7;
                            continue;
                        }
                        $s = 8;
                        continue;
                    case 7:
                        g = k.cacheZone.name;
                        h = k.cacheZone.offset;
                        $s = 9;
                        continue;
                    case 8:
                        q = k.lookup(m);
                        $s = 10;
                    case 10:
                        if ($c) {
                            $c = false;
                            q = q.$blk();
                        }
                        if (q && q.$blk !== undefined) {
                            break s;
                        }
                        p = q;
                        g = p[0];
                        h = p[1];
                    case 9:
                        m =
                            ((r = new $Int64(0, h)),
                            new $Int64(m.$high + r.$high, m.$low + r.$low));
                        $s = 6;
                        continue;
                    case 5:
                        g = 'UTC';
                    case 6:
                        i =
                            ((s = new $Int64(m.$high + 2147483646, m.$low + 450480384)),
                            new $Uint64(s.$high, s.$low));
                        $s = -1;
                        return [g, h, i];
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.locabs };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.k = k;
            $f.l = l;
            $f.m = m;
            $f.n = n;
            $f.o = o;
            $f.p = p;
            $f.q = q;
            $f.r = r;
            $f.s = s;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.locabs = function () {
            return this.$val.locabs();
        };
        BK.ptr.prototype.Date = function () {
            var g, h, i, j, k, l, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                k = $f.k;
                l = $f.l;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        g = 0;
                        h = 0;
                        i = 0;
                        j = this;
                        l = $clone(j, BK).date(true);
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            l = l.$blk();
                        }
                        if (l && l.$blk !== undefined) {
                            break s;
                        }
                        k = l;
                        g = k[0];
                        h = k[1];
                        i = k[2];
                        $s = -1;
                        return [g, h, i];
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.Date };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.k = k;
            $f.l = l;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.Date = function () {
            return this.$val.Date();
        };
        BK.ptr.prototype.Year = function () {
            var g, h, i, j, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        g = this;
                        i = $clone(g, BK).date(false);
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            i = i.$blk();
                        }
                        if (i && i.$blk !== undefined) {
                            break s;
                        }
                        h = i;
                        j = h[0];
                        $s = -1;
                        return j;
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.Year };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.Year = function () {
            return this.$val.Year();
        };
        BK.ptr.prototype.Month = function () {
            var g, h, i, j, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        g = this;
                        i = $clone(g, BK).date(true);
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            i = i.$blk();
                        }
                        if (i && i.$blk !== undefined) {
                            break s;
                        }
                        h = i;
                        j = h[1];
                        $s = -1;
                        return j;
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.Month };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.Month = function () {
            return this.$val.Month();
        };
        BK.ptr.prototype.Day = function () {
            var g, h, i, j, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        g = this;
                        i = $clone(g, BK).date(true);
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            i = i.$blk();
                        }
                        if (i && i.$blk !== undefined) {
                            break s;
                        }
                        h = i;
                        j = h[2];
                        $s = -1;
                        return j;
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.Day };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.Day = function () {
            return this.$val.Day();
        };
        BK.ptr.prototype.Weekday = function () {
            var g, h, i, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        g = this;
                        h = $clone(g, BK).abs();
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            h = h.$blk();
                        }
                        if (h && h.$blk !== undefined) {
                            break s;
                        }
                        i = BP(h);
                        $s = 2;
                    case 2:
                        if ($c) {
                            $c = false;
                            i = i.$blk();
                        }
                        if (i && i.$blk !== undefined) {
                            break s;
                        }
                        $s = -1;
                        return i;
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.Weekday };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.Weekday = function () {
            return this.$val.Weekday();
        };
        BP = function (g) {
            var g, h, i;
            h = $div64(
                new $Uint64(g.$high + 0, g.$low + 86400),
                new $Uint64(0, 604800),
                true
            );
            return (
                ((i = (h.$low >> 0) / 86400),
                i === i && i !== 1 / 0 && i !== -1 / 0
                    ? i >> 0
                    : $throwRuntimeError('integer divide by zero')) >> 0
            );
        };
        BK.ptr.prototype.ISOWeek = function () {
            var g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                k = $f.k;
                l = $f.l;
                m = $f.m;
                n = $f.n;
                o = $f.o;
                p = $f.p;
                q = $f.q;
                r = $f.r;
                s = $f.s;
                t = $f.t;
                u = $f.u;
                v = $f.v;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        g = 0;
                        h = 0;
                        i = this;
                        k = $clone(i, BK).date(true);
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            k = k.$blk();
                        }
                        if (k && k.$blk !== undefined) {
                            break s;
                        }
                        j = k;
                        g = j[0];
                        l = j[1];
                        m = j[2];
                        n = j[3];
                        p = $clone(i, BK).Weekday();
                        $s = 2;
                    case 2:
                        if ($c) {
                            $c = false;
                            p = p.$blk();
                        }
                        if (p && p.$blk !== undefined) {
                            break s;
                        }
                        q =
                            ((o = (((p + 6) >> 0) >> 0) % 7),
                            o === o ? o : $throwRuntimeError('integer divide by zero'));
                        h =
                            ((r = ((((n - q) >> 0) + 7) >> 0) / 7),
                            r === r && r !== 1 / 0 && r !== -1 / 0
                                ? r >> 0
                                : $throwRuntimeError('integer divide by zero'));
                        t =
                            ((s = ((((q - n) >> 0) + 371) >> 0) % 7),
                            s === s ? s : $throwRuntimeError('integer divide by zero'));
                        if (1 <= t && t <= 3) {
                            h = (h + 1) >> 0;
                        }
                        if (h === 0) {
                            g = (g - 1) >> 0;
                            h = 52;
                            if (t === 4 || (t === 5 && CD(g))) {
                                h = (h + 1) >> 0;
                            }
                        }
                        if (l === 12 && m >= 29 && q < 3) {
                            v =
                                ((u = ((((q + 31) >> 0) - m) >> 0) % 7),
                                u === u
                                    ? u
                                    : $throwRuntimeError('integer divide by zero'));
                            if (0 <= v && v <= 2) {
                                g = (g + 1) >> 0;
                                h = 1;
                            }
                        }
                        $s = -1;
                        return [g, h];
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.ISOWeek };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.k = k;
            $f.l = l;
            $f.m = m;
            $f.n = n;
            $f.o = o;
            $f.p = p;
            $f.q = q;
            $f.r = r;
            $f.s = s;
            $f.t = t;
            $f.u = u;
            $f.v = v;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.ISOWeek = function () {
            return this.$val.ISOWeek();
        };
        BK.ptr.prototype.Clock = function () {
            var g, h, i, j, k, l, m, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                k = $f.k;
                l = $f.l;
                m = $f.m;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        g = 0;
                        h = 0;
                        i = 0;
                        j = this;
                        l = $clone(j, BK).abs();
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            l = l.$blk();
                        }
                        if (l && l.$blk !== undefined) {
                            break s;
                        }
                        m = BQ(l);
                        $s = 2;
                    case 2:
                        if ($c) {
                            $c = false;
                            m = m.$blk();
                        }
                        if (m && m.$blk !== undefined) {
                            break s;
                        }
                        k = m;
                        g = k[0];
                        h = k[1];
                        i = k[2];
                        $s = -1;
                        return [g, h, i];
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.Clock };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.k = k;
            $f.l = l;
            $f.m = m;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.Clock = function () {
            return this.$val.Clock();
        };
        BQ = function (g) {
            var g, h, i, j, k, l;
            h = 0;
            i = 0;
            j = 0;
            j = $div64(g, new $Uint64(0, 86400), true).$low >> 0;
            h =
                ((k = j / 3600),
                k === k && k !== 1 / 0 && k !== -1 / 0
                    ? k >> 0
                    : $throwRuntimeError('integer divide by zero'));
            j = (j - $imul(h, 3600)) >> 0;
            i =
                ((l = j / 60),
                l === l && l !== 1 / 0 && l !== -1 / 0
                    ? l >> 0
                    : $throwRuntimeError('integer divide by zero'));
            j = (j - $imul(i, 60)) >> 0;
            return [h, i, j];
        };
        BK.ptr.prototype.Hour = function () {
            var g, h, i, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        g = this;
                        i = $clone(g, BK).abs();
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            i = i.$blk();
                        }
                        if (i && i.$blk !== undefined) {
                            break s;
                        }
                        $s = -1;
                        return (
                            (h =
                                ($div64(i, new $Uint64(0, 86400), true).$low >> 0) /
                                3600),
                            h === h && h !== 1 / 0 && h !== -1 / 0
                                ? h >> 0
                                : $throwRuntimeError('integer divide by zero')
                        );
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.Hour };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.Hour = function () {
            return this.$val.Hour();
        };
        BK.ptr.prototype.Minute = function () {
            var g, h, i, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        g = this;
                        i = $clone(g, BK).abs();
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            i = i.$blk();
                        }
                        if (i && i.$blk !== undefined) {
                            break s;
                        }
                        $s = -1;
                        return (
                            (h = ($div64(i, new $Uint64(0, 3600), true).$low >> 0) / 60),
                            h === h && h !== 1 / 0 && h !== -1 / 0
                                ? h >> 0
                                : $throwRuntimeError('integer divide by zero')
                        );
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.Minute };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.Minute = function () {
            return this.$val.Minute();
        };
        BK.ptr.prototype.Second = function () {
            var g, h, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        g = this;
                        h = $clone(g, BK).abs();
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            h = h.$blk();
                        }
                        if (h && h.$blk !== undefined) {
                            break s;
                        }
                        $s = -1;
                        return $div64(h, new $Uint64(0, 60), true).$low >> 0;
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.Second };
            }
            $f.g = g;
            $f.h = h;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.Second = function () {
            return this.$val.Second();
        };
        BK.ptr.prototype.Nanosecond = function () {
            var g;
            g = this;
            return g.nsec() >> 0;
        };
        BK.prototype.Nanosecond = function () {
            return this.$val.Nanosecond();
        };
        BK.ptr.prototype.YearDay = function () {
            var g, h, i, j, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        g = this;
                        i = $clone(g, BK).date(false);
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            i = i.$blk();
                        }
                        if (i && i.$blk !== undefined) {
                            break s;
                        }
                        h = i;
                        j = h[3];
                        $s = -1;
                        return (j + 1) >> 0;
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.YearDay };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.YearDay = function () {
            return this.$val.YearDay();
        };
        BR.prototype.String = function () {
            var g, h, i, j, k, l, m, n;
            g = this;
            h = DV.zero();
            i = 32;
            j = new $Uint64(g.$high, g.$low);
            k = g.$high < 0 || (g.$high === 0 && g.$low < 0);
            if (k) {
                j = new $Uint64(-j.$high, -j.$low);
            }
            if (j.$high < 0 || (j.$high === 0 && j.$low < 1000000000)) {
                l = 0;
                i = (i - 1) >> 0;
                i < 0 || i >= h.length
                    ? ($throwRuntimeError('index out of range'), undefined)
                    : (h[i] = 115);
                i = (i - 1) >> 0;
                if (j.$high === 0 && j.$low === 0) {
                    return '0s';
                } else if (j.$high < 0 || (j.$high === 0 && j.$low < 1000)) {
                    l = 0;
                    i < 0 || i >= h.length
                        ? ($throwRuntimeError('index out of range'), undefined)
                        : (h[i] = 110);
                } else if (j.$high < 0 || (j.$high === 0 && j.$low < 1000000)) {
                    l = 3;
                    i = (i - 1) >> 0;
                    $copyString($subslice(new DP(h), i), '\xC2\xB5');
                } else {
                    l = 6;
                    i < 0 || i >= h.length
                        ? ($throwRuntimeError('index out of range'), undefined)
                        : (h[i] = 109);
                }
                m = BS($subslice(new DP(h), 0, i), j, l);
                i = m[0];
                j = m[1];
                i = BT($subslice(new DP(h), 0, i), j);
            } else {
                i = (i - 1) >> 0;
                i < 0 || i >= h.length
                    ? ($throwRuntimeError('index out of range'), undefined)
                    : (h[i] = 115);
                n = BS($subslice(new DP(h), 0, i), j, 9);
                i = n[0];
                j = n[1];
                i = BT($subslice(new DP(h), 0, i), $div64(j, new $Uint64(0, 60), true));
                j = $div64(j, new $Uint64(0, 60), false);
                if (j.$high > 0 || (j.$high === 0 && j.$low > 0)) {
                    i = (i - 1) >> 0;
                    i < 0 || i >= h.length
                        ? ($throwRuntimeError('index out of range'), undefined)
                        : (h[i] = 109);
                    i = BT(
                        $subslice(new DP(h), 0, i),
                        $div64(j, new $Uint64(0, 60), true)
                    );
                    j = $div64(j, new $Uint64(0, 60), false);
                    if (j.$high > 0 || (j.$high === 0 && j.$low > 0)) {
                        i = (i - 1) >> 0;
                        i < 0 || i >= h.length
                            ? ($throwRuntimeError('index out of range'), undefined)
                            : (h[i] = 104);
                        i = BT($subslice(new DP(h), 0, i), j);
                    }
                }
            }
            if (k) {
                i = (i - 1) >> 0;
                i < 0 || i >= h.length
                    ? ($throwRuntimeError('index out of range'), undefined)
                    : (h[i] = 45);
            }
            return $bytesToString($subslice(new DP(h), i));
        };
        $ptrType(BR).prototype.String = function () {
            return this.$get().String();
        };
        BS = function (g, h, i) {
            var g, h, i, j, k, l, m, n, o, p, q;
            j = 0;
            k = new $Uint64(0, 0);
            l = g.$length;
            m = false;
            n = 0;
            while (true) {
                if (!(n < i)) {
                    break;
                }
                o = $div64(h, new $Uint64(0, 10), true);
                m = m || !(o.$high === 0 && o.$low === 0);
                if (m) {
                    l = (l - 1) >> 0;
                    l < 0 || l >= g.$length
                        ? ($throwRuntimeError('index out of range'), undefined)
                        : (g.$array[g.$offset + l] =
                              ((((o.$low << 24) >>> 24) + 48) << 24) >>> 24);
                }
                h = $div64(h, new $Uint64(0, 10), false);
                n = (n + 1) >> 0;
            }
            if (m) {
                l = (l - 1) >> 0;
                l < 0 || l >= g.$length
                    ? ($throwRuntimeError('index out of range'), undefined)
                    : (g.$array[g.$offset + l] = 46);
            }
            p = l;
            q = h;
            j = p;
            k = q;
            return [j, k];
        };
        BT = function (g, h) {
            var g, h, i;
            i = g.$length;
            if (h.$high === 0 && h.$low === 0) {
                i = (i - 1) >> 0;
                i < 0 || i >= g.$length
                    ? ($throwRuntimeError('index out of range'), undefined)
                    : (g.$array[g.$offset + i] = 48);
            } else {
                while (true) {
                    if (!(h.$high > 0 || (h.$high === 0 && h.$low > 0))) {
                        break;
                    }
                    i = (i - 1) >> 0;
                    i < 0 || i >= g.$length
                        ? ($throwRuntimeError('index out of range'), undefined)
                        : (g.$array[g.$offset + i] =
                              (((($div64(h, new $Uint64(0, 10), true).$low << 24) >>>
                                  24) +
                                  48) <<
                                  24) >>>
                              24);
                    h = $div64(h, new $Uint64(0, 10), false);
                }
            }
            return i;
        };
        BR.prototype.Nanoseconds = function () {
            var g;
            g = this;
            return new $Int64(g.$high, g.$low);
        };
        $ptrType(BR).prototype.Nanoseconds = function () {
            return this.$get().Nanoseconds();
        };
        BR.prototype.Seconds = function () {
            var g, h, i;
            g = this;
            h = $div64(g, new BR(0, 1000000000), false);
            i = $div64(g, new BR(0, 1000000000), true);
            return $flatten64(h) + $flatten64(i) / 1e9;
        };
        $ptrType(BR).prototype.Seconds = function () {
            return this.$get().Seconds();
        };
        BR.prototype.Minutes = function () {
            var g, h, i;
            g = this;
            h = $div64(g, new BR(13, 4165425152), false);
            i = $div64(g, new BR(13, 4165425152), true);
            return $flatten64(h) + $flatten64(i) / 6e10;
        };
        $ptrType(BR).prototype.Minutes = function () {
            return this.$get().Minutes();
        };
        BR.prototype.Hours = function () {
            var g, h, i;
            g = this;
            h = $div64(g, new BR(838, 817405952), false);
            i = $div64(g, new BR(838, 817405952), true);
            return $flatten64(h) + $flatten64(i) / 3.6e12;
        };
        $ptrType(BR).prototype.Hours = function () {
            return this.$get().Hours();
        };
        BR.prototype.Truncate = function (g) {
            var g, h, i;
            h = this;
            if (g.$high < 0 || (g.$high === 0 && g.$low <= 0)) {
                return h;
            }
            return (i = $div64(h, g, true)), new BR(h.$high - i.$high, h.$low - i.$low);
        };
        $ptrType(BR).prototype.Truncate = function (g) {
            return this.$get().Truncate(g);
        };
        BU = function (g, h) {
            var g, h, i, j, k, l;
            return (
                (i =
                    ((j = new $Uint64(g.$high, g.$low)),
                    (k = new $Uint64(g.$high, g.$low)),
                    new $Uint64(j.$high + k.$high, j.$low + k.$low))),
                (l = new $Uint64(h.$high, h.$low)),
                i.$high < l.$high || (i.$high === l.$high && i.$low < l.$low)
            );
        };
        BR.prototype.Round = function (g) {
            var g, h, i, j, k, l, m;
            h = this;
            if (g.$high < 0 || (g.$high === 0 && g.$low <= 0)) {
                return h;
            }
            i = $div64(h, g, true);
            if (h.$high < 0 || (h.$high === 0 && h.$low < 0)) {
                i = new BR(-i.$high, -i.$low);
                if (BU(i, g)) {
                    return new BR(h.$high + i.$high, h.$low + i.$low);
                }
                k =
                    ((j = new BR(h.$high - g.$high, h.$low - g.$low)),
                    new BR(j.$high + i.$high, j.$low + i.$low));
                if (k.$high < h.$high || (k.$high === h.$high && k.$low < h.$low)) {
                    return k;
                }
                return new BR(-2147483648, 0);
            }
            if (BU(i, g)) {
                return new BR(h.$high - i.$high, h.$low - i.$low);
            }
            m =
                ((l = new BR(h.$high + g.$high, h.$low + g.$low)),
                new BR(l.$high - i.$high, l.$low - i.$low));
            if (m.$high > h.$high || (m.$high === h.$high && m.$low > h.$low)) {
                return m;
            }
            return new BR(2147483647, 4294967295);
        };
        $ptrType(BR).prototype.Round = function (g) {
            return this.$get().Round(g);
        };
        BK.ptr.prototype.Add = function (g) {
            var g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, x;
            h = this;
            j =
                ((i = $div64(g, new BR(0, 1000000000), false)),
                new $Int64(i.$high, i.$low));
            l =
                (h.nsec() +
                    (((k = $div64(g, new BR(0, 1000000000), true)),
                    k.$low + (k.$high >> 31) * 4294967296) >>
                        0)) >>
                0;
            if (l >= 1000000000) {
                j =
                    ((m = new $Int64(0, 1)),
                    new $Int64(j.$high + m.$high, j.$low + m.$low));
                l = (l - 1000000000) >> 0;
            } else if (l < 0) {
                j =
                    ((n = new $Int64(0, 1)),
                    new $Int64(j.$high - n.$high, j.$low - n.$low));
                l = (l + 1000000000) >> 0;
            }
            h.wall =
                ((o =
                    ((p = h.wall),
                    new $Uint64(p.$high & ~0, (p.$low & ~1073741823) >>> 0))),
                (q = new $Uint64(0, l)),
                new $Uint64(o.$high | q.$high, (o.$low | q.$low) >>> 0));
            h.addSec(j);
            if (
                !((r =
                    ((s = h.wall),
                    new $Uint64(s.$high & 2147483648, (s.$low & 0) >>> 0))),
                r.$high === 0 && r.$low === 0)
            ) {
                v =
                    ((t = h.ext),
                    (u = new $Int64(g.$high, g.$low)),
                    new $Int64(t.$high + u.$high, t.$low + u.$low));
                if (
                    ((g.$high < 0 || (g.$high === 0 && g.$low < 0)) &&
                        ((w = h.ext),
                        v.$high > w.$high || (v.$high === w.$high && v.$low > w.$low))) ||
                    ((g.$high > 0 || (g.$high === 0 && g.$low > 0)) &&
                        ((x = h.ext),
                        v.$high < x.$high || (v.$high === x.$high && v.$low < x.$low)))
                ) {
                    h.stripMono();
                } else {
                    h.ext = v;
                }
            }
            return h;
        };
        BK.prototype.Add = function (g) {
            return this.$val.Add(g);
        };
        BK.ptr.prototype.Sub = function (g) {
            var g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v;
            h = this;
            if (
                !((i =
                    ((j =
                        ((k = h.wall),
                        (l = g.wall),
                        new $Uint64(k.$high & l.$high, (k.$low & l.$low) >>> 0))),
                    new $Uint64(j.$high & 2147483648, (j.$low & 0) >>> 0))),
                i.$high === 0 && i.$low === 0)
            ) {
                m = h.ext;
                n = g.ext;
                p =
                    ((o = new $Int64(m.$high - n.$high, m.$low - n.$low)),
                    new BR(o.$high, o.$low));
                if (
                    (p.$high < 0 || (p.$high === 0 && p.$low < 0)) &&
                    (m.$high > n.$high || (m.$high === n.$high && m.$low > n.$low))
                ) {
                    return new BR(2147483647, 4294967295);
                }
                if (
                    (p.$high > 0 || (p.$high === 0 && p.$low > 0)) &&
                    (m.$high < n.$high || (m.$high === n.$high && m.$low < n.$low))
                ) {
                    return new BR(-2147483648, 0);
                }
                return p;
            }
            v =
                ((q = $mul64(
                    ((r =
                        ((s = h.sec()),
                        (t = g.sec()),
                        new $Int64(s.$high - t.$high, s.$low - t.$low))),
                    new BR(r.$high, r.$low)),
                    new BR(0, 1000000000)
                )),
                (u = new BR(0, (h.nsec() - g.nsec()) >> 0)),
                new BR(q.$high + u.$high, q.$low + u.$low));
            if ($clone($clone(g, BK).Add(v), BK).Equal($clone(h, BK))) {
                return v;
            } else if ($clone(h, BK).Before($clone(g, BK))) {
                return new BR(-2147483648, 0);
            } else {
                return new BR(2147483647, 4294967295);
            }
        };
        BK.prototype.Sub = function (g) {
            return this.$val.Sub(g);
        };
        BK.ptr.prototype.AddDate = function (g, h, i) {
            var g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                k = $f.k;
                l = $f.l;
                m = $f.m;
                n = $f.n;
                o = $f.o;
                p = $f.p;
                q = $f.q;
                r = $f.r;
                s = $f.s;
                t = $f.t;
                u = $f.u;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        j = this;
                        l = $clone(j, BK).Date();
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            l = l.$blk();
                        }
                        if (l && l.$blk !== undefined) {
                            break s;
                        }
                        k = l;
                        m = k[0];
                        n = k[1];
                        o = k[2];
                        q = $clone(j, BK).Clock();
                        $s = 2;
                    case 2:
                        if ($c) {
                            $c = false;
                            q = q.$blk();
                        }
                        if (q && q.$blk !== undefined) {
                            break s;
                        }
                        p = q;
                        r = p[0];
                        s = p[1];
                        t = p[2];
                        u = CF(
                            (m + g) >> 0,
                            (n + (h >> 0)) >> 0,
                            (o + i) >> 0,
                            r,
                            s,
                            t,
                            j.nsec() >> 0,
                            $clone(j, BK).Location()
                        );
                        $s = 3;
                    case 3:
                        if ($c) {
                            $c = false;
                            u = u.$blk();
                        }
                        if (u && u.$blk !== undefined) {
                            break s;
                        }
                        $s = -1;
                        return u;
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.AddDate };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.k = k;
            $f.l = l;
            $f.m = m;
            $f.n = n;
            $f.o = o;
            $f.p = p;
            $f.q = q;
            $f.r = r;
            $f.s = s;
            $f.t = t;
            $f.u = u;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.AddDate = function (g, h, i) {
            return this.$val.AddDate(g, h, i);
        };
        BK.ptr.prototype.date = function (g) {
            var g, h, i, j, k, l, m, n, o, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                k = $f.k;
                l = $f.l;
                m = $f.m;
                n = $f.n;
                o = $f.o;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        h = 0;
                        i = 0;
                        j = 0;
                        k = 0;
                        l = this;
                        n = $clone(l, BK).abs();
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            n = n.$blk();
                        }
                        if (n && n.$blk !== undefined) {
                            break s;
                        }
                        o = BX(n, g);
                        $s = 2;
                    case 2:
                        if ($c) {
                            $c = false;
                            o = o.$blk();
                        }
                        if (o && o.$blk !== undefined) {
                            break s;
                        }
                        m = o;
                        h = m[0];
                        i = m[1];
                        j = m[2];
                        k = m[3];
                        $s = -1;
                        return [h, i, j, k];
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.date };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.k = k;
            $f.l = l;
            $f.m = m;
            $f.n = n;
            $f.o = o;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.date = function (g) {
            return this.$val.date(g);
        };
        BX = function (g, h) {
            var aa,
                ab,
                ac,
                ad,
                g,
                h,
                i,
                j,
                k,
                l,
                m,
                n,
                o,
                p,
                q,
                r,
                s,
                t,
                u,
                v,
                w,
                x,
                y,
                z;
            i = 0;
            j = 0;
            k = 0;
            l = 0;
            m = $div64(g, new $Uint64(0, 86400), false);
            n = $div64(m, new $Uint64(0, 146097), false);
            o = $mul64(new $Uint64(0, 400), n);
            m =
                ((p = $mul64(new $Uint64(0, 146097), n)),
                new $Uint64(m.$high - p.$high, m.$low - p.$low));
            n = $div64(m, new $Uint64(0, 36524), false);
            n =
                ((q = $shiftRightUint64(n, 2)),
                new $Uint64(n.$high - q.$high, n.$low - q.$low));
            o =
                ((r = $mul64(new $Uint64(0, 100), n)),
                new $Uint64(o.$high + r.$high, o.$low + r.$low));
            m =
                ((s = $mul64(new $Uint64(0, 36524), n)),
                new $Uint64(m.$high - s.$high, m.$low - s.$low));
            n = $div64(m, new $Uint64(0, 1461), false);
            o =
                ((t = $mul64(new $Uint64(0, 4), n)),
                new $Uint64(o.$high + t.$high, o.$low + t.$low));
            m =
                ((u = $mul64(new $Uint64(0, 1461), n)),
                new $Uint64(m.$high - u.$high, m.$low - u.$low));
            n = $div64(m, new $Uint64(0, 365), false);
            n =
                ((v = $shiftRightUint64(n, 2)),
                new $Uint64(n.$high - v.$high, n.$low - v.$low));
            o = ((w = n), new $Uint64(o.$high + w.$high, o.$low + w.$low));
            m =
                ((x = $mul64(new $Uint64(0, 365), n)),
                new $Uint64(m.$high - x.$high, m.$low - x.$low));
            i =
                ((y =
                    ((z = new $Int64(o.$high, o.$low)),
                    new $Int64(z.$high + -69, z.$low + 4075721025))),
                y.$low + (y.$high >> 31) * 4294967296) >> 0;
            l = m.$low >> 0;
            if (!h) {
                return [i, j, k, l];
            }
            k = l;
            if (CD(i)) {
                if (k > 59) {
                    k = (k - 1) >> 0;
                } else if (k === 59) {
                    j = 2;
                    k = 29;
                    return [i, j, k, l];
                }
            }
            j =
                ((aa = k / 31),
                aa === aa && aa !== 1 / 0 && aa !== -1 / 0
                    ? aa >> 0
                    : $throwRuntimeError('integer divide by zero')) >> 0;
            ac =
                ((ab = (j + 1) >> 0),
                ab < 0 || ab >= BY.length
                    ? ($throwRuntimeError('index out of range'), undefined)
                    : BY[ab]) >> 0;
            ad = 0;
            if (k >= ac) {
                j = (j + 1) >> 0;
                ad = ac;
            } else {
                ad =
                    (j < 0 || j >= BY.length
                        ? ($throwRuntimeError('index out of range'), undefined)
                        : BY[j]) >> 0;
            }
            j = (j + 1) >> 0;
            k = (((k - ad) >> 0) + 1) >> 0;
            return [i, j, k, l];
        };
        BZ = function (g, h) {
            var g, h, i;
            if (g === 2 && CD(h)) {
                return 29;
            }
            return (
                (((g < 0 || g >= BY.length
                    ? ($throwRuntimeError('index out of range'), undefined)
                    : BY[g]) -
                    ((i = (g - 1) >> 0),
                    i < 0 || i >= BY.length
                        ? ($throwRuntimeError('index out of range'), undefined)
                        : BY[i])) >>
                    0) >>
                0
            );
        };
        CB = function (g, h) {
            var g, h;
            return new BK.ptr(
                new $Uint64(0, h),
                new $Int64(g.$high + 14, g.$low + 2006054656),
                $pkg.Local
            );
        };
        BK.ptr.prototype.UTC = function () {
            var g;
            g = this;
            g.setLoc(CK);
            return g;
        };
        BK.prototype.UTC = function () {
            return this.$val.UTC();
        };
        BK.ptr.prototype.Local = function () {
            var g;
            g = this;
            g.setLoc($pkg.Local);
            return g;
        };
        BK.prototype.Local = function () {
            return this.$val.Local();
        };
        BK.ptr.prototype.In = function (g) {
            var g, h;
            h = this;
            if (g === DS.nil) {
                $panic(new $String('time: missing Location in call to Time.In'));
            }
            h.setLoc(g);
            return h;
        };
        BK.prototype.In = function (g) {
            return this.$val.In(g);
        };
        BK.ptr.prototype.Location = function () {
            var g, h;
            g = this;
            h = g.loc;
            if (h === DS.nil) {
                h = $pkg.UTC;
            }
            return h;
        };
        BK.prototype.Location = function () {
            return this.$val.Location();
        };
        BK.ptr.prototype.Zone = function () {
            var g, h, i, j, k, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                k = $f.k;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        g = '';
                        h = 0;
                        i = this;
                        k = i.loc.lookup(i.unixSec());
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            k = k.$blk();
                        }
                        if (k && k.$blk !== undefined) {
                            break s;
                        }
                        j = k;
                        g = j[0];
                        h = j[1];
                        $s = -1;
                        return [g, h];
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.Zone };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.k = k;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.Zone = function () {
            return this.$val.Zone();
        };
        BK.ptr.prototype.Unix = function () {
            var g;
            g = this;
            return g.unixSec();
        };
        BK.prototype.Unix = function () {
            return this.$val.Unix();
        };
        BK.ptr.prototype.UnixNano = function () {
            var g, h, i;
            g = this;
            return (
                (h = $mul64(g.unixSec(), new $Int64(0, 1000000000))),
                (i = new $Int64(0, g.nsec())),
                new $Int64(h.$high + i.$high, h.$low + i.$low)
            );
        };
        BK.prototype.UnixNano = function () {
            return this.$val.UnixNano();
        };
        BK.ptr.prototype.MarshalBinary = function () {
            var g, h, i, j, k, l, m, n, o, p, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                k = $f.k;
                l = $f.l;
                m = $f.m;
                n = $f.n;
                o = $f.o;
                p = $f.p;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        g = this;
                        h = 0;
                        if ($clone(g, BK).Location() === $pkg.UTC) {
                            $s = 1;
                            continue;
                        }
                        $s = 2;
                        continue;
                    case 1:
                        h = -1;
                        $s = 3;
                        continue;
                    case 2:
                        j = $clone(g, BK).Zone();
                        $s = 4;
                    case 4:
                        if ($c) {
                            $c = false;
                            j = j.$blk();
                        }
                        if (j && j.$blk !== undefined) {
                            break s;
                        }
                        i = j;
                        k = i[1];
                        if (
                            !(
                                ((l = k % 60),
                                l === l
                                    ? l
                                    : $throwRuntimeError('integer divide by zero')) === 0
                            )
                        ) {
                            $s = -1;
                            return [
                                DP.nil,
                                C.New(
                                    'Time.MarshalBinary: zone offset has fractional minute'
                                ),
                            ];
                        }
                        k =
                            ((m = k / 60),
                            m === m && m !== 1 / 0 && m !== -1 / 0
                                ? m >> 0
                                : $throwRuntimeError('integer divide by zero'));
                        if (k < -32768 || k === -1 || k > 32767) {
                            $s = -1;
                            return [
                                DP.nil,
                                C.New('Time.MarshalBinary: unexpected zone offset'),
                            ];
                        }
                        h = (k << 16) >> 16;
                    case 3:
                        n = g.sec();
                        o = g.nsec();
                        p = new DP([
                            1,
                            ($shiftRightInt64(n, 56).$low << 24) >>> 24,
                            ($shiftRightInt64(n, 48).$low << 24) >>> 24,
                            ($shiftRightInt64(n, 40).$low << 24) >>> 24,
                            ($shiftRightInt64(n, 32).$low << 24) >>> 24,
                            ($shiftRightInt64(n, 24).$low << 24) >>> 24,
                            ($shiftRightInt64(n, 16).$low << 24) >>> 24,
                            ($shiftRightInt64(n, 8).$low << 24) >>> 24,
                            (n.$low << 24) >>> 24,
                            (((o >> 24) >> 0) << 24) >>> 24,
                            (((o >> 16) >> 0) << 24) >>> 24,
                            (((o >> 8) >> 0) << 24) >>> 24,
                            (o << 24) >>> 24,
                            ((((h >> 8) << 16) >> 16) << 24) >>> 24,
                            (h << 24) >>> 24,
                        ]);
                        $s = -1;
                        return [p, $ifaceNil];
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.MarshalBinary };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.k = k;
            $f.l = l;
            $f.m = m;
            $f.n = n;
            $f.o = o;
            $f.p = p;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.MarshalBinary = function () {
            return this.$val.MarshalBinary();
        };
        BK.ptr.prototype.UnmarshalBinary = function (g) {
            var aa,
                ab,
                ac,
                g,
                h,
                i,
                j,
                k,
                l,
                m,
                n,
                o,
                p,
                q,
                r,
                s,
                t,
                u,
                v,
                w,
                x,
                y,
                z,
                $s,
                $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                aa = $f.aa;
                ab = $f.ab;
                ac = $f.ac;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                k = $f.k;
                l = $f.l;
                m = $f.m;
                n = $f.n;
                o = $f.o;
                p = $f.p;
                q = $f.q;
                r = $f.r;
                s = $f.s;
                t = $f.t;
                u = $f.u;
                v = $f.v;
                w = $f.w;
                x = $f.x;
                y = $f.y;
                z = $f.z;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        h = this;
                        i = g;
                        if (i.$length === 0) {
                            $s = -1;
                            return C.New('Time.UnmarshalBinary: no data');
                        }
                        if (
                            !(
                                (0 >= i.$length
                                    ? ($throwRuntimeError('index out of range'),
                                      undefined)
                                    : i.$array[i.$offset + 0]) === 1
                            )
                        ) {
                            $s = -1;
                            return C.New('Time.UnmarshalBinary: unsupported version');
                        }
                        if (!(i.$length === 15)) {
                            $s = -1;
                            return C.New('Time.UnmarshalBinary: invalid length');
                        }
                        i = $subslice(i, 1);
                        x =
                            ((j =
                                ((k =
                                    ((l =
                                        ((m =
                                            ((n =
                                                ((o =
                                                    ((p = new $Int64(
                                                        0,
                                                        7 >= i.$length
                                                            ? ($throwRuntimeError(
                                                                  'index out of range'
                                                              ),
                                                              undefined)
                                                            : i.$array[i.$offset + 7]
                                                    )),
                                                    (q = $shiftLeft64(
                                                        new $Int64(
                                                            0,
                                                            6 >= i.$length
                                                                ? ($throwRuntimeError(
                                                                      'index out of range'
                                                                  ),
                                                                  undefined)
                                                                : i.$array[i.$offset + 6]
                                                        ),
                                                        8
                                                    )),
                                                    new $Int64(
                                                        p.$high | q.$high,
                                                        (p.$low | q.$low) >>> 0
                                                    ))),
                                                (r = $shiftLeft64(
                                                    new $Int64(
                                                        0,
                                                        5 >= i.$length
                                                            ? ($throwRuntimeError(
                                                                  'index out of range'
                                                              ),
                                                              undefined)
                                                            : i.$array[i.$offset + 5]
                                                    ),
                                                    16
                                                )),
                                                new $Int64(
                                                    o.$high | r.$high,
                                                    (o.$low | r.$low) >>> 0
                                                ))),
                                            (s = $shiftLeft64(
                                                new $Int64(
                                                    0,
                                                    4 >= i.$length
                                                        ? ($throwRuntimeError(
                                                              'index out of range'
                                                          ),
                                                          undefined)
                                                        : i.$array[i.$offset + 4]
                                                ),
                                                24
                                            )),
                                            new $Int64(
                                                n.$high | s.$high,
                                                (n.$low | s.$low) >>> 0
                                            ))),
                                        (t = $shiftLeft64(
                                            new $Int64(
                                                0,
                                                3 >= i.$length
                                                    ? ($throwRuntimeError(
                                                          'index out of range'
                                                      ),
                                                      undefined)
                                                    : i.$array[i.$offset + 3]
                                            ),
                                            32
                                        )),
                                        new $Int64(
                                            m.$high | t.$high,
                                            (m.$low | t.$low) >>> 0
                                        ))),
                                    (u = $shiftLeft64(
                                        new $Int64(
                                            0,
                                            2 >= i.$length
                                                ? ($throwRuntimeError(
                                                      'index out of range'
                                                  ),
                                                  undefined)
                                                : i.$array[i.$offset + 2]
                                        ),
                                        40
                                    )),
                                    new $Int64(
                                        l.$high | u.$high,
                                        (l.$low | u.$low) >>> 0
                                    ))),
                                (v = $shiftLeft64(
                                    new $Int64(
                                        0,
                                        1 >= i.$length
                                            ? ($throwRuntimeError('index out of range'),
                                              undefined)
                                            : i.$array[i.$offset + 1]
                                    ),
                                    48
                                )),
                                new $Int64(k.$high | v.$high, (k.$low | v.$low) >>> 0))),
                            (w = $shiftLeft64(
                                new $Int64(
                                    0,
                                    0 >= i.$length
                                        ? ($throwRuntimeError('index out of range'),
                                          undefined)
                                        : i.$array[i.$offset + 0]
                                ),
                                56
                            )),
                            new $Int64(j.$high | w.$high, (j.$low | w.$low) >>> 0));
                        i = $subslice(i, 8);
                        y =
                            ((3 >= i.$length
                                ? ($throwRuntimeError('index out of range'), undefined)
                                : i.$array[i.$offset + 3]) >>
                                0) |
                            ((((2 >= i.$length
                                ? ($throwRuntimeError('index out of range'), undefined)
                                : i.$array[i.$offset + 2]) >>
                                0) <<
                                8) >>
                                0) |
                            ((((1 >= i.$length
                                ? ($throwRuntimeError('index out of range'), undefined)
                                : i.$array[i.$offset + 1]) >>
                                0) <<
                                16) >>
                                0) |
                            ((((0 >= i.$length
                                ? ($throwRuntimeError('index out of range'), undefined)
                                : i.$array[i.$offset + 0]) >>
                                0) <<
                                24) >>
                                0);
                        i = $subslice(i, 4);
                        z = $imul(
                            ((((1 >= i.$length
                                ? ($throwRuntimeError('index out of range'), undefined)
                                : i.$array[i.$offset + 1]) <<
                                16) >>
                                16) |
                                ((((((0 >= i.$length
                                    ? ($throwRuntimeError('index out of range'),
                                      undefined)
                                    : i.$array[i.$offset + 0]) <<
                                    16) >>
                                    16) <<
                                    8) <<
                                    16) >>
                                    16)) >>
                                0,
                            60
                        );
                        BK.copy(
                            h,
                            new BK.ptr(new $Uint64(0, 0), new $Int64(0, 0), DS.nil)
                        );
                        h.wall = new $Uint64(0, y);
                        h.ext = x;
                        if (z === -60) {
                            $s = 1;
                            continue;
                        }
                        $s = 2;
                        continue;
                    case 1:
                        h.setLoc(CK);
                        $s = 3;
                        continue;
                    case 2:
                        ab = $pkg.Local.lookup(h.unixSec());
                        $s = 4;
                    case 4:
                        if ($c) {
                            $c = false;
                            ab = ab.$blk();
                        }
                        if (ab && ab.$blk !== undefined) {
                            break s;
                        }
                        aa = ab;
                        ac = aa[1];
                        if (z === ac) {
                            h.setLoc($pkg.Local);
                        } else {
                            h.setLoc(CN('', z));
                        }
                    case 3:
                        $s = -1;
                        return $ifaceNil;
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.UnmarshalBinary };
            }
            $f.aa = aa;
            $f.ab = ab;
            $f.ac = ac;
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.k = k;
            $f.l = l;
            $f.m = m;
            $f.n = n;
            $f.o = o;
            $f.p = p;
            $f.q = q;
            $f.r = r;
            $f.s = s;
            $f.t = t;
            $f.u = u;
            $f.v = v;
            $f.w = w;
            $f.x = x;
            $f.y = y;
            $f.z = z;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.UnmarshalBinary = function (g) {
            return this.$val.UnmarshalBinary(g);
        };
        BK.ptr.prototype.GobEncode = function () {
            var g, h, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        g = this;
                        h = $clone(g, BK).MarshalBinary();
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            h = h.$blk();
                        }
                        if (h && h.$blk !== undefined) {
                            break s;
                        }
                        $s = -1;
                        return h;
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.GobEncode };
            }
            $f.g = g;
            $f.h = h;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.GobEncode = function () {
            return this.$val.GobEncode();
        };
        BK.ptr.prototype.GobDecode = function (g) {
            var g, h, i, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        h = this;
                        i = h.UnmarshalBinary(g);
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            i = i.$blk();
                        }
                        if (i && i.$blk !== undefined) {
                            break s;
                        }
                        $s = -1;
                        return i;
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.GobDecode };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.GobDecode = function (g) {
            return this.$val.GobDecode(g);
        };
        BK.ptr.prototype.MarshalJSON = function () {
            var g, h, i, j, k, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                k = $f.k;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        g = this;
                        h = $clone(g, BK).Year();
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            h = h.$blk();
                        }
                        if (h && h.$blk !== undefined) {
                            break s;
                        }
                        i = h;
                        if (i < 0 || i >= 10000) {
                            $s = -1;
                            return [
                                DP.nil,
                                C.New('Time.MarshalJSON: year outside of range [0,9999]'),
                            ];
                        }
                        j = $makeSlice(DP, 0, 37);
                        j = $append(j, 34);
                        k = $clone(g, BK).AppendFormat(
                            j,
                            '2006-01-02T15:04:05.999999999Z07:00'
                        );
                        $s = 2;
                    case 2:
                        if ($c) {
                            $c = false;
                            k = k.$blk();
                        }
                        if (k && k.$blk !== undefined) {
                            break s;
                        }
                        j = k;
                        j = $append(j, 34);
                        $s = -1;
                        return [j, $ifaceNil];
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.MarshalJSON };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.k = k;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.MarshalJSON = function () {
            return this.$val.MarshalJSON();
        };
        BK.ptr.prototype.UnmarshalJSON = function (g) {
            var g, h, i, j, k, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                k = $f.k;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        h = this;
                        if ($bytesToString(g) === 'null') {
                            $s = -1;
                            return $ifaceNil;
                        }
                        i = $ifaceNil;
                        k = AK('"2006-01-02T15:04:05Z07:00"', $bytesToString(g));
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            k = k.$blk();
                        }
                        if (k && k.$blk !== undefined) {
                            break s;
                        }
                        j = k;
                        BK.copy(h, j[0]);
                        i = j[1];
                        $s = -1;
                        return i;
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.UnmarshalJSON };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.k = k;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.UnmarshalJSON = function (g) {
            return this.$val.UnmarshalJSON(g);
        };
        BK.ptr.prototype.MarshalText = function () {
            var g, h, i, j, k, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                k = $f.k;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        g = this;
                        h = $clone(g, BK).Year();
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            h = h.$blk();
                        }
                        if (h && h.$blk !== undefined) {
                            break s;
                        }
                        i = h;
                        if (i < 0 || i >= 10000) {
                            $s = -1;
                            return [
                                DP.nil,
                                C.New('Time.MarshalText: year outside of range [0,9999]'),
                            ];
                        }
                        j = $makeSlice(DP, 0, 35);
                        k = $clone(g, BK).AppendFormat(
                            j,
                            '2006-01-02T15:04:05.999999999Z07:00'
                        );
                        $s = 2;
                    case 2:
                        if ($c) {
                            $c = false;
                            k = k.$blk();
                        }
                        if (k && k.$blk !== undefined) {
                            break s;
                        }
                        $s = -1;
                        return [k, $ifaceNil];
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.MarshalText };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.k = k;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.MarshalText = function () {
            return this.$val.MarshalText();
        };
        BK.ptr.prototype.UnmarshalText = function (g) {
            var g, h, i, j, k, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                k = $f.k;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        h = this;
                        i = $ifaceNil;
                        k = AK('2006-01-02T15:04:05Z07:00', $bytesToString(g));
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            k = k.$blk();
                        }
                        if (k && k.$blk !== undefined) {
                            break s;
                        }
                        j = k;
                        BK.copy(h, j[0]);
                        i = j[1];
                        $s = -1;
                        return i;
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: BK.ptr.prototype.UnmarshalText };
            }
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.k = k;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        BK.prototype.UnmarshalText = function (g) {
            return this.$val.UnmarshalText(g);
        };
        CC = function (g, h) {
            var g, h, i, j, k, l, m;
            if (
                h.$high < 0 ||
                (h.$high === 0 && h.$low < 0) ||
                h.$high > 0 ||
                (h.$high === 0 && h.$low >= 1000000000)
            ) {
                i = $div64(h, new $Int64(0, 1000000000), false);
                g = ((j = i), new $Int64(g.$high + j.$high, g.$low + j.$low));
                h =
                    ((k = $mul64(i, new $Int64(0, 1000000000))),
                    new $Int64(h.$high - k.$high, h.$low - k.$low));
                if (h.$high < 0 || (h.$high === 0 && h.$low < 0)) {
                    h =
                        ((l = new $Int64(0, 1000000000)),
                        new $Int64(h.$high + l.$high, h.$low + l.$low));
                    g =
                        ((m = new $Int64(0, 1)),
                        new $Int64(g.$high - m.$high, g.$low - m.$low));
                }
            }
            return CB(g, (h.$low + (h.$high >> 31) * 4294967296) >> 0);
        };
        $pkg.Unix = CC;
        CD = function (g) {
            var g, h, i, j;
            return (
                ((h = g % 4),
                h === h ? h : $throwRuntimeError('integer divide by zero')) === 0 &&
                (!(
                    ((i = g % 100),
                    i === i ? i : $throwRuntimeError('integer divide by zero')) === 0
                ) ||
                    ((j = g % 400),
                    j === j ? j : $throwRuntimeError('integer divide by zero')) === 0)
            );
        };
        CE = function (g, h, i) {
            var g, h, i, j, k, l, m, n, o, p, q;
            j = 0;
            k = 0;
            if (h < 0) {
                m =
                    (((l = ((-h - 1) >> 0) / i),
                    l === l && l !== 1 / 0 && l !== -1 / 0
                        ? l >> 0
                        : $throwRuntimeError('integer divide by zero')) +
                        1) >>
                    0;
                g = (g - m) >> 0;
                h = (h + $imul(m, i)) >> 0;
            }
            if (h >= i) {
                o =
                    ((n = h / i),
                    n === n && n !== 1 / 0 && n !== -1 / 0
                        ? n >> 0
                        : $throwRuntimeError('integer divide by zero'));
                g = (g + o) >> 0;
                h = (h - $imul(o, i)) >> 0;
            }
            p = g;
            q = h;
            j = p;
            k = q;
            return [j, k];
        };
        CF = function (g, h, i, j, k, l, m, n) {
            var aa,
                ab,
                ac,
                ad,
                ae,
                af,
                ag,
                ah,
                ai,
                aj,
                ak,
                al,
                am,
                an,
                ao,
                ap,
                aq,
                ar,
                as,
                at,
                au,
                av,
                aw,
                ax,
                ay,
                az,
                g,
                h,
                i,
                j,
                k,
                l,
                m,
                n,
                o,
                p,
                q,
                r,
                s,
                t,
                u,
                v,
                w,
                x,
                y,
                z,
                $s,
                $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                aa = $f.aa;
                ab = $f.ab;
                ac = $f.ac;
                ad = $f.ad;
                ae = $f.ae;
                af = $f.af;
                ag = $f.ag;
                ah = $f.ah;
                ai = $f.ai;
                aj = $f.aj;
                ak = $f.ak;
                al = $f.al;
                am = $f.am;
                an = $f.an;
                ao = $f.ao;
                ap = $f.ap;
                aq = $f.aq;
                ar = $f.ar;
                as = $f.as;
                at = $f.at;
                au = $f.au;
                av = $f.av;
                aw = $f.aw;
                ax = $f.ax;
                ay = $f.ay;
                az = $f.az;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                k = $f.k;
                l = $f.l;
                m = $f.m;
                n = $f.n;
                o = $f.o;
                p = $f.p;
                q = $f.q;
                r = $f.r;
                s = $f.s;
                t = $f.t;
                u = $f.u;
                v = $f.v;
                w = $f.w;
                x = $f.x;
                y = $f.y;
                z = $f.z;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        if (n === DS.nil) {
                            $panic(new $String('time: missing Location in call to Date'));
                        }
                        o = ((h >> 0) - 1) >> 0;
                        p = CE(g, o, 12);
                        g = p[0];
                        o = p[1];
                        h = ((o >> 0) + 1) >> 0;
                        q = CE(l, m, 1000000000);
                        l = q[0];
                        m = q[1];
                        r = CE(k, l, 60);
                        k = r[0];
                        l = r[1];
                        s = CE(j, k, 60);
                        j = s[0];
                        k = s[1];
                        t = CE(i, j, 24);
                        i = t[0];
                        j = t[1];
                        w =
                            ((u =
                                ((v = new $Int64(0, g)),
                                new $Int64(v.$high - -69, v.$low - 4075721025))),
                            new $Uint64(u.$high, u.$low));
                        x = $div64(w, new $Uint64(0, 400), false);
                        w =
                            ((y = $mul64(new $Uint64(0, 400), x)),
                            new $Uint64(w.$high - y.$high, w.$low - y.$low));
                        z = $mul64(new $Uint64(0, 146097), x);
                        x = $div64(w, new $Uint64(0, 100), false);
                        w =
                            ((aa = $mul64(new $Uint64(0, 100), x)),
                            new $Uint64(w.$high - aa.$high, w.$low - aa.$low));
                        z =
                            ((ab = $mul64(new $Uint64(0, 36524), x)),
                            new $Uint64(z.$high + ab.$high, z.$low + ab.$low));
                        x = $div64(w, new $Uint64(0, 4), false);
                        w =
                            ((ac = $mul64(new $Uint64(0, 4), x)),
                            new $Uint64(w.$high - ac.$high, w.$low - ac.$low));
                        z =
                            ((ad = $mul64(new $Uint64(0, 1461), x)),
                            new $Uint64(z.$high + ad.$high, z.$low + ad.$low));
                        x = w;
                        z =
                            ((ae = $mul64(new $Uint64(0, 365), x)),
                            new $Uint64(z.$high + ae.$high, z.$low + ae.$low));
                        z =
                            ((af = new $Uint64(
                                0,
                                ((ag = (h - 1) >> 0),
                                ag < 0 || ag >= BY.length
                                    ? ($throwRuntimeError('index out of range'),
                                      undefined)
                                    : BY[ag])
                            )),
                            new $Uint64(z.$high + af.$high, z.$low + af.$low));
                        if (CD(g) && h >= 3) {
                            z =
                                ((ah = new $Uint64(0, 1)),
                                new $Uint64(z.$high + ah.$high, z.$low + ah.$low));
                        }
                        z =
                            ((ai = new $Uint64(0, (i - 1) >> 0)),
                            new $Uint64(z.$high + ai.$high, z.$low + ai.$low));
                        aj = $mul64(z, new $Uint64(0, 86400));
                        aj =
                            ((ak = new $Uint64(
                                0,
                                ((($imul(j, 3600) + $imul(k, 60)) >> 0) + l) >> 0
                            )),
                            new $Uint64(aj.$high + ak.$high, aj.$low + ak.$low));
                        am =
                            ((al = new $Int64(aj.$high, aj.$low)),
                            new $Int64(al.$high + -2147483647, al.$low + 3844486912));
                        ao = n.lookup(am);
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            ao = ao.$blk();
                        }
                        if (ao && ao.$blk !== undefined) {
                            break s;
                        }
                        an = ao;
                        ap = an[1];
                        aq = an[3];
                        ar = an[4];
                        if (!(ap === 0)) {
                            $s = 2;
                            continue;
                        }
                        $s = 3;
                        continue;
                    case 2:
                        at =
                            ((as = new $Int64(0, ap)),
                            new $Int64(am.$high - as.$high, am.$low - as.$low));
                        if (
                            at.$high < aq.$high ||
                            (at.$high === aq.$high && at.$low < aq.$low)
                        ) {
                            $s = 5;
                            continue;
                        }
                        if (
                            at.$high > ar.$high ||
                            (at.$high === ar.$high && at.$low >= ar.$low)
                        ) {
                            $s = 6;
                            continue;
                        }
                        $s = 7;
                        continue;
                    case 5:
                        av = n.lookup(new $Int64(aq.$high - 0, aq.$low - 1));
                        $s = 8;
                    case 8:
                        if ($c) {
                            $c = false;
                            av = av.$blk();
                        }
                        if (av && av.$blk !== undefined) {
                            break s;
                        }
                        au = av;
                        ap = au[1];
                        $s = 7;
                        continue;
                    case 6:
                        ax = n.lookup(ar);
                        $s = 9;
                    case 9:
                        if ($c) {
                            $c = false;
                            ax = ax.$blk();
                        }
                        if (ax && ax.$blk !== undefined) {
                            break s;
                        }
                        aw = ax;
                        ap = aw[1];
                    case 7:
                    case 4:
                        am =
                            ((ay = new $Int64(0, ap)),
                            new $Int64(am.$high - ay.$high, am.$low - ay.$low));
                    case 3:
                        az = $clone(CB(am, m >> 0), BK);
                        az.setLoc(n);
                        $s = -1;
                        return az;
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: CF };
            }
            $f.aa = aa;
            $f.ab = ab;
            $f.ac = ac;
            $f.ad = ad;
            $f.ae = ae;
            $f.af = af;
            $f.ag = ag;
            $f.ah = ah;
            $f.ai = ai;
            $f.aj = aj;
            $f.ak = ak;
            $f.al = al;
            $f.am = am;
            $f.an = an;
            $f.ao = ao;
            $f.ap = ap;
            $f.aq = aq;
            $f.ar = ar;
            $f.as = as;
            $f.at = at;
            $f.au = au;
            $f.av = av;
            $f.aw = aw;
            $f.ax = ax;
            $f.ay = ay;
            $f.az = az;
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.k = k;
            $f.l = l;
            $f.m = m;
            $f.n = n;
            $f.o = o;
            $f.p = p;
            $f.q = q;
            $f.r = r;
            $f.s = s;
            $f.t = t;
            $f.u = u;
            $f.v = v;
            $f.w = w;
            $f.x = x;
            $f.y = y;
            $f.z = z;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        $pkg.Date = CF;
        BK.ptr.prototype.Truncate = function (g) {
            var g, h, i, j;
            h = this;
            h.stripMono();
            if (g.$high < 0 || (g.$high === 0 && g.$low <= 0)) {
                return h;
            }
            i = CG($clone(h, BK), g);
            j = i[1];
            return $clone(h, BK).Add(new BR(-j.$high, -j.$low));
        };
        BK.prototype.Truncate = function (g) {
            return this.$val.Truncate(g);
        };
        BK.ptr.prototype.Round = function (g) {
            var g, h, i, j;
            h = this;
            h.stripMono();
            if (g.$high < 0 || (g.$high === 0 && g.$low <= 0)) {
                return h;
            }
            i = CG($clone(h, BK), g);
            j = i[1];
            if (BU(j, g)) {
                return $clone(h, BK).Add(new BR(-j.$high, -j.$low));
            }
            return $clone(h, BK).Add(new BR(g.$high - j.$high, g.$low - j.$low));
        };
        BK.prototype.Round = function (g) {
            return this.$val.Round(g);
        };
        CG = function (g, h) {
            var aa,
                ab,
                ac,
                ad,
                ae,
                af,
                ag,
                ah,
                ai,
                aj,
                ak,
                al,
                am,
                an,
                ao,
                ap,
                aq,
                ar,
                as,
                g,
                h,
                i,
                j,
                k,
                l,
                m,
                n,
                o,
                p,
                q,
                r,
                s,
                t,
                u,
                v,
                w,
                x,
                y,
                z;
            i = 0;
            j = new BR(0, 0);
            k = false;
            l = g.nsec();
            m = g.sec();
            if (m.$high < 0 || (m.$high === 0 && m.$low < 0)) {
                k = true;
                m = new $Int64(-m.$high, -m.$low);
                l = -l;
                if (l < 0) {
                    l = (l + 1000000000) >> 0;
                    m =
                        ((n = new $Int64(0, 1)),
                        new $Int64(m.$high - n.$high, m.$low - n.$low));
                }
            }
            if (
                (h.$high < 0 || (h.$high === 0 && h.$low < 1000000000)) &&
                ((o = $div64(
                    new BR(0, 1000000000),
                    new BR(h.$high + h.$high, h.$low + h.$low),
                    true
                )),
                o.$high === 0 && o.$low === 0)
            ) {
                i =
                    (((q = l / ((h.$low + (h.$high >> 31) * 4294967296) >> 0)),
                    q === q && q !== 1 / 0 && q !== -1 / 0
                        ? q >> 0
                        : $throwRuntimeError('integer divide by zero')) >>
                        0) &
                    1;
                j = new BR(
                    0,
                    ((r = l % ((h.$low + (h.$high >> 31) * 4294967296) >> 0)),
                    r === r ? r : $throwRuntimeError('integer divide by zero'))
                );
            } else if (
                ((p = $div64(h, new BR(0, 1000000000), true)),
                p.$high === 0 && p.$low === 0)
            ) {
                t =
                    ((s = $div64(h, new BR(0, 1000000000), false)),
                    new $Int64(s.$high, s.$low));
                i =
                    (((u = $div64(m, t, false)), u.$low + (u.$high >> 31) * 4294967296) >>
                        0) &
                    1;
                j =
                    ((v = $mul64(
                        ((w = $div64(m, t, true)), new BR(w.$high, w.$low)),
                        new BR(0, 1000000000)
                    )),
                    (x = new BR(0, l)),
                    new BR(v.$high + x.$high, v.$low + x.$low));
            } else {
                y = new $Uint64(m.$high, m.$low);
                z = $mul64($shiftRightUint64(y, 32), new $Uint64(0, 1000000000));
                aa = $shiftRightUint64(z, 32);
                ab = $shiftLeft64(z, 32);
                z = $mul64(
                    new $Uint64(y.$high & 0, (y.$low & 4294967295) >>> 0),
                    new $Uint64(0, 1000000000)
                );
                ac = ab;
                ad = new $Uint64(ab.$high + z.$high, ab.$low + z.$low);
                ae = ac;
                ab = ad;
                if (ab.$high < ae.$high || (ab.$high === ae.$high && ab.$low < ae.$low)) {
                    aa =
                        ((af = new $Uint64(0, 1)),
                        new $Uint64(aa.$high + af.$high, aa.$low + af.$low));
                }
                ag = ab;
                ah =
                    ((ai = new $Uint64(0, l)),
                    new $Uint64(ab.$high + ai.$high, ab.$low + ai.$low));
                ae = ag;
                ab = ah;
                if (ab.$high < ae.$high || (ab.$high === ae.$high && ab.$low < ae.$low)) {
                    aa =
                        ((aj = new $Uint64(0, 1)),
                        new $Uint64(aa.$high + aj.$high, aa.$low + aj.$low));
                }
                ak = new $Uint64(h.$high, h.$low);
                while (true) {
                    if (
                        !!((al = $shiftRightUint64(ak, 63)),
                        al.$high === 0 && al.$low === 1)
                    ) {
                        break;
                    }
                    ak = $shiftLeft64(ak, 1);
                }
                am = new $Uint64(0, 0);
                while (true) {
                    i = 0;
                    if (
                        aa.$high > ak.$high ||
                        (aa.$high === ak.$high && aa.$low > ak.$low) ||
                        (aa.$high === ak.$high &&
                            aa.$low === ak.$low &&
                            (ab.$high > am.$high ||
                                (ab.$high === am.$high && ab.$low >= am.$low)))
                    ) {
                        i = 1;
                        an = ab;
                        ao = new $Uint64(ab.$high - am.$high, ab.$low - am.$low);
                        ae = an;
                        ab = ao;
                        if (
                            ab.$high > ae.$high ||
                            (ab.$high === ae.$high && ab.$low > ae.$low)
                        ) {
                            aa =
                                ((ap = new $Uint64(0, 1)),
                                new $Uint64(aa.$high - ap.$high, aa.$low - ap.$low));
                        }
                        aa =
                            ((aq = ak),
                            new $Uint64(aa.$high - aq.$high, aa.$low - aq.$low));
                    }
                    if (
                        ak.$high === 0 &&
                        ak.$low === 0 &&
                        ((ar = new $Uint64(h.$high, h.$low)),
                        am.$high === ar.$high && am.$low === ar.$low)
                    ) {
                        break;
                    }
                    am = $shiftRightUint64(am, 1);
                    am =
                        ((as = $shiftLeft64(
                            new $Uint64(ak.$high & 0, (ak.$low & 1) >>> 0),
                            63
                        )),
                        new $Uint64(am.$high | as.$high, (am.$low | as.$low) >>> 0));
                    ak = $shiftRightUint64(ak, 1);
                }
                j = new BR(ab.$high, ab.$low);
            }
            if (k && !(j.$high === 0 && j.$low === 0)) {
                i = (i ^ 1) >> 0;
                j = new BR(h.$high - j.$high, h.$low - j.$low);
            }
            return [i, j];
        };
        CH.ptr.prototype.get = function () {
            var g, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        g = this;
                        if (g === DS.nil) {
                            $s = -1;
                            return CK;
                        }
                        if (g === CL) {
                            $s = 1;
                            continue;
                        }
                        $s = 2;
                        continue;
                    case 1:
                        $r = CM.Do(H);
                        $s = 3;
                    case 3:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                    case 2:
                        $s = -1;
                        return g;
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: CH.ptr.prototype.get };
            }
            $f.g = g;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        CH.prototype.get = function () {
            return this.$val.get();
        };
        CH.ptr.prototype.String = function () {
            var g, h, $s, $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                g = $f.g;
                h = $f.h;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        g = this;
                        h = g.get();
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            h = h.$blk();
                        }
                        if (h && h.$blk !== undefined) {
                            break s;
                        }
                        $s = -1;
                        return h.name;
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: CH.ptr.prototype.String };
            }
            $f.g = g;
            $f.h = h;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        CH.prototype.String = function () {
            return this.$val.String();
        };
        CN = function (g, h) {
            var g, h, i, j;
            i = new CH.ptr(
                g,
                new DI([new CI.ptr(g, h, false)]),
                new DJ([new CJ.ptr(new $Int64(-2147483648, 0), 0, false, false)]),
                new $Int64(-2147483648, 0),
                new $Int64(2147483647, 4294967295),
                DK.nil
            );
            i.cacheZone =
                ((j = i.zone),
                0 >= j.$length
                    ? ($throwRuntimeError('index out of range'), undefined)
                    : j.$array[j.$offset + 0]);
            return i;
        };
        $pkg.FixedZone = CN;
        CH.ptr.prototype.lookup = function (g) {
            var aa,
                ab,
                ac,
                ad,
                ae,
                af,
                g,
                h,
                i,
                j,
                k,
                l,
                m,
                n,
                o,
                p,
                q,
                r,
                s,
                t,
                u,
                v,
                w,
                x,
                y,
                z,
                $s,
                $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                aa = $f.aa;
                ab = $f.ab;
                ac = $f.ac;
                ad = $f.ad;
                ae = $f.ae;
                af = $f.af;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                k = $f.k;
                l = $f.l;
                m = $f.m;
                n = $f.n;
                o = $f.o;
                p = $f.p;
                q = $f.q;
                r = $f.r;
                s = $f.s;
                t = $f.t;
                u = $f.u;
                v = $f.v;
                w = $f.w;
                x = $f.x;
                y = $f.y;
                z = $f.z;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        h = '';
                        i = 0;
                        j = false;
                        k = new $Int64(0, 0);
                        l = new $Int64(0, 0);
                        m = this;
                        n = m.get();
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            n = n.$blk();
                        }
                        if (n && n.$blk !== undefined) {
                            break s;
                        }
                        m = n;
                        if (m.zone.$length === 0) {
                            h = 'UTC';
                            i = 0;
                            j = false;
                            k = new $Int64(-2147483648, 0);
                            l = new $Int64(2147483647, 4294967295);
                            $s = -1;
                            return [h, i, j, k, l];
                        }
                        o = m.cacheZone;
                        if (
                            !(o === DK.nil) &&
                            ((p = m.cacheStart),
                            p.$high < g.$high ||
                                (p.$high === g.$high && p.$low <= g.$low)) &&
                            ((q = m.cacheEnd),
                            g.$high < q.$high || (g.$high === q.$high && g.$low < q.$low))
                        ) {
                            h = o.name;
                            i = o.offset;
                            j = o.isDST;
                            k = m.cacheStart;
                            l = m.cacheEnd;
                            $s = -1;
                            return [h, i, j, k, l];
                        }
                        if (
                            m.tx.$length === 0 ||
                            ((r = ((s = m.tx),
                            0 >= s.$length
                                ? ($throwRuntimeError('index out of range'), undefined)
                                : s.$array[s.$offset + 0]).when),
                            g.$high < r.$high || (g.$high === r.$high && g.$low < r.$low))
                        ) {
                            v =
                                ((t = m.zone),
                                (u = m.lookupFirstZone()),
                                u < 0 || u >= t.$length
                                    ? ($throwRuntimeError('index out of range'),
                                      undefined)
                                    : t.$array[t.$offset + u]);
                            h = v.name;
                            i = v.offset;
                            j = v.isDST;
                            k = new $Int64(-2147483648, 0);
                            if (m.tx.$length > 0) {
                                l = ((w = m.tx),
                                0 >= w.$length
                                    ? ($throwRuntimeError('index out of range'),
                                      undefined)
                                    : w.$array[w.$offset + 0]).when;
                            } else {
                                l = new $Int64(2147483647, 4294967295);
                            }
                            $s = -1;
                            return [h, i, j, k, l];
                        }
                        x = m.tx;
                        l = new $Int64(2147483647, 4294967295);
                        y = 0;
                        z = x.$length;
                        while (true) {
                            if (!((z - y) >> 0 > 1)) {
                                break;
                            }
                            ab =
                                (y +
                                    ((aa = ((z - y) >> 0) / 2),
                                    aa === aa && aa !== 1 / 0 && aa !== -1 / 0
                                        ? aa >> 0
                                        : $throwRuntimeError(
                                              'integer divide by zero'
                                          ))) >>
                                0;
                            ac = (
                                ab < 0 || ab >= x.$length
                                    ? ($throwRuntimeError('index out of range'),
                                      undefined)
                                    : x.$array[x.$offset + ab]
                            ).when;
                            if (
                                g.$high < ac.$high ||
                                (g.$high === ac.$high && g.$low < ac.$low)
                            ) {
                                l = ac;
                                z = ab;
                            } else {
                                y = ab;
                            }
                        }
                        af =
                            ((ad = m.zone),
                            (ae = (
                                y < 0 || y >= x.$length
                                    ? ($throwRuntimeError('index out of range'),
                                      undefined)
                                    : x.$array[x.$offset + y]
                            ).index),
                            ae < 0 || ae >= ad.$length
                                ? ($throwRuntimeError('index out of range'), undefined)
                                : ad.$array[ad.$offset + ae]);
                        h = af.name;
                        i = af.offset;
                        j = af.isDST;
                        k = (
                            y < 0 || y >= x.$length
                                ? ($throwRuntimeError('index out of range'), undefined)
                                : x.$array[x.$offset + y]
                        ).when;
                        $s = -1;
                        return [h, i, j, k, l];
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: CH.ptr.prototype.lookup };
            }
            $f.aa = aa;
            $f.ab = ab;
            $f.ac = ac;
            $f.ad = ad;
            $f.ae = ae;
            $f.af = af;
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.k = k;
            $f.l = l;
            $f.m = m;
            $f.n = n;
            $f.o = o;
            $f.p = p;
            $f.q = q;
            $f.r = r;
            $f.s = s;
            $f.t = t;
            $f.u = u;
            $f.v = v;
            $f.w = w;
            $f.x = x;
            $f.y = y;
            $f.z = z;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        CH.prototype.lookup = function (g) {
            return this.$val.lookup(g);
        };
        CH.ptr.prototype.lookupFirstZone = function () {
            var g, h, i, j, k, l, m, n, o, p, q;
            g = this;
            if (!g.firstZoneUsed()) {
                return 0;
            }
            if (
                g.tx.$length > 0 &&
                ((h = g.zone),
                (i = ((j = g.tx),
                0 >= j.$length
                    ? ($throwRuntimeError('index out of range'), undefined)
                    : j.$array[j.$offset + 0]).index),
                i < 0 || i >= h.$length
                    ? ($throwRuntimeError('index out of range'), undefined)
                    : h.$array[h.$offset + i]).isDST
            ) {
                l =
                    ((((k = g.tx),
                    0 >= k.$length
                        ? ($throwRuntimeError('index out of range'), undefined)
                        : k.$array[k.$offset + 0]).index >>
                        0) -
                        1) >>
                    0;
                while (true) {
                    if (!(l >= 0)) {
                        break;
                    }
                    if (
                        !((m = g.zone),
                        l < 0 || l >= m.$length
                            ? ($throwRuntimeError('index out of range'), undefined)
                            : m.$array[m.$offset + l]).isDST
                    ) {
                        return l;
                    }
                    l = (l - 1) >> 0;
                }
            }
            n = g.zone;
            o = 0;
            while (true) {
                if (!(o < n.$length)) {
                    break;
                }
                p = o;
                if (
                    !((q = g.zone),
                    p < 0 || p >= q.$length
                        ? ($throwRuntimeError('index out of range'), undefined)
                        : q.$array[q.$offset + p]).isDST
                ) {
                    return p;
                }
                o++;
            }
            return 0;
        };
        CH.prototype.lookupFirstZone = function () {
            return this.$val.lookupFirstZone();
        };
        CH.ptr.prototype.firstZoneUsed = function () {
            var g, h, i, j;
            g = this;
            h = g.tx;
            i = 0;
            while (true) {
                if (!(i < h.$length)) {
                    break;
                }
                j = $clone(
                    i < 0 || i >= h.$length
                        ? ($throwRuntimeError('index out of range'), undefined)
                        : h.$array[h.$offset + i],
                    CJ
                );
                if (j.index === 0) {
                    return true;
                }
                i++;
            }
            return false;
        };
        CH.prototype.firstZoneUsed = function () {
            return this.$val.firstZoneUsed();
        };
        CH.ptr.prototype.lookupName = function (g, h) {
            var aa,
                ab,
                ac,
                ad,
                ae,
                g,
                h,
                i,
                j,
                k,
                l,
                m,
                n,
                o,
                p,
                q,
                r,
                s,
                t,
                u,
                v,
                w,
                x,
                y,
                z,
                $s,
                $r;
            $s = 0;
            var $f,
                $c = false;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                aa = $f.aa;
                ab = $f.ab;
                ac = $f.ac;
                ad = $f.ad;
                ae = $f.ae;
                g = $f.g;
                h = $f.h;
                i = $f.i;
                j = $f.j;
                k = $f.k;
                l = $f.l;
                m = $f.m;
                n = $f.n;
                o = $f.o;
                p = $f.p;
                q = $f.q;
                r = $f.r;
                s = $f.s;
                t = $f.t;
                u = $f.u;
                v = $f.v;
                w = $f.w;
                x = $f.x;
                y = $f.y;
                z = $f.z;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        i = 0;
                        j = false;
                        k = this;
                        l = k.get();
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            l = l.$blk();
                        }
                        if (l && l.$blk !== undefined) {
                            break s;
                        }
                        k = l;
                        m = k.zone;
                        n = 0;
                    case 2:
                        if (!(n < m.$length)) {
                            $s = 3;
                            continue;
                        }
                        o = n;
                        q =
                            ((p = k.zone),
                            o < 0 || o >= p.$length
                                ? ($throwRuntimeError('index out of range'), undefined)
                                : p.$array[p.$offset + o]);
                        if (q.name === g) {
                            $s = 4;
                            continue;
                        }
                        $s = 5;
                        continue;
                    case 4:
                        t = k.lookup(
                            ((s = new $Int64(0, q.offset)),
                            new $Int64(h.$high - s.$high, h.$low - s.$low))
                        );
                        $s = 6;
                    case 6:
                        if ($c) {
                            $c = false;
                            t = t.$blk();
                        }
                        if (t && t.$blk !== undefined) {
                            break s;
                        }
                        r = t;
                        u = r[0];
                        v = r[1];
                        if (u === q.name) {
                            w = v;
                            x = true;
                            i = w;
                            j = x;
                            $s = -1;
                            return [i, j];
                        }
                    case 5:
                        n++;
                        $s = 2;
                        continue;
                    case 3:
                        y = k.zone;
                        z = 0;
                        while (true) {
                            if (!(z < y.$length)) {
                                break;
                            }
                            aa = z;
                            ac =
                                ((ab = k.zone),
                                aa < 0 || aa >= ab.$length
                                    ? ($throwRuntimeError('index out of range'),
                                      undefined)
                                    : ab.$array[ab.$offset + aa]);
                            if (ac.name === g) {
                                ad = ac.offset;
                                ae = true;
                                i = ad;
                                j = ae;
                                $s = -1;
                                return [i, j];
                            }
                            z++;
                        }
                        $s = -1;
                        return [i, j];
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: CH.ptr.prototype.lookupName };
            }
            $f.aa = aa;
            $f.ab = ab;
            $f.ac = ac;
            $f.ad = ad;
            $f.ae = ae;
            $f.g = g;
            $f.h = h;
            $f.i = i;
            $f.j = j;
            $f.k = k;
            $f.l = l;
            $f.m = m;
            $f.n = n;
            $f.o = o;
            $f.p = p;
            $f.q = q;
            $f.r = r;
            $f.s = s;
            $f.t = t;
            $f.u = u;
            $f.v = v;
            $f.w = w;
            $f.x = x;
            $f.y = y;
            $f.z = z;
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        CH.prototype.lookupName = function (g, h) {
            return this.$val.lookupName(g, h);
        };
        EA.methods = [
            {
                prop: 'Error',
                name: 'Error',
                pkg: '',
                typ: $funcType([], [$String], false),
            },
        ];
        BK.methods = [
            {
                prop: 'String',
                name: 'String',
                pkg: '',
                typ: $funcType([], [$String], false),
            },
            {
                prop: 'Format',
                name: 'Format',
                pkg: '',
                typ: $funcType([$String], [$String], false),
            },
            {
                prop: 'AppendFormat',
                name: 'AppendFormat',
                pkg: '',
                typ: $funcType([DP, $String], [DP], false),
            },
            {
                prop: 'After',
                name: 'After',
                pkg: '',
                typ: $funcType([BK], [$Bool], false),
            },
            {
                prop: 'Before',
                name: 'Before',
                pkg: '',
                typ: $funcType([BK], [$Bool], false),
            },
            {
                prop: 'Equal',
                name: 'Equal',
                pkg: '',
                typ: $funcType([BK], [$Bool], false),
            },
            {
                prop: 'IsZero',
                name: 'IsZero',
                pkg: '',
                typ: $funcType([], [$Bool], false),
            },
            {
                prop: 'abs',
                name: 'abs',
                pkg: 'time',
                typ: $funcType([], [$Uint64], false),
            },
            {
                prop: 'locabs',
                name: 'locabs',
                pkg: 'time',
                typ: $funcType([], [$String, $Int, $Uint64], false),
            },
            {
                prop: 'Date',
                name: 'Date',
                pkg: '',
                typ: $funcType([], [$Int, BL, $Int], false),
            },
            { prop: 'Year', name: 'Year', pkg: '', typ: $funcType([], [$Int], false) },
            { prop: 'Month', name: 'Month', pkg: '', typ: $funcType([], [BL], false) },
            { prop: 'Day', name: 'Day', pkg: '', typ: $funcType([], [$Int], false) },
            {
                prop: 'Weekday',
                name: 'Weekday',
                pkg: '',
                typ: $funcType([], [BN], false),
            },
            {
                prop: 'ISOWeek',
                name: 'ISOWeek',
                pkg: '',
                typ: $funcType([], [$Int, $Int], false),
            },
            {
                prop: 'Clock',
                name: 'Clock',
                pkg: '',
                typ: $funcType([], [$Int, $Int, $Int], false),
            },
            { prop: 'Hour', name: 'Hour', pkg: '', typ: $funcType([], [$Int], false) },
            {
                prop: 'Minute',
                name: 'Minute',
                pkg: '',
                typ: $funcType([], [$Int], false),
            },
            {
                prop: 'Second',
                name: 'Second',
                pkg: '',
                typ: $funcType([], [$Int], false),
            },
            {
                prop: 'Nanosecond',
                name: 'Nanosecond',
                pkg: '',
                typ: $funcType([], [$Int], false),
            },
            {
                prop: 'YearDay',
                name: 'YearDay',
                pkg: '',
                typ: $funcType([], [$Int], false),
            },
            { prop: 'Add', name: 'Add', pkg: '', typ: $funcType([BR], [BK], false) },
            { prop: 'Sub', name: 'Sub', pkg: '', typ: $funcType([BK], [BR], false) },
            {
                prop: 'AddDate',
                name: 'AddDate',
                pkg: '',
                typ: $funcType([$Int, $Int, $Int], [BK], false),
            },
            {
                prop: 'date',
                name: 'date',
                pkg: 'time',
                typ: $funcType([$Bool], [$Int, BL, $Int, $Int], false),
            },
            { prop: 'UTC', name: 'UTC', pkg: '', typ: $funcType([], [BK], false) },
            { prop: 'Local', name: 'Local', pkg: '', typ: $funcType([], [BK], false) },
            { prop: 'In', name: 'In', pkg: '', typ: $funcType([DS], [BK], false) },
            {
                prop: 'Location',
                name: 'Location',
                pkg: '',
                typ: $funcType([], [DS], false),
            },
            {
                prop: 'Zone',
                name: 'Zone',
                pkg: '',
                typ: $funcType([], [$String, $Int], false),
            },
            { prop: 'Unix', name: 'Unix', pkg: '', typ: $funcType([], [$Int64], false) },
            {
                prop: 'UnixNano',
                name: 'UnixNano',
                pkg: '',
                typ: $funcType([], [$Int64], false),
            },
            {
                prop: 'MarshalBinary',
                name: 'MarshalBinary',
                pkg: '',
                typ: $funcType([], [DP, $error], false),
            },
            {
                prop: 'GobEncode',
                name: 'GobEncode',
                pkg: '',
                typ: $funcType([], [DP, $error], false),
            },
            {
                prop: 'MarshalJSON',
                name: 'MarshalJSON',
                pkg: '',
                typ: $funcType([], [DP, $error], false),
            },
            {
                prop: 'MarshalText',
                name: 'MarshalText',
                pkg: '',
                typ: $funcType([], [DP, $error], false),
            },
            {
                prop: 'Truncate',
                name: 'Truncate',
                pkg: '',
                typ: $funcType([BR], [BK], false),
            },
            { prop: 'Round', name: 'Round', pkg: '', typ: $funcType([BR], [BK], false) },
        ];
        EE.methods = [
            {
                prop: 'nsec',
                name: 'nsec',
                pkg: 'time',
                typ: $funcType([], [$Int32], false),
            },
            {
                prop: 'sec',
                name: 'sec',
                pkg: 'time',
                typ: $funcType([], [$Int64], false),
            },
            {
                prop: 'unixSec',
                name: 'unixSec',
                pkg: 'time',
                typ: $funcType([], [$Int64], false),
            },
            {
                prop: 'addSec',
                name: 'addSec',
                pkg: 'time',
                typ: $funcType([$Int64], [], false),
            },
            {
                prop: 'setLoc',
                name: 'setLoc',
                pkg: 'time',
                typ: $funcType([DS], [], false),
            },
            {
                prop: 'stripMono',
                name: 'stripMono',
                pkg: 'time',
                typ: $funcType([], [], false),
            },
            {
                prop: 'setMono',
                name: 'setMono',
                pkg: 'time',
                typ: $funcType([$Int64], [], false),
            },
            {
                prop: 'mono',
                name: 'mono',
                pkg: 'time',
                typ: $funcType([], [$Int64], false),
            },
            {
                prop: 'UnmarshalBinary',
                name: 'UnmarshalBinary',
                pkg: '',
                typ: $funcType([DP], [$error], false),
            },
            {
                prop: 'GobDecode',
                name: 'GobDecode',
                pkg: '',
                typ: $funcType([DP], [$error], false),
            },
            {
                prop: 'UnmarshalJSON',
                name: 'UnmarshalJSON',
                pkg: '',
                typ: $funcType([DP], [$error], false),
            },
            {
                prop: 'UnmarshalText',
                name: 'UnmarshalText',
                pkg: '',
                typ: $funcType([DP], [$error], false),
            },
        ];
        BL.methods = [
            {
                prop: 'String',
                name: 'String',
                pkg: '',
                typ: $funcType([], [$String], false),
            },
        ];
        BN.methods = [
            {
                prop: 'String',
                name: 'String',
                pkg: '',
                typ: $funcType([], [$String], false),
            },
        ];
        BR.methods = [
            {
                prop: 'String',
                name: 'String',
                pkg: '',
                typ: $funcType([], [$String], false),
            },
            {
                prop: 'Nanoseconds',
                name: 'Nanoseconds',
                pkg: '',
                typ: $funcType([], [$Int64], false),
            },
            {
                prop: 'Seconds',
                name: 'Seconds',
                pkg: '',
                typ: $funcType([], [$Float64], false),
            },
            {
                prop: 'Minutes',
                name: 'Minutes',
                pkg: '',
                typ: $funcType([], [$Float64], false),
            },
            {
                prop: 'Hours',
                name: 'Hours',
                pkg: '',
                typ: $funcType([], [$Float64], false),
            },
            {
                prop: 'Truncate',
                name: 'Truncate',
                pkg: '',
                typ: $funcType([BR], [BR], false),
            },
            { prop: 'Round', name: 'Round', pkg: '', typ: $funcType([BR], [BR], false) },
        ];
        DS.methods = [
            { prop: 'get', name: 'get', pkg: 'time', typ: $funcType([], [DS], false) },
            {
                prop: 'String',
                name: 'String',
                pkg: '',
                typ: $funcType([], [$String], false),
            },
            {
                prop: 'lookup',
                name: 'lookup',
                pkg: 'time',
                typ: $funcType([$Int64], [$String, $Int, $Bool, $Int64, $Int64], false),
            },
            {
                prop: 'lookupFirstZone',
                name: 'lookupFirstZone',
                pkg: 'time',
                typ: $funcType([], [$Int], false),
            },
            {
                prop: 'firstZoneUsed',
                name: 'firstZoneUsed',
                pkg: 'time',
                typ: $funcType([], [$Bool], false),
            },
            {
                prop: 'lookupName',
                name: 'lookupName',
                pkg: 'time',
                typ: $funcType([$String, $Int64], [$Int, $Bool], false),
            },
        ];
        AE.init('', [
            {
                prop: 'Layout',
                name: 'Layout',
                anonymous: false,
                exported: true,
                typ: $String,
                tag: '',
            },
            {
                prop: 'Value',
                name: 'Value',
                anonymous: false,
                exported: true,
                typ: $String,
                tag: '',
            },
            {
                prop: 'LayoutElem',
                name: 'LayoutElem',
                anonymous: false,
                exported: true,
                typ: $String,
                tag: '',
            },
            {
                prop: 'ValueElem',
                name: 'ValueElem',
                anonymous: false,
                exported: true,
                typ: $String,
                tag: '',
            },
            {
                prop: 'Message',
                name: 'Message',
                anonymous: false,
                exported: true,
                typ: $String,
                tag: '',
            },
        ]);
        BK.init('time', [
            {
                prop: 'wall',
                name: 'wall',
                anonymous: false,
                exported: false,
                typ: $Uint64,
                tag: '',
            },
            {
                prop: 'ext',
                name: 'ext',
                anonymous: false,
                exported: false,
                typ: $Int64,
                tag: '',
            },
            {
                prop: 'loc',
                name: 'loc',
                anonymous: false,
                exported: false,
                typ: DS,
                tag: '',
            },
        ]);
        CH.init('time', [
            {
                prop: 'name',
                name: 'name',
                anonymous: false,
                exported: false,
                typ: $String,
                tag: '',
            },
            {
                prop: 'zone',
                name: 'zone',
                anonymous: false,
                exported: false,
                typ: DI,
                tag: '',
            },
            {
                prop: 'tx',
                name: 'tx',
                anonymous: false,
                exported: false,
                typ: DJ,
                tag: '',
            },
            {
                prop: 'cacheStart',
                name: 'cacheStart',
                anonymous: false,
                exported: false,
                typ: $Int64,
                tag: '',
            },
            {
                prop: 'cacheEnd',
                name: 'cacheEnd',
                anonymous: false,
                exported: false,
                typ: $Int64,
                tag: '',
            },
            {
                prop: 'cacheZone',
                name: 'cacheZone',
                anonymous: false,
                exported: false,
                typ: DK,
                tag: '',
            },
        ]);
        CI.init('time', [
            {
                prop: 'name',
                name: 'name',
                anonymous: false,
                exported: false,
                typ: $String,
                tag: '',
            },
            {
                prop: 'offset',
                name: 'offset',
                anonymous: false,
                exported: false,
                typ: $Int,
                tag: '',
            },
            {
                prop: 'isDST',
                name: 'isDST',
                anonymous: false,
                exported: false,
                typ: $Bool,
                tag: '',
            },
        ]);
        CJ.init('time', [
            {
                prop: 'when',
                name: 'when',
                anonymous: false,
                exported: false,
                typ: $Int64,
                tag: '',
            },
            {
                prop: 'index',
                name: 'index',
                anonymous: false,
                exported: false,
                typ: $Uint8,
                tag: '',
            },
            {
                prop: 'isstd',
                name: 'isstd',
                anonymous: false,
                exported: false,
                typ: $Bool,
                tag: '',
            },
            {
                prop: 'isutc',
                name: 'isutc',
                anonymous: false,
                exported: false,
                typ: $Bool,
                tag: '',
            },
        ]);
        $init = function () {
            $pkg.$init = function () {};
            var $f,
                $c = false,
                $s = 0,
                $r;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        $r = C.$init();
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                        $r = B.$init();
                        $s = 2;
                    case 2:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                        $r = E.$init();
                        $s = 3;
                    case 3:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                        $r = A.$init();
                        $s = 4;
                    case 4:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                        $r = D.$init();
                        $s = 5;
                    case 5:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                        CL = new CH.ptr(
                            '',
                            DI.nil,
                            DJ.nil,
                            new $Int64(0, 0),
                            new $Int64(0, 0),
                            DK.nil
                        );
                        CM = new E.Once.ptr(false, false);
                        O = new DM([A.GOROOT() + '/lib/time/zoneinfo.zip']);
                        Q = $toNativeArray($kindInt, [260, 265, 524, 526, 528, 274]);
                        T = new DM([
                            'Sunday',
                            'Monday',
                            'Tuesday',
                            'Wednesday',
                            'Thursday',
                            'Friday',
                            'Saturday',
                        ]);
                        U = new DM(['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']);
                        V = new DM([
                            'Jan',
                            'Feb',
                            'Mar',
                            'Apr',
                            'May',
                            'Jun',
                            'Jul',
                            'Aug',
                            'Sep',
                            'Oct',
                            'Nov',
                            'Dec',
                        ]);
                        W = new DM([
                            'January',
                            'February',
                            'March',
                            'April',
                            'May',
                            'June',
                            'July',
                            'August',
                            'September',
                            'October',
                            'November',
                            'December',
                        ]);
                        AA = C.New('time: invalid number');
                        AD = C.New('bad value for field');
                        AQ = C.New('time: bad [0-9]*');
                        BM = $toNativeArray($kindString, [
                            'January',
                            'February',
                            'March',
                            'April',
                            'May',
                            'June',
                            'July',
                            'August',
                            'September',
                            'October',
                            'November',
                            'December',
                        ]);
                        BO = $toNativeArray($kindString, [
                            'Sunday',
                            'Monday',
                            'Tuesday',
                            'Wednesday',
                            'Thursday',
                            'Friday',
                            'Saturday',
                        ]);
                        BY = $toNativeArray(
                            $kindInt32,
                            [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365]
                        );
                        CK = new CH.ptr(
                            'UTC',
                            DI.nil,
                            DJ.nil,
                            new $Int64(0, 0),
                            new $Int64(0, 0),
                            DK.nil
                        );
                        $pkg.UTC = CK;
                        $pkg.Local = CL;
                        CO = C.New('time: invalid location name');
                        CW = C.New('malformed time zone information');
                        F();
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: $init };
            }
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        $pkg.$init = $init;
        return $pkg;
    })();
    $packages['github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp'] =
        (function () {
            var $pkg = {},
                $init,
                A,
                B,
                C,
                D,
                E,
                G,
                H,
                I,
                J,
                M,
                N,
                O,
                P,
                Q,
                R,
                S,
                AH,
                AI,
                AJ,
                AK,
                AL,
                AM,
                AN,
                AO,
                BI,
                BJ,
                BK,
                BL,
                BM,
                BN,
                BO,
                BP,
                BQ,
                BR,
                BS,
                BT,
                BU,
                BV,
                BY,
                W,
                X,
                Y,
                Z,
                AA,
                AB,
                AC,
                U,
                V,
                AD,
                AE,
                AF,
                AG,
                AP,
                AQ,
                AR,
                AT,
                AV,
                AW,
                AX,
                AY,
                AZ,
                BA,
                BB,
                BD,
                BE,
                BF,
                BG,
                BH;
            A = $packages['github.com/gopherjs/gopherjs/js'];
            B = $packages['time'];
            C = $pkg.IssuanceStatus = $newType(
                4,
                $kindInt,
                'fees.IssuanceStatus',
                true,
                'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                true,
                null
            );
            D = $pkg.IssuanceType = $newType(
                4,
                $kindInt,
                'fees.IssuanceType',
                true,
                'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                true,
                null
            );
            E = $pkg.SalesChannelType = $newType(
                4,
                $kindInt,
                'fees.SalesChannelType',
                true,
                'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                true,
                null
            );
            G = $pkg.FeeType = $newType(
                4,
                $kindInt,
                'fees.FeeType',
                true,
                'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                true,
                null
            );
            H = $pkg.FeeCalculationModel = $newType(
                4,
                $kindInt,
                'fees.FeeCalculationModel',
                true,
                'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                true,
                null
            );
            I = $pkg.FeeDisplayModel = $newType(
                4,
                $kindInt,
                'fees.FeeDisplayModel',
                true,
                'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                true,
                null
            );
            J = $pkg.ItemType = $newType(
                4,
                $kindInt,
                'fees.ItemType',
                true,
                'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                true,
                null
            );
            M = $pkg.IssuanceTypesEnum = $newType(
                0,
                $kindStruct,
                'fees.IssuanceTypesEnum',
                true,
                'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                true,
                function (Private_, Commercial_) {
                    this.$val = this;
                    if (arguments.length === 0) {
                        this.Private = 0;
                        this.Commercial = 0;
                        return;
                    }
                    this.Private = Private_;
                    this.Commercial = Commercial_;
                }
            );
            N = $pkg.ItemTypesEnum = $newType(
                0,
                $kindStruct,
                'fees.ItemTypesEnum',
                true,
                'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                true,
                function (Permit_, PermitType_, Division_) {
                    this.$val = this;
                    if (arguments.length === 0) {
                        this.Permit = 0;
                        this.PermitType = 0;
                        this.Division = 0;
                        return;
                    }
                    this.Permit = Permit_;
                    this.PermitType = PermitType_;
                    this.Division = Division_;
                }
            );
            O = $pkg.FeeTypesEnum = $newType(
                0,
                $kindStruct,
                'fees.FeeTypesEnum',
                true,
                'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                true,
                function (
                    CLIN_,
                    Transaction_,
                    Use_,
                    Ticket_,
                    Attribute_,
                    POS_,
                    Tax_,
                    Cancellation_,
                    Reservation_
                ) {
                    this.$val = this;
                    if (arguments.length === 0) {
                        this.CLIN = 0;
                        this.Transaction = 0;
                        this.Use = 0;
                        this.Ticket = 0;
                        this.Attribute = 0;
                        this.POS = 0;
                        this.Tax = 0;
                        this.Cancellation = 0;
                        this.Reservation = 0;
                        return;
                    }
                    this.CLIN = CLIN_;
                    this.Transaction = Transaction_;
                    this.Use = Use_;
                    this.Ticket = Ticket_;
                    this.Attribute = Attribute_;
                    this.POS = POS_;
                    this.Tax = Tax_;
                    this.Cancellation = Cancellation_;
                    this.Reservation = Reservation_;
                }
            );
            P = $pkg.FeeCalculationModelsEnum = $newType(
                0,
                $kindStruct,
                'fees.FeeCalculationModelsEnum',
                true,
                'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                true,
                function (
                    NoUseFee_,
                    FlatUseFee_,
                    PerGroupPerNight_,
                    PerMember_,
                    PerGroupPerDay_,
                    PerGroupSizePerDay_
                ) {
                    this.$val = this;
                    if (arguments.length === 0) {
                        this.NoUseFee = 0;
                        this.FlatUseFee = 0;
                        this.PerGroupPerNight = 0;
                        this.PerMember = 0;
                        this.PerGroupPerDay = 0;
                        this.PerGroupSizePerDay = 0;
                        return;
                    }
                    this.NoUseFee = NoUseFee_;
                    this.FlatUseFee = FlatUseFee_;
                    this.PerGroupPerNight = PerGroupPerNight_;
                    this.PerMember = PerMember_;
                    this.PerGroupPerDay = PerGroupPerDay_;
                    this.PerGroupSizePerDay = PerGroupSizePerDay_;
                }
            );
            Q = $pkg.FeeDisplayModelsEnum = $newType(
                0,
                $kindStruct,
                'fees.FeeDisplayModelsEnum',
                true,
                'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                true,
                function (OneFee_, AddOnFee_) {
                    this.$val = this;
                    if (arguments.length === 0) {
                        this.OneFee = 0;
                        this.AddOnFee = 0;
                        return;
                    }
                    this.OneFee = OneFee_;
                    this.AddOnFee = AddOnFee_;
                }
            );
            R = $pkg.LineItemGenerationModel = $newType(
                4,
                $kindInt,
                'fees.LineItemGenerationModel',
                true,
                'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                true,
                null
            );
            S = $pkg.LineItemGenerationModelsEnum = $newType(
                0,
                $kindStruct,
                'fees.LineItemGenerationModelsEnum',
                true,
                'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                true,
                function (Regular_, UseFeeRefund_, FullRefund_) {
                    this.$val = this;
                    if (arguments.length === 0) {
                        this.Regular = 0;
                        this.UseFeeRefund = 0;
                        this.FullRefund = 0;
                        return;
                    }
                    this.Regular = Regular_;
                    this.UseFeeRefund = UseFeeRefund_;
                    this.FullRefund = FullRefund_;
                }
            );
            AH = $pkg.Fee = $newType(
                0,
                $kindStruct,
                'fees.Fee',
                true,
                'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                true,
                function (
                    Raw_,
                    SKU_,
                    Description_,
                    Type_,
                    Amount_,
                    SalesChannelType_,
                    OverridesSKU_
                ) {
                    this.$val = this;
                    if (arguments.length === 0) {
                        this.Raw = null;
                        this.SKU = '';
                        this.Description = '';
                        this.Type = 0;
                        this.Amount = 0;
                        this.SalesChannelType = 0;
                        this.OverridesSKU = '';
                        return;
                    }
                    this.Raw = Raw_;
                    this.SKU = SKU_;
                    this.Description = Description_;
                    this.Type = Type_;
                    this.Amount = Amount_;
                    this.SalesChannelType = SalesChannelType_;
                    this.OverridesSKU = OverridesSKU_;
                }
            );
            AI = $pkg.Individual = $newType(
                0,
                $kindStruct,
                'fees.Individual',
                true,
                'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                true,
                function (Raw_) {
                    this.$val = this;
                    if (arguments.length === 0) {
                        this.Raw = null;
                        return;
                    }
                    this.Raw = Raw_;
                }
            );
            AJ = $pkg.Issuance = $newType(
                0,
                $kindStruct,
                'fees.Issuance',
                true,
                'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                true,
                function (
                    Raw_,
                    ID_,
                    GroupMembers_,
                    DivisionID_,
                    PermitTypeID_,
                    StartDate_,
                    EndDate_,
                    Status_,
                    Type_,
                    SalesChannelType_,
                    FeeOverrides_
                ) {
                    this.$val = this;
                    if (arguments.length === 0) {
                        this.Raw = null;
                        this.ID = '';
                        this.GroupMembers = BP.nil;
                        this.DivisionID = '';
                        this.PermitTypeID = '';
                        this.StartDate = '';
                        this.EndDate = '';
                        this.Status = 0;
                        this.Type = 0;
                        this.SalesChannelType = 0;
                        this.FeeOverrides = BN.nil;
                        return;
                    }
                    this.Raw = Raw_;
                    this.ID = ID_;
                    this.GroupMembers = GroupMembers_;
                    this.DivisionID = DivisionID_;
                    this.PermitTypeID = PermitTypeID_;
                    this.StartDate = StartDate_;
                    this.EndDate = EndDate_;
                    this.Status = Status_;
                    this.Type = Type_;
                    this.SalesChannelType = SalesChannelType_;
                    this.FeeOverrides = FeeOverrides_;
                }
            );
            AK = $pkg.FeeOverride = $newType(
                0,
                $kindStruct,
                'fees.FeeOverride',
                true,
                'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                true,
                function (Raw_, SKU_, Description_, Type_, Amount_) {
                    this.$val = this;
                    if (arguments.length === 0) {
                        this.Raw = null;
                        this.SKU = '';
                        this.Description = '';
                        this.Type = 0;
                        this.Amount = 0;
                        return;
                    }
                    this.Raw = Raw_;
                    this.SKU = SKU_;
                    this.Description = Description_;
                    this.Type = Type_;
                    this.Amount = Amount_;
                }
            );
            AL = $pkg.Division = $newType(
                0,
                $kindStruct,
                'fees.Division',
                true,
                'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                true,
                function (
                    Raw_,
                    ID_,
                    Type_,
                    FeeCalculationModel_,
                    FeeDisplayModel_,
                    Fees_,
                    CommercialFees_
                ) {
                    this.$val = this;
                    if (arguments.length === 0) {
                        this.Raw = null;
                        this.ID = '';
                        this.Type = '';
                        this.FeeCalculationModel = 0;
                        this.FeeDisplayModel = 0;
                        this.Fees = BQ.nil;
                        this.CommercialFees = BQ.nil;
                        return;
                    }
                    this.Raw = Raw_;
                    this.ID = ID_;
                    this.Type = Type_;
                    this.FeeCalculationModel = FeeCalculationModel_;
                    this.FeeDisplayModel = FeeDisplayModel_;
                    this.Fees = Fees_;
                    this.CommercialFees = CommercialFees_;
                }
            );
            AM = $pkg.Permit = $newType(
                0,
                $kindStruct,
                'fees.Permit',
                true,
                'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                true,
                function (Raw_, OrgCode_, ID_, Rules_, Divisions_) {
                    this.$val = this;
                    if (arguments.length === 0) {
                        this.Raw = null;
                        this.OrgCode = '';
                        this.ID = '';
                        this.Rules = BS.nil;
                        this.Divisions = false;
                        return;
                    }
                    this.Raw = Raw_;
                    this.OrgCode = OrgCode_;
                    this.ID = ID_;
                    this.Rules = Rules_;
                    this.Divisions = Divisions_;
                }
            );
            AN = $pkg.Rule = $newType(
                0,
                $kindStruct,
                'fees.Rule',
                true,
                'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                true,
                function (Raw_, ItemID_, ItemType_, Name_, Value_) {
                    this.$val = this;
                    if (arguments.length === 0) {
                        this.Raw = null;
                        this.ItemID = '';
                        this.ItemType = 0;
                        this.Name = '';
                        this.Value = new $Int64(0, 0);
                        return;
                    }
                    this.Raw = Raw_;
                    this.ItemID = ItemID_;
                    this.ItemType = ItemType_;
                    this.Name = Name_;
                    this.Value = Value_;
                }
            );
            AO = $pkg.LineItem = $newType(
                0,
                $kindStruct,
                'fees.LineItem',
                true,
                'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                true,
                function (
                    Raw_,
                    Sku_,
                    Description_,
                    UnitPrice_,
                    Quantity_,
                    FeeType_,
                    AffectedSkus_,
                    DisplayAs_
                ) {
                    this.$val = this;
                    if (arguments.length === 0) {
                        this.Raw = null;
                        this.Sku = '';
                        this.Description = '';
                        this.UnitPrice = 0;
                        this.Quantity = 0;
                        this.FeeType = 0;
                        this.AffectedSkus = BK.nil;
                        this.DisplayAs = '';
                        return;
                    }
                    this.Raw = Raw_;
                    this.Sku = Sku_;
                    this.Description = Description_;
                    this.UnitPrice = UnitPrice_;
                    this.Quantity = Quantity_;
                    this.FeeType = FeeType_;
                    this.AffectedSkus = AffectedSkus_;
                    this.DisplayAs = DisplayAs_;
                }
            );
            BI = $ptrType(AO);
            BJ = $sliceType(BI);
            BK = $sliceType($String);
            BL = $ptrType(AH);
            BM = $ptrType(AK);
            BN = $sliceType(BM);
            BO = $ptrType(AI);
            BP = $sliceType(BO);
            BQ = $sliceType(BL);
            BR = $ptrType(AN);
            BS = $sliceType(BR);
            BT = $ptrType(AL);
            BU = $mapType($String, BT);
            BV = $ptrType(B.Location);
            BY = $ptrType(A.Object);
            U = function (a, b, c, d) {
                var a, b, c, d, e, f, g, h, i, j, k, l, $s, $r;
                $s = 0;
                var $f,
                    $c = false;
                if (this !== undefined && this.$blk !== undefined) {
                    $f = this;
                    $c = true;
                    a = $f.a;
                    b = $f.b;
                    c = $f.c;
                    d = $f.d;
                    e = $f.e;
                    f = $f.f;
                    g = $f.g;
                    h = $f.h;
                    i = $f.i;
                    j = $f.j;
                    k = $f.k;
                    l = $f.l;
                    $s = $f.$s;
                    $r = $f.$r;
                }
                s: while (true) {
                    switch ($s) {
                        case 0:
                            f = V(a, b, c, $pkg.DefaultUseFeeCalculationMap);
                            $s = 1;
                        case 1:
                            if ($c) {
                                $c = false;
                                f = f.$blk();
                            }
                            if (f && f.$blk !== undefined) {
                                break s;
                            }
                            e = f;
                            g = e[0];
                            h = e[1];
                            if (h.$length > 0) {
                                $s = -1;
                                return [new BJ([]), h];
                            }
                            i = d;
                            if (i === $pkg.LineItemGenerationModels.UseFeeRefund) {
                                j =
                                    $parseInt(b.Raw.fee_display_model) >> 0 ===
                                    $pkg.FeeDisplayModels.OneFee;
                                k = AQ(g, j);
                                k = BG(b, k);
                                g = $appendSlice(g, k);
                            } else if (i === $pkg.LineItemGenerationModels.FullRefund) {
                                l = AR(g);
                                g = $appendSlice(g, l);
                            }
                            g = BH(g);
                            $s = -1;
                            return [g, h];
                    }
                    return;
                }
                if ($f === undefined) {
                    $f = { $blk: U };
                }
                $f.a = a;
                $f.b = b;
                $f.c = c;
                $f.d = d;
                $f.e = e;
                $f.f = f;
                $f.g = g;
                $f.h = h;
                $f.i = i;
                $f.j = j;
                $f.k = k;
                $f.l = l;
                $f.$s = $s;
                $f.$r = $r;
                return $f;
            };
            $pkg.GenerateLineItems = U;
            V = function (a, b, c, d) {
                var a,
                    aa,
                    ab,
                    ac,
                    ad,
                    ae,
                    af,
                    ag,
                    ah,
                    ai,
                    aj,
                    b,
                    c,
                    d,
                    e,
                    f,
                    g,
                    h,
                    i,
                    j,
                    k,
                    l,
                    m,
                    n,
                    o,
                    p,
                    q,
                    r,
                    s,
                    t,
                    u,
                    v,
                    w,
                    x,
                    y,
                    z,
                    $s,
                    $r;
                $s = 0;
                var $f,
                    $c = false;
                if (this !== undefined && this.$blk !== undefined) {
                    $f = this;
                    $c = true;
                    a = $f.a;
                    aa = $f.aa;
                    ab = $f.ab;
                    ac = $f.ac;
                    ad = $f.ad;
                    ae = $f.ae;
                    af = $f.af;
                    ag = $f.ag;
                    ah = $f.ah;
                    ai = $f.ai;
                    aj = $f.aj;
                    b = $f.b;
                    c = $f.c;
                    d = $f.d;
                    e = $f.e;
                    f = $f.f;
                    g = $f.g;
                    h = $f.h;
                    i = $f.i;
                    j = $f.j;
                    k = $f.k;
                    l = $f.l;
                    m = $f.m;
                    n = $f.n;
                    o = $f.o;
                    p = $f.p;
                    q = $f.q;
                    r = $f.r;
                    s = $f.s;
                    t = $f.t;
                    u = $f.u;
                    v = $f.v;
                    w = $f.w;
                    x = $f.x;
                    y = $f.y;
                    z = $f.z;
                    $s = $f.$s;
                    $r = $f.$r;
                }
                s: while (true) {
                    switch ($s) {
                        case 0:
                            e = new BJ([]);
                            f = new BK([]);
                            if (true) {
                                if (!BD(b.Raw, 'fee_calculation_model')) {
                                    $s = -1;
                                    return [
                                        e,
                                        new BK(['Division has no fee calculation model']),
                                    ];
                                }
                            }
                            g =
                                ((h =
                                    d[
                                        H.keyFor(
                                            $parseInt(b.Raw.fee_calculation_model) >> 0
                                        )
                                    ]),
                                h !== undefined
                                    ? [h.v, true]
                                    : [$throwNilPointerError, false]);
                            i = g[0];
                            j = g[1];
                            if (!j) {
                                f = $append(
                                    f,
                                    'Could not determine division use fee calculation model'
                                );
                                $s = -1;
                                return [e, f];
                            }
                            k = AG(a, b);
                            l = k[0];
                            m = k[1];
                            if (m > 0) {
                                e = $append(e, l);
                            }
                            n = $makeMap($String.keyFor, []);
                            o = $clone(b, AL).getFees();
                            p = 0;
                            while (true) {
                                if (!(p < o.$length)) {
                                    break;
                                }
                                q =
                                    p < 0 || p >= o.$length
                                        ? ($throwRuntimeError('index out of range'),
                                          undefined)
                                        : o.$array[o.$offset + p];
                                r = $internalize(q.Raw.sku, $String);
                                (n ||
                                    $throwRuntimeError('assignment to entry in nil map'))[
                                    $String.keyFor(r)
                                ] = { k: r, v: q };
                                p++;
                            }
                            if (
                                $parseInt(a.Raw.type) >> 0 ===
                                $pkg.IssuanceTypes.Commercial
                            ) {
                                s = $clone(b, AL).getCommercialFees();
                                t = 0;
                                while (true) {
                                    if (!(t < s.$length)) {
                                        break;
                                    }
                                    u =
                                        t < 0 || t >= s.$length
                                            ? ($throwRuntimeError('index out of range'),
                                              undefined)
                                            : s.$array[s.$offset + t];
                                    v = $internalize(u.Raw.overrides_sku, $String);
                                    (n ||
                                        $throwRuntimeError(
                                            'assignment to entry in nil map'
                                        ))[$String.keyFor(v)] = { k: v, v: u };
                                    t++;
                                }
                            }
                            w = $clone(b, AL).getFees();
                            x = 0;
                        case 1:
                            if (!(x < w.$length)) {
                                $s = 2;
                                continue;
                            }
                            y =
                                x < 0 || x >= w.$length
                                    ? ($throwRuntimeError('index out of range'),
                                      undefined)
                                    : w.$array[w.$offset + x];
                            aa =
                                ((z =
                                    n[$String.keyFor($internalize(y.Raw.sku, $String))]),
                                z !== undefined ? z.v : BL.nil);
                            ab = $parseInt(aa.Raw.type) >> 0;
                            if (ab === $pkg.FeeTypes.Reservation) {
                                $s = 4;
                                continue;
                            }
                            if (ab === $pkg.FeeTypes.Use) {
                                $s = 5;
                                continue;
                            }
                            $s = 6;
                            continue;
                        case 4:
                            ac = AF(a, b, c, aa, m);
                            if ($parseInt(ac.Raw.UnitPrice) >> 0 > 0) {
                                e = $append(e, ac);
                            }
                            $s = 6;
                            continue;
                        case 5:
                            ae = i(a, b, c, aa, m);
                            $s = 7;
                        case 7:
                            if ($c) {
                                $c = false;
                                ae = ae.$blk();
                            }
                            if (ae && ae.$blk !== undefined) {
                                break s;
                            }
                            ad = ae;
                            af = ad[0];
                            ag = ad[1];
                            af = BF(af, b, l);
                            e = $appendSlice(e, af);
                            f = $appendSlice(f, ag);
                        case 6:
                        case 3:
                            x++;
                            $s = 1;
                            continue;
                        case 2:
                            ah = AD(a, e);
                            ai = ah[0];
                            aj = ah[1];
                            e = $appendSlice(e, ai);
                            f = $appendSlice(f, aj);
                            $s = -1;
                            return [e, f];
                    }
                    return;
                }
                if ($f === undefined) {
                    $f = { $blk: V };
                }
                $f.a = a;
                $f.aa = aa;
                $f.ab = ab;
                $f.ac = ac;
                $f.ad = ad;
                $f.ae = ae;
                $f.af = af;
                $f.ag = ag;
                $f.ah = ah;
                $f.ai = ai;
                $f.aj = aj;
                $f.b = b;
                $f.c = c;
                $f.d = d;
                $f.e = e;
                $f.f = f;
                $f.g = g;
                $f.h = h;
                $f.i = i;
                $f.j = j;
                $f.k = k;
                $f.l = l;
                $f.m = m;
                $f.n = n;
                $f.o = o;
                $f.p = p;
                $f.q = q;
                $f.r = r;
                $f.s = s;
                $f.t = t;
                $f.u = u;
                $f.v = v;
                $f.w = w;
                $f.x = x;
                $f.y = y;
                $f.z = z;
                $f.$s = $s;
                $f.$r = $r;
                return $f;
            };
            AD = function (a, b) {
                var a,
                    aa,
                    b,
                    c,
                    d,
                    e,
                    f,
                    g,
                    h,
                    i,
                    j,
                    k,
                    l,
                    m,
                    n,
                    o,
                    p,
                    q,
                    r,
                    s,
                    t,
                    u,
                    v,
                    w,
                    x,
                    y,
                    z;
                c = new BJ([]);
                d = new BK([]);
                if (true) {
                    if (!BD(a.Raw, 'fee_overrides')) {
                        return [c, d];
                    }
                }
                if ($internalize(a.Raw.fee_overrides, BN).$length === 0) {
                    return [c, d];
                }
                e = {};
                f = {};
                g = $internalize(a.Raw.fee_overrides, BN);
                h = 0;
                while (true) {
                    if (!(h < g.$length)) {
                        break;
                    }
                    i =
                        h < 0 || h >= g.$length
                            ? ($throwRuntimeError('index out of range'), undefined)
                            : g.$array[g.$offset + h];
                    j = BB();
                    j.Raw.Sku = $externalize($internalize(i.Raw.sku, $String), $String);
                    j.Raw.Description = $externalize(
                        $internalize(i.Raw.description, $String),
                        $String
                    );
                    j.Raw.UnitPrice = AT($parseInt(i.Raw.amount) >> 0);
                    j.Raw.Quantity = 1;
                    j.Raw.FeeType = $parseInt(i.Raw.type) >> 0;
                    j.Raw.DisplayAs = $externalize('Fee Adjustment', $String);
                    k = $parseInt(i.Raw.type) >> 0;
                    (f || $throwRuntimeError('assignment to entry in nil map'))[
                        G.keyFor(k)
                    ] = { k: k, v: j };
                    h++;
                }
                l = b;
                m = 0;
                while (true) {
                    if (!(m < l.$length)) {
                        break;
                    }
                    n =
                        m < 0 || m >= l.$length
                            ? ($throwRuntimeError('index out of range'), undefined)
                            : l.$array[l.$offset + m];
                    o =
                        ((p = e[G.keyFor($parseInt(n.Raw.FeeType) >> 0)]),
                        p !== undefined ? [p.v, true] : [0, false]);
                    q = o[0];
                    r = o[1];
                    if (!r) {
                        q = $parseInt(n.Raw.FeeType) >> 0;
                    }
                    s =
                        ((t = f[G.keyFor(q)]),
                        t !== undefined ? [t.v, true] : [BI.nil, false]);
                    u = s[0];
                    v = s[1];
                    if (v) {
                        u.Raw.UnitPrice =
                            (($parseInt(u.Raw.UnitPrice) >> 0) -
                                $imul(
                                    $parseInt(n.Raw.UnitPrice) >> 0,
                                    $parseInt(n.Raw.Quantity) >> 0
                                )) >>
                            0;
                    }
                    m++;
                }
                w = f;
                x = 0;
                y = $keys(w);
                while (true) {
                    if (!(x < y.length)) {
                        break;
                    }
                    z = w[y[x]];
                    if (z === undefined) {
                        x++;
                        continue;
                    }
                    aa = z.v;
                    if (!($parseInt(aa.Raw.UnitPrice) >> 0 === 0)) {
                        c = $append(c, aa);
                    }
                    x++;
                }
                return [c, d];
            };
            AE = function (a, b) {
                var a, b;
                if (b > 0) {
                    return a + 'RESIDUAL';
                }
                return a;
            };
            AF = function (a, b, c, d, e) {
                var a, b, c, d, e, f, g, h;
                f = BB();
                g = $pkg.FeeTypes.Reservation;
                h = AE($internalize(c.Raw.org_code, $String), e);
                f.Raw.Sku = $externalize(h, $String);
                f.Raw.Description = $externalize(
                    $internalize(d.Raw.description, $String),
                    $String
                );
                f.Raw.UnitPrice = (AT($parseInt(d.Raw.amount) >> 0) - e) >> 0;
                f.Raw.Quantity = 1;
                f.Raw.FeeType = g;
                if (
                    $parseInt(b.Raw.fee_display_model) >> 0 ===
                    $pkg.FeeDisplayModels.OneFee
                ) {
                    f.Raw.DisplayAs = $externalize('Use Fee', $String);
                } else {
                    f.Raw.DisplayAs = $externalize('Reservation Fee', $String);
                }
                return f;
            };
            AG = function (a, b) {
                var a, b, c, d;
                c = 0;
                d = BB();
                if (
                    $parseInt(b.Raw.fee_display_model) >> 0 ===
                    $pkg.FeeDisplayModels.OneFee
                ) {
                    d.Raw.DisplayAs = $externalize('Use Fee', $String);
                } else {
                    d.Raw.DisplayAs = $externalize('Reservation Fee', $String);
                }
                return [d, c];
            };
            AJ.ptr.prototype.getGroupSize = function () {
                var a;
                a = this;
                if (true) {
                    if (!BD(a.Raw, 'group_members')) {
                        return 0;
                    }
                }
                return $internalize(a.Raw.group_members, BP).$length;
            };
            AJ.prototype.getGroupSize = function () {
                return this.$val.getGroupSize();
            };
            AL.ptr.prototype.getFees = function () {
                var a;
                a = this;
                if (true) {
                    if (!BD(a.Raw, 'fees')) {
                        return new BQ([]);
                    }
                }
                return $internalize(a.Raw.fees, BQ);
            };
            AL.prototype.getFees = function () {
                return this.$val.getFees();
            };
            AL.ptr.prototype.getCommercialFees = function () {
                var a;
                a = this;
                if (true) {
                    if (!BD(a.Raw, 'commercial_fees')) {
                        return new BQ([]);
                    }
                }
                return $internalize(a.Raw.commercial_fees, BQ);
            };
            AL.prototype.getCommercialFees = function () {
                return this.$val.getCommercialFees();
            };
            AP = function (a) {
                var a, b;
                b = BB();
                b.Raw.Sku = $externalize($internalize(a.Raw.Sku, $String), $String);
                b.Raw.Description = $externalize(
                    $internalize(a.Raw.Description, $String) + ' - Refund',
                    $String
                );
                b.Raw.UnitPrice = -($parseInt(a.Raw.UnitPrice) >> 0);
                b.Raw.Quantity = $parseInt(a.Raw.Quantity) >> 0;
                b.Raw.FeeType = $pkg.FeeTypes.Use;
                b.Raw.DisplayAs = $externalize('Refund', $String);
                return b;
            };
            AQ = function (a, b) {
                var a, b, c, d, e, f, g;
                c = new BJ([]);
                d = a;
                e = 0;
                while (true) {
                    if (!(e < d.$length)) {
                        break;
                    }
                    f =
                        e < 0 || e >= d.$length
                            ? ($throwRuntimeError('index out of range'), undefined)
                            : d.$array[d.$offset + e];
                    g = $parseInt(f.Raw.FeeType) >> 0;
                    if (g === $pkg.FeeTypes.Use) {
                        c = $append(c, AP(f));
                    }
                    e++;
                }
                return c;
            };
            AR = function (a) {
                var a, b, c, d, e;
                b = new BJ([]);
                c = a;
                d = 0;
                while (true) {
                    if (!(d < c.$length)) {
                        break;
                    }
                    e =
                        d < 0 || d >= c.$length
                            ? ($throwRuntimeError('index out of range'), undefined)
                            : c.$array[c.$offset + d];
                    b = $append(b, AP(e));
                    d++;
                }
                return b;
            };
            AT = function (a) {
                var a;
                return $imul(a, 1000);
            };
            AV = function (a, b) {
                var a, b, c, $s, $r;
                $s = 0;
                var $f,
                    $c = false;
                if (this !== undefined && this.$blk !== undefined) {
                    $f = this;
                    $c = true;
                    a = $f.a;
                    b = $f.b;
                    c = $f.c;
                    $s = $f.$s;
                    $r = $f.$r;
                }
                s: while (true) {
                    switch ($s) {
                        case 0:
                            c = AW(a, b);
                            $s = 1;
                        case 1:
                            if ($c) {
                                $c = false;
                                c = c.$blk();
                            }
                            if (c && c.$blk !== undefined) {
                                break s;
                            }
                            $s = -1;
                            return (c + 1) >> 0;
                    }
                    return;
                }
                if ($f === undefined) {
                    $f = { $blk: AV };
                }
                $f.a = a;
                $f.b = b;
                $f.c = c;
                $f.$s = $s;
                $f.$r = $r;
                return $f;
            };
            AW = function (a, b) {
                var a, b, c, d, e, f, $s, $r;
                $s = 0;
                var $f,
                    $c = false;
                if (this !== undefined && this.$blk !== undefined) {
                    $f = this;
                    $c = true;
                    a = $f.a;
                    b = $f.b;
                    c = $f.c;
                    d = $f.d;
                    e = $f.e;
                    f = $f.f;
                    $s = $f.$s;
                    $r = $f.$r;
                }
                s: while (true) {
                    switch ($s) {
                        case 0:
                            c = BE(a);
                            $s = 1;
                        case 1:
                            if ($c) {
                                $c = false;
                                c = c.$blk();
                            }
                            if (c && c.$blk !== undefined) {
                                break s;
                            }
                            d = $clone(c, B.Time);
                            e = BE(b);
                            $s = 2;
                        case 2:
                            if ($c) {
                                $c = false;
                                e = e.$blk();
                            }
                            if (e && e.$blk !== undefined) {
                                break s;
                            }
                            f = $clone(e, B.Time);
                            $s = -1;
                            return (
                                ($clone(f, B.Time).Sub($clone(d, B.Time)).Hours() / 24) >>
                                0
                            );
                    }
                    return;
                }
                if ($f === undefined) {
                    $f = { $blk: AW };
                }
                $f.a = a;
                $f.b = b;
                $f.c = c;
                $f.d = d;
                $f.e = e;
                $f.f = f;
                $f.$s = $s;
                $f.$r = $r;
                return $f;
            };
            AX = function (a, b, c) {
                var a, b, c, d, e, f, g, h, i, j, k, l, $s, $r;
                $s = 0;
                var $f,
                    $c = false;
                if (this !== undefined && this.$blk !== undefined) {
                    $f = this;
                    $c = true;
                    a = $f.a;
                    b = $f.b;
                    c = $f.c;
                    d = $f.d;
                    e = $f.e;
                    f = $f.f;
                    g = $f.g;
                    h = $f.h;
                    i = $f.i;
                    j = $f.j;
                    k = $f.k;
                    l = $f.l;
                    $s = $f.$s;
                    $r = $f.$r;
                }
                s: while (true) {
                    switch ($s) {
                        case 0:
                            e = B.Parse('2006-01-02T15:04:05Z07:00', '0');
                            $s = 1;
                        case 1:
                            if ($c) {
                                $c = false;
                                e = e.$blk();
                            }
                            if (e && e.$blk !== undefined) {
                                break s;
                            }
                            d = e;
                            f = $clone(d[0], B.Time);
                            h = B.Parse('2006-01-02T15:04:05Z07:00', a);
                            $s = 2;
                        case 2:
                            if ($c) {
                                $c = false;
                                h = h.$blk();
                            }
                            if (h && h.$blk !== undefined) {
                                break s;
                            }
                            g = h;
                            i = $clone(g[0], B.Time);
                            k = B.Parse('2006-01-02T15:04:05Z07:00', b);
                            $s = 3;
                        case 3:
                            if ($c) {
                                $c = false;
                                k = k.$blk();
                            }
                            if (k && k.$blk !== undefined) {
                                break s;
                            }
                            j = k;
                            l = $clone(j[0], B.Time);
                            if ($equal(l, f, B.Time) || $equal(i, f, B.Time)) {
                                $s = -1;
                                return [
                                    false,
                                    c +
                                        ' has either an undefined end date, or an end date before their start date',
                                ];
                            }
                            $s = -1;
                            return [true, ''];
                    }
                    return;
                }
                if ($f === undefined) {
                    $f = { $blk: AX };
                }
                $f.a = a;
                $f.b = b;
                $f.c = c;
                $f.d = d;
                $f.e = e;
                $f.f = f;
                $f.g = g;
                $f.h = h;
                $f.i = i;
                $f.j = j;
                $f.k = k;
                $f.l = l;
                $f.$s = $s;
                $f.$r = $r;
                return $f;
            };
            AY = function (a, b, c) {
                var a, b, c, d, e, f, g, h, i, j, k, l, m, $s, $r;
                $s = 0;
                var $f,
                    $c = false;
                if (this !== undefined && this.$blk !== undefined) {
                    $f = this;
                    $c = true;
                    a = $f.a;
                    b = $f.b;
                    c = $f.c;
                    d = $f.d;
                    e = $f.e;
                    f = $f.f;
                    g = $f.g;
                    h = $f.h;
                    i = $f.i;
                    j = $f.j;
                    k = $f.k;
                    l = $f.l;
                    m = $f.m;
                    $s = $f.$s;
                    $r = $f.$r;
                }
                s: while (true) {
                    switch ($s) {
                        case 0:
                            d = AZ(
                                'HighUseSeasonStart',
                                $internalize(b.Raw.id, $String),
                                $pkg.ItemTypes.Division,
                                $internalize(c.Raw.rules, BS)
                            );
                            e = $clone(d[0], AN);
                            f = d[1];
                            g = AZ(
                                'HighUseSeasonEnd',
                                $internalize(b.Raw.id, $String),
                                $pkg.ItemTypes.Division,
                                $internalize(c.Raw.rules, BS)
                            );
                            h = $clone(g[0], AN);
                            i = g[1];
                            if (!f || !i) {
                                $s = -1;
                                return false;
                            }
                            j = $clone(
                                B.Unix(
                                    $internalize(e.Raw.value, $Int64),
                                    new $Int64(0, 0)
                                ),
                                B.Time
                            );
                            k = $clone(
                                B.Unix(
                                    $internalize(h.Raw.value, $Int64),
                                    new $Int64(0, 0)
                                ),
                                B.Time
                            );
                            l = BE($internalize(a.Raw.start_date, $String));
                            $s = 1;
                        case 1:
                            if ($c) {
                                $c = false;
                                l = l.$blk();
                            }
                            if (l && l.$blk !== undefined) {
                                break s;
                            }
                            m = $clone(l, B.Time);
                            $s = -1;
                            return (
                                $clone(m, B.Time).After($clone(j, B.Time)) &&
                                $clone(m, B.Time).Before($clone(k, B.Time))
                            );
                    }
                    return;
                }
                if ($f === undefined) {
                    $f = { $blk: AY };
                }
                $f.a = a;
                $f.b = b;
                $f.c = c;
                $f.d = d;
                $f.e = e;
                $f.f = f;
                $f.g = g;
                $f.h = h;
                $f.i = i;
                $f.j = j;
                $f.k = k;
                $f.l = l;
                $f.m = m;
                $f.$s = $s;
                $f.$r = $r;
                return $f;
            };
            AZ = function (a, b, c, d) {
                var a, b, c, d, e, f, g, h, i, j;
                e = d;
                f = 0;
                while (true) {
                    if (!(f < e.$length)) {
                        break;
                    }
                    g =
                        f < 0 || f >= e.$length
                            ? ($throwRuntimeError('index out of range'), undefined)
                            : e.$array[e.$offset + f];
                    if (
                        a === $internalize(g.Raw.name, $String) &&
                        $internalize(g.Raw.item_id, $String) === b &&
                        $parseInt(g.Raw.item_type) >> 0 === c
                    ) {
                        return [g, true];
                    }
                    f++;
                }
                h = d;
                i = 0;
                while (true) {
                    if (!(i < h.$length)) {
                        break;
                    }
                    j =
                        i < 0 || i >= h.$length
                            ? ($throwRuntimeError('index out of range'), undefined)
                            : h.$array[h.$offset + i];
                    if (
                        a === $internalize(j.Raw.name, $String) &&
                        $parseInt(j.Raw.item_type) >> 0 === $pkg.ItemTypes.Permit
                    ) {
                        return [j, true];
                    }
                    i++;
                }
                return [new AN.ptr(null, '', 0, '', new $Int64(0, 0)), false];
            };
            BA = function (a) {
                var a, b;
                b = BB();
                b.Raw.Sku = $externalize($internalize(a.Raw.sku, $String), $String);
                b.Raw.Description = $externalize(
                    $internalize(a.Raw.description, $String),
                    $String
                );
                b.Raw.UnitPrice = AT($parseInt(a.Raw.amount) >> 0);
                b.Raw.Quantity = 1;
                b.Raw.FeeType = $parseInt(a.Raw.type) >> 0;
                return b;
            };
            BB = function () {
                var a;
                a = new AO.ptr(null, '', '', 0, 0, 0, BK.nil, '');
                if (true) {
                    a = new AO.ptr(new $global.Object(), '', '', 0, 0, 0, BK.nil, '');
                }
                return a;
            };
            BD = function (a, b) {
                var a, b;
                if (
                    a[$externalize(b, $String)] === null ||
                    a[$externalize(b, $String)] === undefined
                ) {
                    return false;
                }
                return true;
            };
            BE = function (a) {
                var a, b, c, d, e, $s, $r;
                $s = 0;
                var $f,
                    $c = false;
                if (this !== undefined && this.$blk !== undefined) {
                    $f = this;
                    $c = true;
                    a = $f.a;
                    b = $f.b;
                    c = $f.c;
                    d = $f.d;
                    e = $f.e;
                    $s = $f.$s;
                    $r = $f.$r;
                }
                s: while (true) {
                    switch ($s) {
                        case 0:
                            c = B.Parse('2006-01-02T15:04:05Z07:00', a);
                            $s = 1;
                        case 1:
                            if ($c) {
                                $c = false;
                                c = c.$blk();
                            }
                            if (c && c.$blk !== undefined) {
                                break s;
                            }
                            b = c;
                            d = $clone(b[0], B.Time);
                            e = b[1];
                            if (!$interfaceIsEqual(e, $ifaceNil)) {
                                $s = -1;
                                return new B.Time.ptr(
                                    new $Uint64(0, 0),
                                    new $Int64(0, 0),
                                    BV.nil
                                );
                            }
                            $s = -1;
                            return d;
                    }
                    return;
                }
                if ($f === undefined) {
                    $f = { $blk: BE };
                }
                $f.a = a;
                $f.b = b;
                $f.c = c;
                $f.d = d;
                $f.e = e;
                $f.$s = $s;
                $f.$r = $r;
                return $f;
            };
            BF = function (a, b, c) {
                var a, b, c, d, e, f, g, h;
                if (
                    $parseInt(b.Raw.fee_display_model) >> 0 ===
                    $pkg.FeeDisplayModels.OneFee
                ) {
                    d = new BJ([]);
                    e = a;
                    f = 0;
                    while (true) {
                        if (!(f < e.$length)) {
                            break;
                        }
                        g =
                            f < 0 || f >= e.$length
                                ? ($throwRuntimeError('index out of range'), undefined)
                                : e.$array[e.$offset + f];
                        g.Raw.DisplayAs = $externalize('Use Fee', $String);
                        d = $append(d, g);
                        f++;
                    }
                    h = BB();
                    h.Raw.Sku = $externalize(
                        $internalize(c.Raw.Sku, $String) + 'OFFSET',
                        $String
                    );
                    h.Raw.Description = $externalize(
                        $internalize(c.Raw.Description, $String) + ' Offset',
                        $String
                    );
                    h.Raw.UnitPrice = -($parseInt(c.Raw.UnitPrice) >> 0);
                    h.Raw.Quantity = $parseInt(c.Raw.Quantity) >> 0;
                    h.Raw.FeeType = $pkg.FeeTypes.Use;
                    h.Raw.DisplayAs = $externalize('Use Fee', $String);
                    d = $append(d, h);
                    return d;
                }
                return a;
            };
            BG = function (a, b) {
                var a, b, c, d, e, f;
                c = $clone(a, AL).getFees();
                d = 0;
                while (true) {
                    if (!(d < c.$length)) {
                        break;
                    }
                    e =
                        d < 0 || d >= c.$length
                            ? ($throwRuntimeError('index out of range'), undefined)
                            : c.$array[c.$offset + d];
                    if ($parseInt(e.Raw.type) >> 0 === $pkg.FeeTypes.Cancellation) {
                        f = BA(e);
                        f.Raw.DisplayAs = $externalize('Cancellation Fee', $String);
                        f.Raw.FeeType = $pkg.FeeTypes.Use;
                        b = $append(b, f);
                    }
                    d++;
                }
                return b;
            };
            BH = function (a) {
                var a, b, c, d, e, f;
                if (true) {
                    return a;
                }
                b = new BJ([]);
                c = a;
                d = 0;
                while (true) {
                    if (!(d < c.$length)) {
                        break;
                    }
                    e =
                        d < 0 || d >= c.$length
                            ? ($throwRuntimeError('index out of range'), undefined)
                            : c.$array[c.$offset + d];
                    f = $parseInt(e.Raw.FeeType) >> 0;
                    if (
                        f === $pkg.FeeTypes.Reservation ||
                        f === $pkg.FeeTypes.Cancellation
                    ) {
                        e.Raw.FeeType = $pkg.FeeTypes.Use;
                    }
                    b = $append(b, e);
                    d++;
                }
                return b;
            };
            AJ.methods = [
                {
                    prop: 'getGroupSize',
                    name: 'getGroupSize',
                    pkg: 'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                    typ: $funcType([], [$Int], false),
                },
            ];
            AL.methods = [
                {
                    prop: 'getFees',
                    name: 'getFees',
                    pkg: 'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                    typ: $funcType([], [BQ], false),
                },
                {
                    prop: 'getCommercialFees',
                    name: 'getCommercialFees',
                    pkg: 'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                    typ: $funcType([], [BQ], false),
                },
            ];
            AM.methods = [
                {
                    prop: 'getRules',
                    name: 'getRules',
                    pkg: 'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                    typ: $funcType([], [BS], false),
                },
                {
                    prop: 'getDivisions',
                    name: 'getDivisions',
                    pkg: 'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp',
                    typ: $funcType([], [BU], false),
                },
            ];
            M.init('', [
                {
                    prop: 'Private',
                    name: 'Private',
                    anonymous: false,
                    exported: true,
                    typ: D,
                    tag: '',
                },
                {
                    prop: 'Commercial',
                    name: 'Commercial',
                    anonymous: false,
                    exported: true,
                    typ: D,
                    tag: '',
                },
            ]);
            N.init('', [
                {
                    prop: 'Permit',
                    name: 'Permit',
                    anonymous: false,
                    exported: true,
                    typ: J,
                    tag: 'tag:"Permit"',
                },
                {
                    prop: 'PermitType',
                    name: 'PermitType',
                    anonymous: false,
                    exported: true,
                    typ: J,
                    tag: 'tag:"Permit Type"',
                },
                {
                    prop: 'Division',
                    name: 'Division',
                    anonymous: false,
                    exported: true,
                    typ: J,
                    tag: 'tag:"Division"',
                },
            ]);
            O.init('', [
                {
                    prop: 'CLIN',
                    name: 'CLIN',
                    anonymous: false,
                    exported: true,
                    typ: G,
                    tag: '',
                },
                {
                    prop: 'Transaction',
                    name: 'Transaction',
                    anonymous: false,
                    exported: true,
                    typ: G,
                    tag: '',
                },
                {
                    prop: 'Use',
                    name: 'Use',
                    anonymous: false,
                    exported: true,
                    typ: G,
                    tag: '',
                },
                {
                    prop: 'Ticket',
                    name: 'Ticket',
                    anonymous: false,
                    exported: true,
                    typ: G,
                    tag: '',
                },
                {
                    prop: 'Attribute',
                    name: 'Attribute',
                    anonymous: false,
                    exported: true,
                    typ: G,
                    tag: '',
                },
                {
                    prop: 'POS',
                    name: 'POS',
                    anonymous: false,
                    exported: true,
                    typ: G,
                    tag: '',
                },
                {
                    prop: 'Tax',
                    name: 'Tax',
                    anonymous: false,
                    exported: true,
                    typ: G,
                    tag: '',
                },
                {
                    prop: 'Cancellation',
                    name: 'Cancellation',
                    anonymous: false,
                    exported: true,
                    typ: G,
                    tag: '',
                },
                {
                    prop: 'Reservation',
                    name: 'Reservation',
                    anonymous: false,
                    exported: true,
                    typ: G,
                    tag: '',
                },
            ]);
            P.init('', [
                {
                    prop: 'NoUseFee',
                    name: 'NoUseFee',
                    anonymous: false,
                    exported: true,
                    typ: H,
                    tag: '',
                },
                {
                    prop: 'FlatUseFee',
                    name: 'FlatUseFee',
                    anonymous: false,
                    exported: true,
                    typ: H,
                    tag: '',
                },
                {
                    prop: 'PerGroupPerNight',
                    name: 'PerGroupPerNight',
                    anonymous: false,
                    exported: true,
                    typ: H,
                    tag: '',
                },
                {
                    prop: 'PerMember',
                    name: 'PerMember',
                    anonymous: false,
                    exported: true,
                    typ: H,
                    tag: '',
                },
                {
                    prop: 'PerGroupPerDay',
                    name: 'PerGroupPerDay',
                    anonymous: false,
                    exported: true,
                    typ: H,
                    tag: '',
                },
                {
                    prop: 'PerGroupSizePerDay',
                    name: 'PerGroupSizePerDay',
                    anonymous: false,
                    exported: true,
                    typ: H,
                    tag: '',
                },
            ]);
            Q.init('', [
                {
                    prop: 'OneFee',
                    name: 'OneFee',
                    anonymous: false,
                    exported: true,
                    typ: I,
                    tag: '',
                },
                {
                    prop: 'AddOnFee',
                    name: 'AddOnFee',
                    anonymous: false,
                    exported: true,
                    typ: I,
                    tag: '',
                },
            ]);
            S.init('', [
                {
                    prop: 'Regular',
                    name: 'Regular',
                    anonymous: false,
                    exported: true,
                    typ: R,
                    tag: '',
                },
                {
                    prop: 'UseFeeRefund',
                    name: 'UseFeeRefund',
                    anonymous: false,
                    exported: true,
                    typ: R,
                    tag: '',
                },
                {
                    prop: 'FullRefund',
                    name: 'FullRefund',
                    anonymous: false,
                    exported: true,
                    typ: R,
                    tag: '',
                },
            ]);
            AH.init('', [
                {
                    prop: 'Raw',
                    name: 'Raw',
                    anonymous: false,
                    exported: true,
                    typ: BY,
                    tag: '',
                },
                {
                    prop: 'SKU',
                    name: 'SKU',
                    anonymous: false,
                    exported: true,
                    typ: $String,
                    tag: 'js:"sku"',
                },
                {
                    prop: 'Description',
                    name: 'Description',
                    anonymous: false,
                    exported: true,
                    typ: $String,
                    tag: 'js:"description"',
                },
                {
                    prop: 'Type',
                    name: 'Type',
                    anonymous: false,
                    exported: true,
                    typ: G,
                    tag: 'js:"type"',
                },
                {
                    prop: 'Amount',
                    name: 'Amount',
                    anonymous: false,
                    exported: true,
                    typ: $Int,
                    tag: 'js:"amount"',
                },
                {
                    prop: 'SalesChannelType',
                    name: 'SalesChannelType',
                    anonymous: false,
                    exported: true,
                    typ: E,
                    tag: 'js:"sales_channel_type"',
                },
                {
                    prop: 'OverridesSKU',
                    name: 'OverridesSKU',
                    anonymous: false,
                    exported: true,
                    typ: $String,
                    tag: 'js:"overrides_sku"',
                },
            ]);
            AI.init('', [
                {
                    prop: 'Raw',
                    name: 'Raw',
                    anonymous: false,
                    exported: true,
                    typ: BY,
                    tag: '',
                },
            ]);
            AJ.init('', [
                {
                    prop: 'Raw',
                    name: 'Raw',
                    anonymous: false,
                    exported: true,
                    typ: BY,
                    tag: '',
                },
                {
                    prop: 'ID',
                    name: 'ID',
                    anonymous: false,
                    exported: true,
                    typ: $String,
                    tag: 'js:"id"',
                },
                {
                    prop: 'GroupMembers',
                    name: 'GroupMembers',
                    anonymous: false,
                    exported: true,
                    typ: BP,
                    tag: 'js:"group_members"',
                },
                {
                    prop: 'DivisionID',
                    name: 'DivisionID',
                    anonymous: false,
                    exported: true,
                    typ: $String,
                    tag: 'js:"division_id"',
                },
                {
                    prop: 'PermitTypeID',
                    name: 'PermitTypeID',
                    anonymous: false,
                    exported: true,
                    typ: $String,
                    tag: 'js:"permit_type_id"',
                },
                {
                    prop: 'StartDate',
                    name: 'StartDate',
                    anonymous: false,
                    exported: true,
                    typ: $String,
                    tag: 'js:"start_date"',
                },
                {
                    prop: 'EndDate',
                    name: 'EndDate',
                    anonymous: false,
                    exported: true,
                    typ: $String,
                    tag: 'js:"end_date"',
                },
                {
                    prop: 'Status',
                    name: 'Status',
                    anonymous: false,
                    exported: true,
                    typ: C,
                    tag: 'js:"status"',
                },
                {
                    prop: 'Type',
                    name: 'Type',
                    anonymous: false,
                    exported: true,
                    typ: D,
                    tag: 'js:"type"',
                },
                {
                    prop: 'SalesChannelType',
                    name: 'SalesChannelType',
                    anonymous: false,
                    exported: true,
                    typ: E,
                    tag: 'js:"sales_channel_type"',
                },
                {
                    prop: 'FeeOverrides',
                    name: 'FeeOverrides',
                    anonymous: false,
                    exported: true,
                    typ: BN,
                    tag: 'js:"fee_overrides"',
                },
            ]);
            AK.init('', [
                {
                    prop: 'Raw',
                    name: 'Raw',
                    anonymous: false,
                    exported: true,
                    typ: BY,
                    tag: '',
                },
                {
                    prop: 'SKU',
                    name: 'SKU',
                    anonymous: false,
                    exported: true,
                    typ: $String,
                    tag: 'js:"sku"',
                },
                {
                    prop: 'Description',
                    name: 'Description',
                    anonymous: false,
                    exported: true,
                    typ: $String,
                    tag: 'js:"description"',
                },
                {
                    prop: 'Type',
                    name: 'Type',
                    anonymous: false,
                    exported: true,
                    typ: G,
                    tag: 'js:"type"',
                },
                {
                    prop: 'Amount',
                    name: 'Amount',
                    anonymous: false,
                    exported: true,
                    typ: $Int,
                    tag: 'js:"amount"',
                },
            ]);
            AL.init('', [
                {
                    prop: 'Raw',
                    name: 'Raw',
                    anonymous: false,
                    exported: true,
                    typ: BY,
                    tag: '',
                },
                {
                    prop: 'ID',
                    name: 'ID',
                    anonymous: false,
                    exported: true,
                    typ: $String,
                    tag: 'js:"id"',
                },
                {
                    prop: 'Type',
                    name: 'Type',
                    anonymous: false,
                    exported: true,
                    typ: $String,
                    tag: 'js:"type"',
                },
                {
                    prop: 'FeeCalculationModel',
                    name: 'FeeCalculationModel',
                    anonymous: false,
                    exported: true,
                    typ: H,
                    tag: 'js:"fee_calculation_model"',
                },
                {
                    prop: 'FeeDisplayModel',
                    name: 'FeeDisplayModel',
                    anonymous: false,
                    exported: true,
                    typ: I,
                    tag: 'js:"fee_display_model"',
                },
                {
                    prop: 'Fees',
                    name: 'Fees',
                    anonymous: false,
                    exported: true,
                    typ: BQ,
                    tag: 'js:"fees"',
                },
                {
                    prop: 'CommercialFees',
                    name: 'CommercialFees',
                    anonymous: false,
                    exported: true,
                    typ: BQ,
                    tag: 'js:"commercial_fees"',
                },
            ]);
            AM.init('', [
                {
                    prop: 'Raw',
                    name: 'Raw',
                    anonymous: false,
                    exported: true,
                    typ: BY,
                    tag: '',
                },
                {
                    prop: 'OrgCode',
                    name: 'OrgCode',
                    anonymous: false,
                    exported: true,
                    typ: $String,
                    tag: 'js:"org_code"',
                },
                {
                    prop: 'ID',
                    name: 'ID',
                    anonymous: false,
                    exported: true,
                    typ: $String,
                    tag: 'js:"id"',
                },
                {
                    prop: 'Rules',
                    name: 'Rules',
                    anonymous: false,
                    exported: true,
                    typ: BS,
                    tag: 'js:"rules"',
                },
                {
                    prop: 'Divisions',
                    name: 'Divisions',
                    anonymous: false,
                    exported: true,
                    typ: BU,
                    tag: 'js:"divisions"',
                },
            ]);
            AN.init('', [
                {
                    prop: 'Raw',
                    name: 'Raw',
                    anonymous: false,
                    exported: true,
                    typ: BY,
                    tag: '',
                },
                {
                    prop: 'ItemID',
                    name: 'ItemID',
                    anonymous: false,
                    exported: true,
                    typ: $String,
                    tag: 'js:"item_id"',
                },
                {
                    prop: 'ItemType',
                    name: 'ItemType',
                    anonymous: false,
                    exported: true,
                    typ: J,
                    tag: 'js:"item_type"',
                },
                {
                    prop: 'Name',
                    name: 'Name',
                    anonymous: false,
                    exported: true,
                    typ: $String,
                    tag: 'js:"name"',
                },
                {
                    prop: 'Value',
                    name: 'Value',
                    anonymous: false,
                    exported: true,
                    typ: $Int64,
                    tag: 'js:"value"',
                },
            ]);
            AO.init('', [
                {
                    prop: 'Raw',
                    name: 'Raw',
                    anonymous: false,
                    exported: true,
                    typ: BY,
                    tag: '',
                },
                {
                    prop: 'Sku',
                    name: 'Sku',
                    anonymous: false,
                    exported: true,
                    typ: $String,
                    tag: 'js:"Sku"',
                },
                {
                    prop: 'Description',
                    name: 'Description',
                    anonymous: false,
                    exported: true,
                    typ: $String,
                    tag: 'js:"Description"',
                },
                {
                    prop: 'UnitPrice',
                    name: 'UnitPrice',
                    anonymous: false,
                    exported: true,
                    typ: $Int,
                    tag: 'js:"UnitPrice"',
                },
                {
                    prop: 'Quantity',
                    name: 'Quantity',
                    anonymous: false,
                    exported: true,
                    typ: $Int,
                    tag: 'js:"Quantity"',
                },
                {
                    prop: 'FeeType',
                    name: 'FeeType',
                    anonymous: false,
                    exported: true,
                    typ: G,
                    tag: 'js:"FeeType"',
                },
                {
                    prop: 'AffectedSkus',
                    name: 'AffectedSkus',
                    anonymous: false,
                    exported: true,
                    typ: BK,
                    tag: 'js:"AffectedSkus"',
                },
                {
                    prop: 'DisplayAs',
                    name: 'DisplayAs',
                    anonymous: false,
                    exported: true,
                    typ: $String,
                    tag: 'js:"DisplayAs"',
                },
            ]);
            $init = function () {
                $pkg.$init = function () {};
                var $f,
                    $c = false,
                    $s = 0,
                    $r;
                if (this !== undefined && this.$blk !== undefined) {
                    $f = this;
                    $c = true;
                    $s = $f.$s;
                    $r = $f.$r;
                }
                s: while (true) {
                    switch ($s) {
                        case 0:
                            $r = A.$init();
                            $s = 1;
                        case 1:
                            if ($c) {
                                $c = false;
                                $r = $r.$blk();
                            }
                            if ($r && $r.$blk !== undefined) {
                                break s;
                            }
                            $r = B.$init();
                            $s = 2;
                        case 2:
                            if ($c) {
                                $c = false;
                                $r = $r.$blk();
                            }
                            if ($r && $r.$blk !== undefined) {
                                break s;
                            }
                            $pkg.IssuanceTypes = new M.ptr(0, 1);
                            $pkg.ItemTypes = new N.ptr(0, 1, 2);
                            $pkg.FeeTypes = new O.ptr(0, 1, 2, 3, 4, 5, 6, 999, 1000);
                            $pkg.FeeCalculationModels = new P.ptr(0, 1, 2, 3, 7, 9);
                            $pkg.FeeDisplayModels = new Q.ptr(0, 1);
                            $pkg.LineItemGenerationModels = new S.ptr(0, 1, 2);
                            W = function (a, b, c, d, e) {
                                var a, b, c, d, e;
                                return [new BJ([BA(d)]), new BK([])];
                            };
                            X = function (a, b, c, d, e) {
                                var a, b, c, d, e, f;
                                f = BA(d);
                                return [new BJ([f]), new BK([])];
                            };
                            AA = function (a, b, c, d, e) {
                                var a, b, c, d, e, f;
                                f = BB();
                                f.Raw.Sku = $externalize(
                                    $internalize(d.Raw.sku, $String),
                                    $String
                                );
                                f.Raw.Description = $externalize(
                                    $internalize(d.Raw.description, $String),
                                    $String
                                );
                                f.Raw.UnitPrice = AT($parseInt(d.Raw.amount) >> 0);
                                f.Raw.Quantity = $clone(a, AJ).getGroupSize();
                                f.Raw.FeeType = $parseInt(d.Raw.type) >> 0;
                                return [new BJ([f]), new BK([])];
                            };
                            Y = function $b(a, b, c, d, e) {
                                var a, b, c, d, e, f, g, h, i, j, k, $s, $r;
                                $s = 0;
                                var $f,
                                    $c = false;
                                if (this !== undefined && this.$blk !== undefined) {
                                    $f = this;
                                    $c = true;
                                    a = $f.a;
                                    b = $f.b;
                                    c = $f.c;
                                    d = $f.d;
                                    e = $f.e;
                                    f = $f.f;
                                    g = $f.g;
                                    h = $f.h;
                                    i = $f.i;
                                    j = $f.j;
                                    k = $f.k;
                                    $s = $f.$s;
                                    $r = $f.$r;
                                }
                                s: while (true) {
                                    switch ($s) {
                                        case 0:
                                            g = AX(
                                                $internalize(a.Raw.start_date, $String),
                                                $internalize(a.Raw.end_date, $String),
                                                'The group'
                                            );
                                            $s = 1;
                                        case 1:
                                            if ($c) {
                                                $c = false;
                                                g = g.$blk();
                                            }
                                            if (g && g.$blk !== undefined) {
                                                break s;
                                            }
                                            f = g;
                                            h = f[0];
                                            i = f[1];
                                            if (!h) {
                                                $s = -1;
                                                return [new BJ([]), new BK([i])];
                                            }
                                            j = BB();
                                            j.Raw.Sku = $externalize(
                                                $internalize(d.Raw.sku, $String),
                                                $String
                                            );
                                            j.Raw.Description = $externalize(
                                                $internalize(d.Raw.description, $String),
                                                $String
                                            );
                                            j.Raw.UnitPrice = AT(
                                                $parseInt(d.Raw.amount) >> 0
                                            );
                                            k = AW(
                                                $internalize(a.Raw.start_date, $String),
                                                $internalize(a.Raw.end_date, $String)
                                            );
                                            $s = 2;
                                        case 2:
                                            if ($c) {
                                                $c = false;
                                                k = k.$blk();
                                            }
                                            if (k && k.$blk !== undefined) {
                                                break s;
                                            }
                                            j.Raw.Quantity = k;
                                            j.Raw.FeeType = $parseInt(d.Raw.type) >> 0;
                                            $s = -1;
                                            return [new BJ([j]), new BK([])];
                                    }
                                    return;
                                }
                                if ($f === undefined) {
                                    $f = { $blk: $b };
                                }
                                $f.a = a;
                                $f.b = b;
                                $f.c = c;
                                $f.d = d;
                                $f.e = e;
                                $f.f = f;
                                $f.g = g;
                                $f.h = h;
                                $f.i = i;
                                $f.j = j;
                                $f.k = k;
                                $f.$s = $s;
                                $f.$r = $r;
                                return $f;
                            };
                            Z = function $b(a, b, c, d, e) {
                                var a, b, c, d, e, f, g, h, i, j, k, $s, $r;
                                $s = 0;
                                var $f,
                                    $c = false;
                                if (this !== undefined && this.$blk !== undefined) {
                                    $f = this;
                                    $c = true;
                                    a = $f.a;
                                    b = $f.b;
                                    c = $f.c;
                                    d = $f.d;
                                    e = $f.e;
                                    f = $f.f;
                                    g = $f.g;
                                    h = $f.h;
                                    i = $f.i;
                                    j = $f.j;
                                    k = $f.k;
                                    $s = $f.$s;
                                    $r = $f.$r;
                                }
                                s: while (true) {
                                    switch ($s) {
                                        case 0:
                                            g = AX(
                                                $internalize(a.Raw.start_date, $String),
                                                $internalize(a.Raw.end_date, $String),
                                                'The group'
                                            );
                                            $s = 1;
                                        case 1:
                                            if ($c) {
                                                $c = false;
                                                g = g.$blk();
                                            }
                                            if (g && g.$blk !== undefined) {
                                                break s;
                                            }
                                            f = g;
                                            h = f[0];
                                            i = f[1];
                                            if (!h) {
                                                $s = -1;
                                                return [new BJ([]), new BK([i])];
                                            }
                                            j = BB();
                                            j.Raw.Sku = $externalize(
                                                $internalize(d.Raw.sku, $String),
                                                $String
                                            );
                                            j.Raw.Description = $externalize(
                                                $internalize(d.Raw.description, $String),
                                                $String
                                            );
                                            j.Raw.UnitPrice = AT(
                                                $parseInt(d.Raw.amount) >> 0
                                            );
                                            k = AV(
                                                $internalize(a.Raw.start_date, $String),
                                                $internalize(a.Raw.end_date, $String)
                                            );
                                            $s = 2;
                                        case 2:
                                            if ($c) {
                                                $c = false;
                                                k = k.$blk();
                                            }
                                            if (k && k.$blk !== undefined) {
                                                break s;
                                            }
                                            j.Raw.Quantity = k;
                                            j.Raw.FeeType = $parseInt(d.Raw.type) >> 0;
                                            $s = -1;
                                            return [new BJ([j]), new BK([])];
                                    }
                                    return;
                                }
                                if ($f === undefined) {
                                    $f = { $blk: $b };
                                }
                                $f.a = a;
                                $f.b = b;
                                $f.c = c;
                                $f.d = d;
                                $f.e = e;
                                $f.f = f;
                                $f.g = g;
                                $f.h = h;
                                $f.i = i;
                                $f.j = j;
                                $f.k = k;
                                $f.$s = $s;
                                $f.$r = $r;
                                return $f;
                            };
                            AB = function $b(a, b, c, d, e) {
                                var a, b, c, d, e, f, g, $s, $r;
                                $s = 0;
                                var $f,
                                    $c = false;
                                if (this !== undefined && this.$blk !== undefined) {
                                    $f = this;
                                    $c = true;
                                    a = $f.a;
                                    b = $f.b;
                                    c = $f.c;
                                    d = $f.d;
                                    e = $f.e;
                                    f = $f.f;
                                    g = $f.g;
                                    $s = $f.$s;
                                    $r = $f.$r;
                                }
                                s: while (true) {
                                    switch ($s) {
                                        case 0:
                                            f = AY(a, b, c);
                                            $s = 3;
                                        case 3:
                                            if ($c) {
                                                $c = false;
                                                f = f.$blk();
                                            }
                                            if (f && f.$blk !== undefined) {
                                                break s;
                                            }
                                            if (f) {
                                                $s = 1;
                                                continue;
                                            }
                                            $s = 2;
                                            continue;
                                        case 1:
                                            g = AA(a, b, c, d, e);
                                            $s = 4;
                                        case 4:
                                            if ($c) {
                                                $c = false;
                                                g = g.$blk();
                                            }
                                            if (g && g.$blk !== undefined) {
                                                break s;
                                            }
                                            $s = -1;
                                            return g;
                                        case 2:
                                            $s = -1;
                                            return [new BJ([]), new BK([])];
                                    }
                                    return;
                                }
                                if ($f === undefined) {
                                    $f = { $blk: $b };
                                }
                                $f.a = a;
                                $f.b = b;
                                $f.c = c;
                                $f.d = d;
                                $f.e = e;
                                $f.f = f;
                                $f.g = g;
                                $f.$s = $s;
                                $f.$r = $r;
                                return $f;
                            };
                            AC = function $b(a, b, c, d, e) {
                                var a, b, c, d, e, f, g, h, i, j, k, $s, $r;
                                $s = 0;
                                var $f,
                                    $c = false;
                                if (this !== undefined && this.$blk !== undefined) {
                                    $f = this;
                                    $c = true;
                                    a = $f.a;
                                    b = $f.b;
                                    c = $f.c;
                                    d = $f.d;
                                    e = $f.e;
                                    f = $f.f;
                                    g = $f.g;
                                    h = $f.h;
                                    i = $f.i;
                                    j = $f.j;
                                    k = $f.k;
                                    $s = $f.$s;
                                    $r = $f.$r;
                                }
                                s: while (true) {
                                    switch ($s) {
                                        case 0:
                                            g = AX(
                                                $internalize(a.Raw.start_date, $String),
                                                $internalize(a.Raw.end_date, $String),
                                                'Group members'
                                            );
                                            $s = 1;
                                        case 1:
                                            if ($c) {
                                                $c = false;
                                                g = g.$blk();
                                            }
                                            if (g && g.$blk !== undefined) {
                                                break s;
                                            }
                                            f = g;
                                            h = f[0];
                                            i = f[1];
                                            if (!h) {
                                                $s = -1;
                                                return [new BJ([]), new BK([i])];
                                            }
                                            j = BB();
                                            j.Raw.Sku = $externalize(
                                                $internalize(d.Raw.sku, $String),
                                                $String
                                            );
                                            j.Raw.Description = $externalize(
                                                $internalize(d.Raw.description, $String),
                                                $String
                                            );
                                            j.Raw.UnitPrice = $imul(
                                                AT($parseInt(d.Raw.amount) >> 0),
                                                $clone(a, AJ).getGroupSize()
                                            );
                                            k = AV(
                                                $internalize(a.Raw.start_date, $String),
                                                $internalize(a.Raw.end_date, $String)
                                            );
                                            $s = 2;
                                        case 2:
                                            if ($c) {
                                                $c = false;
                                                k = k.$blk();
                                            }
                                            if (k && k.$blk !== undefined) {
                                                break s;
                                            }
                                            j.Raw.Quantity = k;
                                            j.Raw.FeeType = $parseInt(d.Raw.type) >> 0;
                                            $s = -1;
                                            return [new BJ([j]), new BK([])];
                                    }
                                    return;
                                }
                                if ($f === undefined) {
                                    $f = { $blk: $b };
                                }
                                $f.a = a;
                                $f.b = b;
                                $f.c = c;
                                $f.d = d;
                                $f.e = e;
                                $f.f = f;
                                $f.g = g;
                                $f.h = h;
                                $f.i = i;
                                $f.j = j;
                                $f.k = k;
                                $f.$s = $s;
                                $f.$r = $r;
                                return $f;
                            };
                            $pkg.DefaultUseFeeCalculationMap = $makeMap(H.keyFor, [
                                { k: $pkg.FeeCalculationModels.NoUseFee, v: W },
                                { k: $pkg.FeeCalculationModels.FlatUseFee, v: X },
                                { k: $pkg.FeeCalculationModels.PerGroupPerNight, v: Y },
                                { k: $pkg.FeeCalculationModels.PerGroupPerDay, v: Z },
                                { k: $pkg.FeeCalculationModels.PerMember, v: AA },
                                {
                                    k: $pkg.FeeCalculationModels.PerGroupSizePerDay,
                                    v: AC,
                                },
                            ]);
                    }
                    return;
                }
                if ($f === undefined) {
                    $f = { $blk: $init };
                }
                $f.$s = $s;
                $f.$r = $r;
                return $f;
            };
            $pkg.$init = $init;
            return $pkg;
        })();
    $packages['github.com/FootprintRecreation/VehiclePermitService/fees'] = (function () {
        var $pkg = {},
            $init,
            A,
            B,
            E,
            F,
            G,
            H,
            I,
            J,
            K,
            L,
            M,
            N,
            O,
            P,
            C,
            D;
        A =
            $packages[
                'github.com/FootprintRecreation/VehiclePermitService/fees/fees_temp'
            ];
        B = $packages['github.com/gopherjs/gopherjs/js'];
        E = $sliceType($String);
        F = $ptrType(A.Individual);
        G = $sliceType(F);
        H = $ptrType(A.FeeOverride);
        I = $sliceType(H);
        J = $ptrType(A.Fee);
        K = $sliceType(J);
        L = $ptrType(A.Rule);
        M = $sliceType(L);
        N = $ptrType(A.LineItem);
        O = $sliceType(N);
        P = $funcType([$String, $String, $String], [O, E], false);
        C = function (a) {
            var a;
            return $global.JSON.parse($externalize(a, $String));
        };
        D = function () {
            $global.GenerateLineItems = $externalize(function $b(a, b, c) {
                var a, b, c, d, e, f, g, h, $s, $r;
                $s = 0;
                var $f,
                    $c = false;
                if (this !== undefined && this.$blk !== undefined) {
                    $f = this;
                    $c = true;
                    a = $f.a;
                    b = $f.b;
                    c = $f.c;
                    d = $f.d;
                    e = $f.e;
                    f = $f.f;
                    g = $f.g;
                    h = $f.h;
                    $s = $f.$s;
                    $r = $f.$r;
                }
                s: while (true) {
                    switch ($s) {
                        case 0:
                            d = new E([]);
                            e = new A.Issuance.ptr(
                                C(a),
                                '',
                                G.nil,
                                '',
                                '',
                                '',
                                '',
                                0,
                                0,
                                0,
                                I.nil
                            );
                            if (e.Raw === null) {
                                d = $append(
                                    d,
                                    'GenerateLineItems received a null issuance'
                                );
                            }
                            f = new A.Division.ptr(C(b), '', '', 0, 0, K.nil, K.nil);
                            if (f.Raw === null) {
                                d = $append(
                                    d,
                                    'GenerateLineItems received a null division'
                                );
                            }
                            g = new A.Permit.ptr(C(c), '', '', M.nil, false);
                            if (g.Raw === null) {
                                d = $append(
                                    d,
                                    'GenerateLineItems received a null permit'
                                );
                            }
                            if (d.$length > 0) {
                                $s = -1;
                                return [new O([]), d];
                            }
                            h = A.GenerateLineItems(
                                e,
                                f,
                                g,
                                A.LineItemGenerationModels.Regular
                            );
                            $s = 1;
                        case 1:
                            if ($c) {
                                $c = false;
                                h = h.$blk();
                            }
                            if (h && h.$blk !== undefined) {
                                break s;
                            }
                            $s = -1;
                            return h;
                    }
                    return;
                }
                if ($f === undefined) {
                    $f = { $blk: $b };
                }
                $f.a = a;
                $f.b = b;
                $f.c = c;
                $f.d = d;
                $f.e = e;
                $f.f = f;
                $f.g = g;
                $f.h = h;
                $f.$s = $s;
                $f.$r = $r;
                return $f;
            }, P);
        };
        $init = function () {
            $pkg.$init = function () {};
            var $f,
                $c = false,
                $s = 0,
                $r;
            if (this !== undefined && this.$blk !== undefined) {
                $f = this;
                $c = true;
                $s = $f.$s;
                $r = $f.$r;
            }
            s: while (true) {
                switch ($s) {
                    case 0:
                        $r = A.$init();
                        $s = 1;
                    case 1:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                        $r = B.$init();
                        $s = 2;
                    case 2:
                        if ($c) {
                            $c = false;
                            $r = $r.$blk();
                        }
                        if ($r && $r.$blk !== undefined) {
                            break s;
                        }
                        if ($pkg === $mainPkg) {
                            D();
                            $mainFinished = true;
                        }
                }
                return;
            }
            if ($f === undefined) {
                $f = { $blk: $init };
            }
            $f.$s = $s;
            $f.$r = $r;
            return $f;
        };
        $pkg.$init = $init;
        return $pkg;
    })();
    $synthesizeMethods();
    var $mainPkg = $packages['github.com/FootprintRecreation/VehiclePermitService/fees'];
    $packages['runtime'].$init();
    $go($mainPkg.$init, []);
    $flushConsole();
}).call(this);
//# sourceMappingURL=fees.js.map
